<template>
  <div>
    <div v-if="!loading && !results">
      <header>
        <div>
          <h1>Predict bioactivity, pIC<sub>50</sub></h1>
        </div>
      </header>
      <section class="container-md my-40">
        <div>
          <div>
            This submission allows users to submit compounds by SDF format,
            <span class="colored"
              >not to exceed more than 150 molecules and 60 atoms per
              molecule</span
            >. Note that the ID of the result is equivalent to the order of ID
            from the SDF input file. For information, visit the
            <span
              style="text-decoration: underline; color: #582E91; cursor: pointer;"
              @click="goToHelp"
              >Help page</span
            >.
          </div>
        </div>
        <div class="my-20">
          <h4>Please, paste your compound(s) in SDF format</h4>
        </div>
        <div class="text-light" style="margin-bottom: 10px">
          Examples: Bioactive compounds against EGFR from ZINC 15 database
        </div>
        <div class="compounds">
          <button class="btn btn-primary" @click="set5Compounds">
            5 compounds
          </button>
          <button class="btn btn-primary" @click="set10Compounds">
            10 compounds
          </button>
          <button class="btn btn-primary" @click="set25Compounds">
            25 compounds
          </button>
          <button class="btn btn-primary" @click="set50Compounds">
            50 compounds
          </button>
        </div>
        <div class="article-cols my-40 input-container">
          <div>
            <textarea
              rows="10"
              placeholder="Input your compound(s) here"
              v-model="textarea"
            ></textarea>
            <hr />
            <div>
              <v-file-input
                v-model="file"
                :rules="rules"
                name="sdf_file"
                label="File input"
                prepend-icon="mdi-paperclip"
                placeholder="Click to upload sdf file"
                show-size
                small-chips
                accept=".sdf"
              ></v-file-input>
            </div>
            <hr />
            <div class="btn-compounds-group">
              <button class="btn btn-primary" @click="goToProcessing">
                Submit
              </button>
              <button class="btn btn-gray" @click="resetToDefault">
                Reset
              </button>
            </div>
          </div>
          <div class="molecule-img hidden-sm-and-down">
            <v-img src="../assets/images/molecule_line.webp" class="img" />
          </div>
        </div>
        <div>
          Reference: Sterling, T., &amp; Irwin, J. J. (2015). ZINC 15–ligand
          discovery for everyone.&nbsp;<i
            >Journal of chemical information and modeling,&nbsp;55</i
          >(11), 2324-2337.
        </div>
      </section>
    </div>
    <Processing v-if="loading" :processing="this.processing"></Processing>
    <Results v-if="!loading && results" :results="results"></Results>
  </div>
</template>

<script>
import axios from "axios";
import Processing from "@/components/Processing.vue";
import Results from "@/components/Results.vue";

export default {
  name: "predictor",
  components: {
    Processing,
    Results
  },
  props: {
    processing: Function,
    end_process: Function,
    setActive: Function
  },
  data() {
    return {
      textarea: null,
      loading: false,
      results: null,
      file: null,
      rules: [
        value =>
          !value ||
          value.name.split(".")[1] == "sdf" ||
          value.name.split(".")[1] == "SDF" ||
          "File type should be a SDF!"
      ]
    };

    // results: {
    //     data: [
    //       {
    //         id: 0,
    //         origin_id: "134817166",
    //         others: {
    //           chemical_formula: "C31H38FN9O",
    //           hba: 10,
    //           hbd: 3,
    //           id: 0,
    //           logp: 4.785,
    //           mw: 571.705,
    //           ranked: 7,
    //           rotable_bond: 8,
    //           smile:
    //             "CN(C)C1CCN(c2ccc(Nc3cc4c(N5CCC(CO)CC5)nc(Nc5ccc(F)cc5)nc4cn3)nc2)CC1"
    //         },
    //         picture:
    //           "<img src=data:image/png;base64,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 alt=Mol/>",
    //         predicted: 6.434,
    //         predicted_nm: 368.336,
    //         ranked: 7,
    //         smile:
    //           "CN(C)C1CCN(c2ccc(Nc3cc4c(N5CCC(CO)CC5)nc(Nc5ccc(F)cc5)nc4cn3)nc2)CC1"
    //       },
    //       {
    //         id: 1,
    //         origin_id: "78357783",
    //         others: {
    //           chemical_formula: "C27H30ClN7O2",
    //           hba: 7,
    //           hbd: 3,
    //           id: 1,
    //           logp: 5.153,
    //           mw: 520.037,
    //           ranked: 2,
    //           rotable_bond: 10,
    //           smile:
    //             "C=CC(=O)Nc1cc(Nc2ncc(Cl)c(-c3c[nH]c4ccccc34)n2)c(OC)cc1N(C)CCN(C)C"
    //         },
    //         picture:
    //           "<img src=data:image/png;base64,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 alt=Mol/>",
    //         predicted: 8.517,
    //         predicted_nm: 3.044,
    //         ranked: 2,
    //         smile:
    //           "C=CC(=O)Nc1cc(Nc2ncc(Cl)c(-c3c[nH]c4ccccc34)n2)c(OC)cc1N(C)CCN(C)C"
    //       },
    //       {
    //         id: 2,
    //         origin_id: "9549299",
    //         others: {
    //           chemical_formula: "C21H18F3N5O",
    //           hba: 5,
    //           hbd: 3,
    //           id: 2,
    //           logp: 5.331,
    //           mw: 413.403,
    //           ranked: 5,
    //           rotable_bond: 6,
    //           smile: "O=C(Nc1cccc(Nc2cc(Nc3cccc(C(F)(F)F)c3)ncn2)c1)C1CC1"
    //         },
    //         picture:
    //           "<img src=data:image/png;base64,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 alt=Mol/>",
    //         predicted: 6.932,
    //         predicted_nm: 116.967,
    //         ranked: 5,
    //         smile: "O=C(Nc1cccc(Nc2cc(Nc3cccc(C(F)(F)F)c3)ncn2)c1)C1CC1"
    //       },
    //       {
    //         id: 3,
    //         origin_id: "11566580",
    //         others: {
    //           chemical_formula: "C17H11ClFN5O",
    //           hba: 5,
    //           hbd: 2,
    //           id: 3,
    //           logp: 3.523,
    //           mw: 355.76,
    //           ranked: 1,
    //           rotable_bond: 3,
    //           smile: "CC#CC(=O)Nc1cc2c(Nc3ccc(F)c(Cl)c3)ncnc2cn1"
    //         },
    //         picture:
    //           "<img src=data:image/png;base64,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 alt=Mol/>",
    //         predicted: 9.086,
    //         predicted_nm: 0.821,
    //         ranked: 1,
    //         smile: "CC#CC(=O)Nc1cc2c(Nc3ccc(F)c(Cl)c3)ncnc2cn1"
    //       },
    //       {
    //         id: 4,
    //         origin_id: "9843206",
    //         others: {
    //           chemical_formula: "C23H21N3O3",
    //           hba: 6,
    //           hbd: 1,
    //           id: 4,
    //           logp: 4.97,
    //           mw: 387.439,
    //           ranked: 4,
    //           rotable_bond: 7,
    //           smile: "COc1cc2ncnc(Nc3ccc(OCc4ccccc4)cc3)c2cc1OC"
    //         },
    //         picture:
    //           "<img src=data:image/png;base64,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 alt=Mol/>",
    //         predicted: 7.362,
    //         predicted_nm: 43.421,
    //         ranked: 4,
    //         smile: "COc1cc2ncnc(Nc3ccc(OCc4ccccc4)cc3)c2cc1OC"
    //       },
    //       {
    //         id: 5,
    //         origin_id: "16760413",
    //         others: {
    //           chemical_formula: "C18H25Cl3FN7O2",
    //           hba: 7,
    //           hbd: 2,
    //           id: 5,
    //           logp: 2.656,
    //           mw: 496.802,
    //           ranked: 3,
    //           rotable_bond: 4,
    //           smile: "CN1CCC(Nc2ncc3ncnc(Nc4ccc(F)c(Cl)c4)c3n2)CC1.Cl.Cl.O.O"
    //         },
    //         picture:
    //           "<img src=data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAIAAAAiOjnJAAAABmJLR0QA/wD/AP+gvaeTAAAfUElEQVR4nO2deVxU5f7HPzMgAiKbGEqi4pIFaLnhgjc1zS0QK0lM0VLJell0b7nkrcSr1y7XWzZ28ZbrFZfqB7mN20UyN67cUhZFzUR2SBRkGYZhmeF8f388NE2kbHPOmWHmvF+8fDnH4fl+kc88z3Oe811kRAQJCb6Rm9oBCctEEpaEIEjCkhAESVgSgiAJS0IQJGFJCILlC6uioaKGqwGgJW2prpRdvFZzrZqrBnBfd19HOlP6Z6FYvrBiSmLOqs8CuFV3688//7lQWzgra9besr1hOWHKSuW64nUF2gJT+2iB2JraATGo5WqruWo2b31V9lWYe1iYW5iaU59SnTK1axaLVQgrpiTmYMXBioaKnp16pmnSXnR9EYCT3OkF1xfOqc+Z2jvLxPKXQgDLPZfv7bs3+tFoACGuIRerLwIoqC+IyI8wtWsWi1XMWDLI9H/OdJk5M2tmfHm8lrR/f/TvO+7vMLV3lonMOh9CqxpUzjbOpvbCkrFSYUkIjVXssSTERxKWhCBIwpIQBElYEoIgCUtCECRhSQiCpQurogI1NQCg1aK09NfrGg3+9z9kZ5vKL4vH0oUVE4OzZwHg1i38+c+NF3NyMGYMvvoKixZhxQrTOWfJWMEjndpaVFc3zluMPXvw3nuYOxcARoyARgNHR1N5Z6lYgbBiYnDwICoq0LNn45XLl7FoUePf/fyQkwM/P1N5Z6lY+lIIYPly7N2L6Ohfr0yciAsXAKCuDtnZ8PU1lWsWjBUISyb79c+kJLz/Pry9cfw4Zs2Cvz8iIhr/SYJXrOwhdFwcZs3CH/+If/0L5eXo0gV2dqb2yTKxgj2WIUOG4E9/wjvvAICbm6m9sWSsYCk05J134OGB5GRT+2H5WNlSKCEWVjZjSYiFJCwJQZCEJSEIkrAkBMHShSVFN5gISxeWFN1gIqzggFSKbjAFViAsKbrBFFj6UggpusE0WIGwpOgGU2Blj3Sk6AaxsII9liFSdINYWMFSaIgU3SAWVrYUSoiFlc1YEmIhCUtCECRhSQiCJCwJQZCEJSEIkrAkBEFUYX3//ffZUgiUdSCqsF555ZX+/funpaWJaVTCJIh3QKpWq11cXGxtbauqquykJ3SWjngzVlpaGsdxgwcPllRlDYgnrJSUFADDhw8XzaKECRFPWKmpqZCEZTWIPWMNGzZMNIsSJkSkzbtGo3F2dpbL5SqVyt7eXgSLEqZFpBkrLS2toaHB399fUpWVIFIE6a1b3ceM+TQgoFYccxImRyRhnTv3WHLyY+Hh4liTMD0iLYUpKQAg3RFaD2Js3jUauLgAgEoFBwehrUmYBWLMWFeuQKeDn5+kKitCDGGlpgKAdIBlVYghLGmDZYWIN2NJwrIqBN+819bC2RkcB5VKKhZkRQh+jqXTYf16FBdLqrIuhJ2xysthYwNnZ+h0qKiAh4dwpqyFazXXfDr7dJF3ua+772LjYisz0+obwu6xFApMnQoi5OZizRpBTVk+hdrCWVmz9pbtDcsJU1Yq1xWvK9AWmNqphyKI3jkOFy+ic2cAcHfHtm2YNEkIO9bFV2VfhbmHhbmFqTn1KdUpU7vTAjzPWNevY+1aDByIP/wBGzYAwIoV2L8fxcX82rFG0jRpAY4BAJzkTi+4vmBqd1qAH2GlpeG99+DjA39//OUvyM6Gjw+eegoAOnXCxo1YvhzV1Zg+HXl5vBi0RkJcQy5WXwRQUF8QkR9handagowgIyPj448PDBxIQOOXtze98w59/33jG6KiKCmJiGjZMurfnwDy8qK0NGNsWi+aBs3kW5Nn3p45PXP6Vc3VyILI7LpsUzv1UNojrJycHIVCwYKMu3Z1trev6daNwsMpMZEaGh76XeXlNGECAeTkRMeOtd9ja+b9ovcX5i68UXPD1I60TBuElZWV9dFHHz355JP62c7Dw2Pp0qXnzpXqdK0aoa6O5s8ngGxs6PPP2+mxNTPw2kCkIF2TbmpHWqZVwqqrqxs1apReT25ubosWLUpISNBqtW21x3EUFdW4bkZGEse13WVrpVJXKU+R26fZ13P1pvalZVolrLCwMC8vLwcHh9DQUKVSWVdXZ6TVL74gW1sCaMECqqtrszqtk7NVZ5GCgJsBpnakVbR8jqVSqeLi4mxtbUtLS7t27crLHcPSpejXD7NnIy9v4/TpCQcOHHB1deVlZAsmRZMCYJhDxwg/avm4gaXGP/nkk3ypivHsszh7VpWZufm77757+umnCwrM9xDZTGDCGu7YMaJEWhaWcKnxQ4c6//DDD0OGDMnIyBg1ahRLlZZ4GKmaVFiSsNjvW6AM5kcfffTs2bMTJky4c+fO+PHjT5w4IYQVC0DNqW/V3rKT2fk5dIx+UqacsRhubm4JCQnz5s1Tq9UhISFbt24VyFCHJr06nQM32GGwnayD1Oppfm9fVVUll8vt7Oxqa2sFvYngOG7VqlUAZDLZ5s2bBbXVEVEoFD2G9Fi9a7WpHWktLcxY+qJWnVmsgmDIZLLo6OgdO3bY29sXFxfrdDpBzXU4UlJSiq8W99X2NbUjraUFYYlce2jy5Mk1NTXbt2+3tTXT+DVT0eFq9bQgLJF/HmZuxIgR4pjrKGg0mp9++qlTp07+/v6m9qW1tEpYos1YUnG2B9IRa/U0JyzxPygdbsIXh45YZbM5YaWnp4v8QWGVujvW/6AICHqUKBDNCUvk+aOgoODu3bvdunXr06ePOBY7Ch1xxmru5kvaYJmW2traxMTEuLi4vLw8Gxsbfp/VCk1zwhL5Ny1tsBh1dXUJCQlxcXFKpbKqqgqAXC7nOG7ixIlHjx4dOXKkqR1sHQ87OdVoNLa2tra2thqNRpyz2hkzZgCIj48Xx5y5odPpLly4EBkZ2b17d/1vx9fXNyoqKiMjg/3ndOnS5ciRI6b2tFU8VFjJyckAhgwZIporPXr0AJCVlSWaRXOgoaGB6cnT07OJnm7duqV/m1arXbp0KQAbG5uYmBgTOtxKHiqsmJgYAK+++qo4fhQVFQFwc3PjrCNaWa+nnj17NtHTzZs3H/Zd0dHRMpkMQGRkZEMziStmwEOFtWjRIgCifTiUSiWASZMmiWPOhFy7di0qKqpfv356PfXt2zcyMjIlJeX3bxs0aFBmZqbh9d27d3fq1AnAiy++yPsuRa3TFdbWsi+tcZ/whworICAAwKFDh4wZvfVERUUBWLlypTjmxCc/P3/FihWGJyn9+vVbvXp1evpvUm5u3LgRFRX1xBNP6N+2adOmJkN9++23Li4uAMaMGVNSUsKjk/vv3o3MzPw4P//j/PyytmfKGPJQYZ06dcrGxsbLy+vKlSvGGGglwcHBAL7++msRbIlPZWVldHQ0E0qvXr0iIyMvXLhguOjn5uYqFIrAwEC9ntzd3cPDw5VK5QNToTIyMnr37g1gwIABhluxdtNAVK3T7b9793RZmfGjUTPCKisrGz9+PAAnJ6fjx4/zYqwZvLy8ADSZ9i2GxMREAH369Pnvf/9rqKf8/HymJ7ZzYrtMpqf6+hZyvIqKioYOHQqgR48ely5dardvWRrNZ4WF069c+Xte3v67dxf8+OO7t29vKiho94CM5gL96urqXn75ZQC2trZffPGFkZaaobi4GICLi4ul7tzZdPXWW2+xlxzHffrpp6NHj9brycXFZeHChcePH29RT4ZUVVVNnz6dHUMolco2uXSjunpzQUHQ1avDL19mX6/++KMYMxaD4zi2+wGwatUqgX7xx48fBzBx4kQhBjcHQkNDAezevVt/hZ1zOjg4BAUFxcbGVldXt29krVb72muvtf4Y4qfy8i2FhbMyMvR6eu7q1U8LCq6r1UQknrAYO3bsYJF3CxcubNNHqpWsW7cOwLvvvsv7yGZC//79AWRkZOivHD16ND4+nq/buhaPIbKzs6Ojo5944omgv/6V6WlSevqG3Ny0qiqB1ojW1m5ISEhgz6omTZpUUVHBrxMhISEAvvzyS36HNRPKy8tlMpmDg0M7KhK0ngceQ2RmZm7YsGHIkCH6e4IBfn7ReXmXVSqhD8HaUBQkPT390UcfBeDv75+Xl8eL+erq6ri4OGdnZwDNHAx2aE6fPg1g9OjRQhvSH0MMHz48KirK8CGvu7v74sWLT506pWtl/RajaVsZo5ycHHbE4uXllZqa2m6rtbW1SqUyPDyczYJyuXznzp1mfpTcbjZu3Ahg2bJlIthKT0/v2bOnwy+9ZVxcXNg9pvHlNtpKm+tjGR5DnDhxok3fW1dXd+zYsfDwcDZFAZDJZGPHjlUoFOXl5W31pKMQFhYGYNeuXeKY27JlCwBvb+/Dhw8LnbTXDO0pvFZbW6s/hti6dWuL79c/t3/kkUeaPBe7fft2OxzoWAwcOBBAkxN2fjHcva1cuRJAVFSUcOZaQztLRbbmGEL/nJWFLRjq6aeffjLO7Q5DZWWlXC63t7cX4m6aoVKpHBwcxo0bx15OmjQJQFuPtXjHqBqk+gTAJscQly9fjoyMZIfphnq6caMD1DjklzNnzgAICBCwqNXZs2cBjBw5kog4jnN3dwdQVFQknMXWYFRe6JIlS7y9vUNDQ2NjYwsLCzds2HDy5Ml9+/ZlZWWxN/Tp0yckJCQ0NHTcuHHGGOq4iBDebRjom5OTU1ZW5unpafipNgnGJhxPnTr122+/nTlz5unTp9l9NYC+ffu+9NJLc+bMkeKMRUiwMQzpZubMIeOXh0z2gICAuLi48ePHOzs7L168eM6cOQEBAfqnYFaOCDOWoQnzyRvgp0TCvXv3AIwbN27Tpk28DGgZqNXqzMxMOzs7Pz+hilqp1epbt27pTZhPohg/nSmkzK0HkpqaynHckCFD7OyEKmqVnp7OcZy/vz8rB2Q+Gb/8CMt8ZmCzQoTPm+EUlZeXV1pa6uHh0atXL+EsthK+eumYywfFrBDh82aoXbOq1cODsPLy8kpKSjw8PLy9vY0fzZL4/Y7nxx9/JF47jxpq13w2WOBFWGb1QTEffvjhhya1elJSUgICAubMmVNbW8uLCX05oMGDB8PMdro8CMusfh6Tk5ubu3nz5hEjRowaNapbt24Adu7cyf7p/v37AOLj42fMmFFRUWG8rfT0dJ1O5+fnx8oBmVdRGuMP75cs+aJbt8e/+eYb44fquGRnZ//tb397ivVoBAB4eHiwFDoAq1evZo9Tr169ynbWvr6+ubm5Rhr97LPPACxevJiI8vPzAXTr1o2HH4YPeBCWpycBlJNjmdFUzZOfT598QqNG0WOPNUZpurq6vvrqqydPnmQRB//+979ZYOfs2bNramqIqLCwkHVQ69mz5+XLl42x/sorrwDYsmULER06dAjAlClTePm5Hki5rlzToCGieq6+RNuYz5ihyVA3qImoVFuq5X4NsjBWWPn5BJDZfE5E4s4d+uwzGjeO5PLGTmZTpyrmzZunVCp/HwKVmJjIAjvHjh3L8ktVKtXUqVMBODk5HTOid+O2bdtmzpzJIi4//PBDNjUa83M1z/o7609UniCiazXXIvIiCuoLQm6HrCxcGXQ76EjFkSaNOY0V1uHDBNCzzxo5jHlRVkaVlUREWi2VlFB5ObEg8vp6OnOGJk4kG5tGPTk60ksv0YED1HxWxNWrV9kts34FrKurmz9/PgAbG5vP+ejdKEKtnvV31h8sP6huUF+qvhSRF7GxeONXZV8RUVVD1YHyAzwL68MPCaD33jNyGPNizRoaPZo4jjIz6Y03aP16YqGy167R3Lkkk1HnzhQURLGxpFK1dsyioiK2A+vRowdbAQ1j2iIjI41MrWNBb9nZAjbzXX9n/TO3npmfMz/odlBEXsTc7LlZtb+WBmoiLGPvClljJcu7I3R3x7Ztv76srUV1NWpq4OQEpRL37uHoUSxYgNYX2fPy8jp//vy0adOKi4vHjx9/7NgxmUy2du3anTt3durU6bPPPjPmGCI9Pb24uNjNza1v377tG6GVLPdcvrfv3uhHo9FS83N+hGUmd7g8smIF9u9HcXHjy5gYvP46/vIXAAgKwi8h+22ja9euR44cCQ8Pr66unjVr1ueffw5g0aJFx48fd3Z2jo+Pf+6559p0DFFWVrZnz57g4OCRI0cOGjTo9ddfFzqoRAaZ/s+ZLjNj78eGZIUszV8a2T2y6VuNmRuLigggNzdL68C7Zg0lJVFyMo0a1XQpjIgwdvAmKyDLTbp8+TIrlLVmzZoWRygrK9u5c+eUKVP0/Tvs7e3DwsJMUqCgUlf5wOtGCUupJIAsr6ZVVBQlJRERLVvWKKyTJ4mIrl/nQVgM/TFEaGgoO4bIzc194403mgmNZzmYQUFB+lgJGxubwMDArVu3VlY++LdrQowS1unTNG0abdjAlzNmxzPP0Jw5xFM1g6YkJiayNLixY8eWlpY+7G0ajYblYHbp0sVQTwqF4t69e4J4xgftyCt86K04rzXATE9ZGclk5OhIwiUP//4YQk9NTQ3Tk5OTE9OTXC5neiouLhbKIf5os7CauRXna5kwExITCaCxY4W10uQYQp8j7mxwgzB8+HCFQvHzzz8L6wqvtCc0md2KT5rU+FJ/K25hpKQAwp+keHl5nTlz5oUXXjhz5sy4cePs7OxUKhUAmUw2atSoOXPmhIaGmkPgXltpj7BWrMCaNdCHccfE4OBBVFTAoP6vJSDaEZ2rq+t//vOfxYsXV1RUHDt2zNfXNzQ0dN68eSyFuoPSHmF16oSNG/HHPzYeXy1fjunTcf06Nm/m2TnTwmYscY7o7Ozs9uzZo9Vq8/LyOrSe9LT5gJSdwI0eDX1gH7vyzTdITgbH8eibKamsRHY2HBxgUL9YWGQymZ2dnWWoCoCM+IiU/fln9O+P2lrMmYPYWAjcP1oMvvsOkyZh9GgkJ5valY4JP8kUXl44dgwuLvi//8PEiSgt5WXURsrLoVIBgE7H88jNkJbGwRIfVYkGP8ICMGkSkpLQuzeSkzFmDDIz+RoYCgWmTgURcnOxZg1vwzZPauqCPn0mBwZK81U74U1YAPz9kZyMoUNx+zbGjMHFizyMyaaoJrEGInDp0g95eaf9/BxFtWpB8CksAF5eOHsWkyfj/n3MnFlz8uTZ9o1TXo49exAcDC8vlJQ0jTUQGpVKlZWVZW9v7+vrK5JJi4NnYQFwdsaJE3j1VW7gwPDg4MmscmErqahAbCxmzICnJxYuxLFjkMtRXNx4wLF8OQCkpOD8ed69/g361Hj2nFiiHfAvLACdOmHXLvmsWSM5jnvzzTfffvttrtlzCLVaHRdXExKCHj3wyis4eRIApk/H7t0oLgYrJs0OOKqrERSEKVPw9ddCON6IlNDGA4I+MGq+B5rhc9bx41MBksspMJAUCrp798EDchytXEkAyWQkXJVNVmF1+/btQhmwAoQVFj2oB1pNTc3hw4fnzp1r+Nw+LGzDli0P1VMTFIrG9JjFi0mIovyDBg0CYEy9cQnBhUUGnQd8fHxefPFFpjMAMplszJgxCoWisLCwrWMePEgODgTQlCltyGhoDVVVVXK53M7OTvza6JaEGMIioqKiIl9fX72kWK3bdjSRKyykzZsb/56cTN27E0AjRxIvEUpsaQ4ODra3t+/Ro4ckLGMQSVhE9MknnwAYPnx4u2u763Q0dCgBtHRp4wp48yb160cAzZoVxwq5tIOamppDhw4ZLs0sVnPixIkW3NZAaMQT1pIlSwBs1k847eLQIXJ0bEyRZYGsd+/SggUXALi7u58/f771Q7G2Bq+99pp+HmVTaXR09OnTp3mssGCdiCcs1g40KSmJiIxpm/O//9EjjxBAQ4YQ6wNaU1PDGgJ27tx5//79zX97M20yDJdmHissWCciCauurs7Ozk4ul1dVVRHR888/7+vrm5yc3L7Rbt2i/v0JoGnTillTAp1O9+abb7Ibggd2+2hHmwy+KixYJyIJ69KlS+wXyV6ym0RjumTfu0fPP1/h7Ozt5uZ27tw5dlGhUMjlcgBLlizRt5e5du3aqlWrDAvq+/j4rFq16mFtMrRa7ZtvvilQhQXrQSRhffHFFwDCw8Pplw7Qzs7ORvaRq62tfemllwDY2dnt27ePXTxw4ABrqhYYGPjWW2+xVu+MAQMGvP/++1evXm1+2LVr17IVMCUlhYg4jlu9ejWAwMB5H3xgaam5wiGSsFjf4k8//ZR+6QA9YcIE44flOI41uzJcAZOTk93d3fVbcm9v78jIyAsXLrQyUVilUk2bNo3dGx49epRd3L37sKNjHUDh4SSdQrQGkYTFnruxuzbeO0B/8sknbAU8cuQIuxIZGQlg2LBhycnJ7Ug812q1ERERbAVkZc2I6NQpcnYmgJ55hqRTiBYRQ1j19TRx4o0//GGXSqUiYTpAx8fHR0RE6DX0/PPPA9Cvj+2A47gPPvgAgKdnz7VrK9jAV65Qr14EkJ8f8dS72GIRQ1ipqQTQ4483vnz66cqnn77+008C9j1jW6t2H5nq2bFjp59fCkDz5jWugIWF9OSTBFDPnpSSwoOrlooYwtq+nQB6+WUiopISAsjJiYRrAF1SUsLOCHhpMp2Y2LgCjh1LrMBCWRmNH08Ade1Kp04Zb8EyESQeqwmGKcWXLwPAsGGQC2aZ1Z0fOnSonA8bkycjKQne3rh4EU8/jbw8uLnh1CnMmwetFg0NJkj06BCIISzDlGIR8tZ5D9MbPBhJSfDzw40bWLUKAOzssHcvfvgByckmSPToEAguLJ0OGRmQycBKoItQAVCIDja9eyMpCRER+PzzxisyGQYPBkyR6NEhEFxY16+jpgYDBoCdK3XEGYvh6opt2+Dm1vS6yIkeHQV+GmE2g6GSiPD227hyBY89JpS58vLy3NxcR0dHFgUqAk0qWUgwBBeW4donk+FPfxLWHHsO89RTT9nY2AhrCQAgkyE3F2FhGDHCcupW8IKAwiovh40N3ngDTzwBgx4zwiJya7WXX8agQVi/HjdvimOwwyDgHoulxvv6YupU7N8vnJ3fIHIHLLbQP/64ONY6EsJu3sW/YxJ5xhKn6l9HRFhhiXzHVFlZmZ2dbW9v/7hYc4il9k8wHmGFZZgar9MJagow2LmLkxpPhLQ0QBLWgxBQWIa1/4gwdy4iIoSVl8ip8VlZqKiAl5elFV/lBQHvCteubfxLTAxSUzF2LOrqUFKCL7+EIx/VgXQ63blz5ybpqzeL0jXeEGmD1QxiPCsEMGwYzp5F9+44cgQTJuDu3fYPxXFcUlLS22+/3atXr8mTJzMxMUTeuUsbrOYQM5QiM5MGDiSAfHyorbFSDQ0N58+fX7Zsmaenp955f3//b7/9lr2hsrJSLpd37ty5mXY0/LJkya3+/WuVSmvsWdwiogqLiEpLaexYAsjdnX5JrmmBa9euRUVF9evXT6+nvn37RkZGNkn327VrF4Bhw4YJ4vfv4DjO3d0dQFGRgBGLHRexhUVEajUFBxNA9vZ0+PBD++8wPQ0YMECvp969e7O0CMO3ZWdnKxQKtq/y8fFxcXFJESWyMysrC4Cnp6cItjoiJhAWEel0tGwZDRiQ4eLi+vv80vr6+icMyqt7e3u/++6733//veF7bt++/dFHH7FkZUb37t1Zf9GuXbsmJCQI/SPExcUBeO6554Q21EExjbAYmzb9i3UEfeutt3S/bbE1ZcqUbt26hYeHJyYmGqbZ5OfnKxSKwMBAfStRV1fX8PBwpVJZX19fV1c3b948ALa2tkLnl7733nsAPvzwQ0GtdFxMKSwi+uabb1h+aUhISHV1tf763bt3DSPWS0pKtm7daqgnR0fH0NBQpVLZpNgQvx28DUlJSTHcTj377LMADh8+zNf4FoaJhUVEFy9e9PDwABAQEHD3tyX97t+/HxsbGxQUpO9R6+DgEBQUFBsbq1armxlz586d7FsWLFhgZJkrttVj0V3r1q3TX2c+F7CyJBK/w/TCIqLMzEzWQ8bHx+fmzZtlZWVMT/onM/b29kxPrKZIazh69CgrczV7dmRFRZtd+vFH+uijfxiW4+7Zs+c//vEP9q85OTkAPDw82jyu1WAWwiKiO3fujBgxAkCXLl30eurcufPMmTP37dunalc1yCtXrgwaNGLQII2/f2vzS3NzSaGgwECW7zUXgLu7O9vDaQ2qnW7fvh3AtGnT2uGVlWAuwiIitVodHBw8f/58Hnse5+ToHn+cAOrVi65ceejbOI4+/phGjiSg8cvNjVatSklISDDUk35ptrGxGTly5D//+U8j3bNgzEhYRMRxXHV1dTOdt9uBPr/Uyamxy/ADCQgggBwdKTSUlMrfVP64f//+9u3bJ0+erA93dnBw+OCDD3h00vIwL2EJRG0tvfwyAWRrS1u3Pvg9x4/TwYNUU/PrlYoK+vrrCzNmzDBcmoODg9u9NFsVViEsIuI4iopqXOZWrWquzJVGQ0olhYdTly40YsRxADwuzdaDtQiLsWUL2dgQQLt2NdbG1WqppISISKOh+HiaPbuxfDxANjY0dWr9tm3bWd8DiTbBT4fVDsTRozh0CL16ITERFy8iKwvr10Ong1IJtRoA5HIEBmLOHMyeDYNACom2IVI8lvkQHIxduyCT/Zro0bkzjhyBWg1fX0RFITMT589j2TJJVUYheMKq2bJiBdasgZ8fbG2xbx+GDkWfPqb2yYKwuhlLj2Gix6xZkqp4xkqFZZjoISEEVrd5lxAHK52xJIRGEpaEIEjCkhAESVgSgiAJS0IQJGFJCML/A9khJ4CG+2RKAAAAAElFTkSuQmCC alt=Mol/>",
    //         predicted: 8.237,
    //         predicted_nm: 5.797,
    //         ranked: 3,
    //         smile: "CN1CCC(Nc2ncc3ncnc(Nc4ccc(F)c(Cl)c4)c3n2)CC1.Cl.Cl.O.O"
    //       },
    //       {
    //         id: 6,
    //         origin_id: "78358313",
    //         others: {
    //           chemical_formula: "C25H31N7O",
    //           hba: 8,
    //           hbd: 2,
    //           id: 6,
    //           logp: 3.968,
    //           mw: 445.571,
    //           ranked: 8,
    //           rotable_bond: 8,
    //           smile: "COc1cc(N(C)CCN(C)C)c(N)cc1Nc1nccc(-c2cn(C)c3ccccc23)n1"
    //         },
    //         picture:
    //           "<img src=data:image/png;base64,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 alt=Mol/>",
    //         predicted: 6.195,
    //         predicted_nm: 638.022,
    //         ranked: 8,
    //         smile: "COc1cc(N(C)CCN(C)C)c(N)cc1Nc1nccc(-c2cn(C)c3ccccc23)n1"
    //       },
    //       {
    //         id: 7,
    //         origin_id: "121595975",
    //         others: {
    //           chemical_formula: "C26H33N9O3S",
    //           hba: 12,
    //           hbd: 2,
    //           id: 7,
    //           logp: 3.347,
    //           mw: 551.677,
    //           ranked: 9,
    //           rotable_bond: 9,
    //           smile:
    //             "CCC(C)n1nc(N2CC(C(C)(C)O)C2)c2cnc(Nc3ccnc(-c4cnn(S(=O)(=O)C5CC5)c4)n3)cc21"
    //         },
    //         picture:
    //           "<img src=data:image/png;base64,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 alt=Mol/>",
    //         predicted: 5.873,
    //         predicted_nm: 1340.554,
    //         ranked: 9,
    //         smile:
    //           "CCC(C)n1nc(N2CC(C(C)(C)O)C2)c2cnc(Nc3ccnc(-c4cnn(S(=O)(=O)C5CC5)c4)n3)cc21"
    //       },
    //       {
    //         id: 8,
    //         origin_id: "127264586",
    //         others: {
    //           chemical_formula: "C25H24ClN7O2",
    //           hba: 8,
    //           hbd: 1,
    //           id: 8,
    //           logp: 4.052,
    //           mw: 489.967,
    //           ranked: 6,
    //           rotable_bond: 6,
    //           smile:
    //             "C=CC(=O)N1CCCC(n2nc(-c3ccc(OCc4ccccn4)c(Cl)c3)c3c(N)ncnc32)C1"
    //         },
    //         picture:
    //           "<img src=data:image/png;base64,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 alt=Mol/>",
    //         predicted: 6.912,
    //         predicted_nm: 122.337,
    //         ranked: 6,
    //         smile:
    //           "C=CC(=O)N1CCCC(n2nc(-c3ccc(OCc4ccccn4)c(Cl)c3)c3c(N)ncnc32)C1"
    //       },
    //       {
    //         id: 9,
    //         origin_id: "134826780",
    //         others: {
    //           chemical_formula: "C31H45N6O17P",
    //           hba: 12,
    //           hbd: 12,
    //           id: 9,
    //           logp: -2.583,
    //           mw: 804.7,
    //           ranked: 10,
    //           rotable_bond: 24,
    //           smile:
    //             "CC(C)CC(NC(=O)C(Cc1ccc(OP(=O)(O)O)cc1)NC(=O)C(CCC(=O)O)NC(=O)C(CC(=O)O)NC(=O)C(C)NC(=O)C(N)CC(=O)O)C(=O)O"
    //         },
    //         picture:
    //           "<img src=data:image/png;base64,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 alt=Mol/>",
    //         predicted: 5.144,
    //         predicted_nm: 7174.277,
    //         ranked: 10,
    //         smile:
    //           "CC(C)CC(NC(=O)C(Cc1ccc(OP(=O)(O)O)cc1)NC(=O)C(CCC(=O)O)NC(=O)C(CC(=O)O)NC(=O)C(C)NC(=O)C(N)CC(=O)O)C(=O)O"
    //       }
    //     ],
    //     error: []
    //   }
  },
  methods: {
    goToHelp() {
      const path = "/help";
      if (this.$route.path !== path) this.$router.push(path);
      this.setActive("help");
    },
    async goToProcessing() {
      // textarea and file are empty?
      if (this.textarea != null || this.file != null) {
        // only textarea is not empty
        this.processing();
        // Go to top of the page
        document.documentElement.scrollTop = 0;

        if (this.textarea != null && this.file == null) {
          let bodyFormData = new FormData();
          bodyFormData.set("text", this.textarea);
          this.loading = true;
          const response = await axios
            .post(
              "https://ligegfr.manbaritone.dev/text-predictor",
              bodyFormData,
              {
                headers: {
                  "Content-Type": "multipart/form-data"
                }
              }
            )
            .catch(error => {
              if (error) {
                alert("Something went wrong, please submit again later");
                if (
                  error.response.data.message ==
                  "Error occurs while processing the machine learning model."
                ) {
                  alert(
                    "The file you provided is in a wrong format! (please check the example)"
                  );
                }
              }
              this.loading = false;
            });
          if (response) {
            this.results = response.data;
          }
          this.loading = false;
        } else {
          // only file is not empty || textarea and file are not empty
          let bodyFormData = new FormData();
          bodyFormData.set("sdf_file", this.file);
          this.loading = true;
          const response = await axios
            .post(
              "https://ligegfr.manbaritone.dev/file-predictor",
              bodyFormData,
              {
                headers: {
                  "Content-Type": "multipart/form-data"
                }
              }
            )
            .catch(error => {
              if (error) {
                alert("Something went wrong, please submit again later");
                if (
                  error.response.data.message ==
                  "Error occurs while processing the machine learning model."
                ) {
                  alert(
                    "The file you provided is in a wrong format! (please check the example)"
                  );
                }
              }
              this.loading = false;
            });
          if (response) {
            this.results = response.data;
          }
          this.loading = false;
        }
      } else {
        alert("Please provides us your data and submit it again");
      }
      this.end_process();
    },
    set5Compounds() {
      this.resetToDefault();
      this.textarea = `
 OpenBabel10312015333D

 22 25  0  0  0  0  0  0  0  0999 V2000
   -4.7445    1.7572    0.7582 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.2994    0.7076   -0.1517 N   0  0  0  0  0  0  0  0  0  0  0  0
   -4.9649    0.0619   -1.1129 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.2921   -1.0576   -1.4747 N   0  0  0  0  0  0  0  0  0  0  0  0
   -3.1821   -1.1246   -0.7037 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3093   -2.1397   -0.3319 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.1317   -1.7137    0.2647 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.1733   -2.5853    0.6387 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.9781   -2.1810    1.2171 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.3222   -0.9020    1.0426 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.4362    0.0765    0.7349 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.9219    1.2717    0.1153 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.3256    1.5588    0.1611 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.7939    2.4508    1.1161 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.0027    2.2263    1.7649 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.8559    1.2789    1.2660 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.5026    0.4741    0.1894 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.4644   -1.1620   -0.0930 Br  0  0  0  0  0  0  0  0  0  0  0  0
    3.2485    0.6771   -0.3676 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.8439   -0.3657    0.4384 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.8270    0.5711    0.2832 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0836    0.1196   -0.0922 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  9 10  2  0  0  0  0
 10 11  1  0  0  0  0
 11 12  1  0  0  0  0
 11 20  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 17 18  1  0  0  0  0
 17 19  2  0  0  0  0
 19 13  1  0  0  0  0
 20 21  1  0  0  0  0
 20  7  1  0  0  0  0
 21 22  2  0  0  0  0
 22  2  1  0  0  0  0
 22  5  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000003815030

>  <smiles>
Cn1cnc2cc3ncnc(Nc4cccc(Br)c4)c3cc21

$$$$

 OpenBabel10312015333D

 22 24  0  0  0  0  0  0  0  0999 V2000
   -5.1006   -0.2083   -1.4236 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.9407    0.5310   -0.2154 O   0  0  0  0  0  0  0  0  0  0  0  0
   -3.6504    0.5319    0.3228 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.8345    1.6412    0.1355 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.4589    1.5107    0.0166 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.7000    2.4346   -0.6209 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.4269    2.0953   -1.2918 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.9960    0.8837   -1.0801 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.4169    0.1039   -0.1376 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.1630   -0.9852    0.4167 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.5903   -0.9777    0.2911 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.1185   -1.9498   -0.5464 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.4463   -1.8757   -0.9353 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.1618   -0.6904   -0.8279 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.5160    0.3874   -0.2704 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.2348    2.1540   -0.3890 Br  0  0  0  0  0  0  0  0  0  0  0  0
    3.2994    0.2111    0.3771 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.8443    0.3115    0.3500 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.6481   -0.7546    0.6682 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0341   -0.6580    0.6906 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.8189   -1.8074    0.5544 O   0  0  0  0  0  0  0  0  0  0  0  0
   -3.3394   -2.8891   -0.2302 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  9 10  1  0  0  0  0
  9 18  2  0  0  0  0
 10 11  1  0  0  0  0
 11 12  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 15 16  1  0  0  0  0
 15 17  2  0  0  0  0
 17 11  1  0  0  0  0
 18 19  1  0  0  0  0
 18  5  1  0  0  0  0
 19 20  2  0  0  0  0
 20 21  1  0  0  0  0
 20  3  1  0  0  0  0
 21 22  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000000600292

>  <smiles>
COc1cc2ncnc(Nc3cccc(Br)c3)c2cc1OC

$$$$

 OpenBabel10312015333D

 22 25  0  0  0  0  0  0  0  0999 V2000
   -3.7381    1.6179    2.6126 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.3313    1.6756    1.2297 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.9777    2.8220    0.6165 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.6286    2.4522   -0.6335 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.4005    1.1180   -0.6776 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.4342    0.3832   -1.3548 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.1128   -0.8984   -0.9364 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.9698   -1.4856   -0.0162 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.9526   -0.7494    0.6346 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0498    0.6182    0.4439 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.5910   -2.6995    0.4485 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.5156   -3.3373   -0.0611 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.3606   -2.6866   -0.8590 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.1970   -1.3567   -1.0259 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.2630   -0.5046   -1.4564 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.3599   -0.2167   -0.5827 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.3885   -0.7589    0.6914 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.5688   -0.6259    1.4074 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.5246    0.2732    1.0151 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.2873    1.0968   -0.0752 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.4679    2.5307   -0.4553 Br  0  0  0  0  0  0  0  0  0  0  0  0
    3.2845    0.7319   -0.9657 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  8 11  1  0  0  0  0
  9 10  2  0  0  0  0
 10  2  1  0  0  0  0
 10  5  1  0  0  0  0
 11 12  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 14  7  1  0  0  0  0
 15 16  1  0  0  0  0
 16 17  2  0  0  0  0
 17 18  1  0  0  0  0
 18 19  2  0  0  0  0
 19 20  1  0  0  0  0
 20 21  1  0  0  0  0
 20 22  2  0  0  0  0
 22 16  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000002391775

>  <smiles>
Cn1cnc2cc3c(Nc4cccc(Br)c4)ncnc3cc21

$$$$

 OpenBabel10312015333D

 34 36  0  0  0  0  0  0  0  0999 V2000
    8.3527    3.0433    1.2856 C   0  0  0  0  0  0  0  0  0  0  0  0
    7.6887    2.2563    0.6391 C   0  0  0  0  0  0  0  0  0  0  0  0
    7.3961    0.9113    0.1120 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.1551    0.3908    0.6648 N   0  0  0  0  0  0  0  0  0  0  0  0
    5.6091   -0.5200   -0.3116 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.4989   -1.3062    0.3123 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.8993   -2.3021   -0.3046 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.4393   -2.4590   -0.2534 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.9429   -2.4291    0.9128 O   0  0  0  0  0  0  0  0  0  0  0  0
    1.5772   -2.0690   -1.3087 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.5263   -1.1074   -1.1417 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.5540   -1.3365   -0.2994 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.0522   -0.2841    0.4598 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.4684    0.9775    0.4353 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.3847    1.2629   -0.6231 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.7628    0.2234   -1.4657 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.7262    0.4580   -2.4247 O   0  0  0  0  0  0  0  0  0  0  0  0
    2.0658   -0.4960   -3.4015 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.0944   -0.4884   -4.5525 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.5855    1.7381    1.5237 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.3318    1.3479    2.5864 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.0563    0.1818    2.5760 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0120   -0.1512    3.5856 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.5046   -0.6520    4.5164 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.9702   -0.6238    1.4470 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0500   -1.4785    1.0488 N   0  0  0  0  0  0  0  0  0  0  0  0
   -4.1291   -0.8868    0.3153 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.1855   -0.2580    0.9292 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.6585    0.9755    0.4987 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.3529    1.3711   -0.7941 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.5871    2.6483   -1.1866 F   0  0  0  0  0  0  0  0  0  0  0  0
   -4.5433    0.5758   -1.5653 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.2710    0.9178   -3.2582 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -3.8070   -0.4317   -0.9575 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  3  0  0  0  0
  2  3  1  0  0  0  0
  3  4  1  0  0  0  0
  4  5  1  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  8 10  1  0  0  0  0
 10 11  1  0  0  0  0
 11 12  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 14 20  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 16 11  1  0  0  0  0
 17 18  1  0  0  0  0
 18 19  1  0  0  0  0
 20 21  2  0  0  0  0
 21 22  1  0  0  0  0
 22 23  1  0  0  0  0
 22 25  2  0  0  0  0
 23 24  3  0  0  0  0
 25 26  1  0  0  0  0
 25 13  1  0  0  0  0
 26 27  1  0  0  0  0
 27 28  2  0  0  0  0
 28 29  1  0  0  0  0
 29 30  2  0  0  0  0
 30 31  1  0  0  0  0
 30 32  1  0  0  0  0
 32 33  1  0  0  0  0
 32 34  2  0  0  0  0
 34 27  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000064564721

>  <smiles>
C#CCNC/C=C/C(=O)Nc1cc2c(Nc3ccc(F)c(Cl)c3)c(C#N)cnc2cc1OCC

$$$$

 OpenBabel10312015333D

 25 27  0  0  0  0  0  0  0  0999 V2000
    3.6989    3.8425    1.1264 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.7120    3.0818    0.7140 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.3986    2.0177   -0.2400 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.5317    2.1577   -1.4814 O   0  0  0  0  0  0  0  0  0  0  0  0
    3.7921    0.8318    0.2235 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.9118    0.0300   -0.5737 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.4100   -0.9350   -1.4416 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.7791   -2.1705   -1.5264 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.5412   -2.3948   -0.9568 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.1644   -3.6319   -0.5566 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.3202   -3.8265    0.4848 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.4893   -2.8205    0.8599 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.2530   -1.5993    0.3384 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.9822   -0.4970    0.8664 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.2460   -0.0932    0.3251 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3633    1.1515   -0.2804 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.5730    1.8152   -0.2756 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.8765    3.0604   -1.4826 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -4.6447    1.3480    0.4538 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.9899    2.4107    0.7594 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -4.5300    0.1501    1.1196 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.3711   -0.5978    0.9605 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.3951   -1.9238    1.2368 F   0  0  0  0  0  0  0  0  0  0  0  0
    0.8900   -1.3071   -0.3933 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.5642   -0.1000   -0.2604 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  2  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  3  5  1  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 12 13  2  0  0  0  0
 13 14  1  0  0  0  0
 13 24  1  0  0  0  0
 14 15  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 17 18  1  0  0  0  0
 17 19  2  0  0  0  0
 19 20  1  0  0  0  0
 19 21  1  0  0  0  0
 21 22  2  0  0  0  0
 22 23  1  0  0  0  0
 22 15  1  0  0  0  0
 24 25  2  0  0  0  0
 24  9  1  0  0  0  0
 25  6  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000013671593

>  <smiles>
C=CC(=O)Nc1ccc2ncnc(Nc3cc(Cl)c(Cl)cc3F)c2c1

$$$$
`;
    },
    set10Compounds() {
      this.resetToDefault();
      this.textarea = `
 OpenBabel10312015333D

 22 25  0  0  0  0  0  0  0  0999 V2000
   -4.7445    1.7572    0.7582 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.2994    0.7076   -0.1517 N   0  0  0  0  0  0  0  0  0  0  0  0
   -4.9649    0.0619   -1.1129 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.2921   -1.0576   -1.4747 N   0  0  0  0  0  0  0  0  0  0  0  0
   -3.1821   -1.1246   -0.7037 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3093   -2.1397   -0.3319 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.1317   -1.7137    0.2647 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.1733   -2.5853    0.6387 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.9781   -2.1810    1.2171 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.3222   -0.9020    1.0426 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.4362    0.0765    0.7349 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.9219    1.2717    0.1153 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.3256    1.5588    0.1611 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.7939    2.4508    1.1161 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.0027    2.2263    1.7649 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.8559    1.2789    1.2660 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.5026    0.4741    0.1894 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.4644   -1.1620   -0.0930 Br  0  0  0  0  0  0  0  0  0  0  0  0
    3.2485    0.6771   -0.3676 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.8439   -0.3657    0.4384 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.8270    0.5711    0.2832 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0836    0.1196   -0.0922 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  9 10  2  0  0  0  0
 10 11  1  0  0  0  0
 11 12  1  0  0  0  0
 11 20  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 17 18  1  0  0  0  0
 17 19  2  0  0  0  0
 19 13  1  0  0  0  0
 20 21  1  0  0  0  0
 20  7  1  0  0  0  0
 21 22  2  0  0  0  0
 22  2  1  0  0  0  0
 22  5  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000003815030

>  <smiles>
Cn1cnc2cc3ncnc(Nc4cccc(Br)c4)c3cc21

$$$$

 OpenBabel10312015333D

 22 24  0  0  0  0  0  0  0  0999 V2000
   -5.1006   -0.2083   -1.4236 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.9407    0.5310   -0.2154 O   0  0  0  0  0  0  0  0  0  0  0  0
   -3.6504    0.5319    0.3228 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.8345    1.6412    0.1355 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.4589    1.5107    0.0166 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.7000    2.4346   -0.6209 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.4269    2.0953   -1.2918 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.9960    0.8837   -1.0801 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.4169    0.1039   -0.1376 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.1630   -0.9852    0.4167 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.5903   -0.9777    0.2911 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.1185   -1.9498   -0.5464 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.4463   -1.8757   -0.9353 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.1618   -0.6904   -0.8279 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.5160    0.3874   -0.2704 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.2348    2.1540   -0.3890 Br  0  0  0  0  0  0  0  0  0  0  0  0
    3.2994    0.2111    0.3771 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.8443    0.3115    0.3500 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.6481   -0.7546    0.6682 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0341   -0.6580    0.6906 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.8189   -1.8074    0.5544 O   0  0  0  0  0  0  0  0  0  0  0  0
   -3.3394   -2.8891   -0.2302 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  9 10  1  0  0  0  0
  9 18  2  0  0  0  0
 10 11  1  0  0  0  0
 11 12  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 15 16  1  0  0  0  0
 15 17  2  0  0  0  0
 17 11  1  0  0  0  0
 18 19  1  0  0  0  0
 18  5  1  0  0  0  0
 19 20  2  0  0  0  0
 20 21  1  0  0  0  0
 20  3  1  0  0  0  0
 21 22  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000000600292

>  <smiles>
COc1cc2ncnc(Nc3cccc(Br)c3)c2cc1OC

$$$$

 OpenBabel10312015333D

 22 25  0  0  0  0  0  0  0  0999 V2000
   -3.7381    1.6179    2.6126 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.3313    1.6756    1.2297 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.9777    2.8220    0.6165 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.6286    2.4522   -0.6335 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.4005    1.1180   -0.6776 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.4342    0.3832   -1.3548 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.1128   -0.8984   -0.9364 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.9698   -1.4856   -0.0162 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.9526   -0.7494    0.6346 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0498    0.6182    0.4439 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.5910   -2.6995    0.4485 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.5156   -3.3373   -0.0611 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.3606   -2.6866   -0.8590 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.1970   -1.3567   -1.0259 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.2630   -0.5046   -1.4564 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.3599   -0.2167   -0.5827 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.3885   -0.7589    0.6914 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.5688   -0.6259    1.4074 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.5246    0.2732    1.0151 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.2873    1.0968   -0.0752 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.4679    2.5307   -0.4553 Br  0  0  0  0  0  0  0  0  0  0  0  0
    3.2845    0.7319   -0.9657 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  8 11  1  0  0  0  0
  9 10  2  0  0  0  0
 10  2  1  0  0  0  0
 10  5  1  0  0  0  0
 11 12  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 14  7  1  0  0  0  0
 15 16  1  0  0  0  0
 16 17  2  0  0  0  0
 17 18  1  0  0  0  0
 18 19  2  0  0  0  0
 19 20  1  0  0  0  0
 20 21  1  0  0  0  0
 20 22  2  0  0  0  0
 22 16  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000002391775

>  <smiles>
Cn1cnc2cc3c(Nc4cccc(Br)c4)ncnc3cc21

$$$$

 OpenBabel10312015333D

 34 36  0  0  0  0  0  0  0  0999 V2000
    8.3527    3.0433    1.2856 C   0  0  0  0  0  0  0  0  0  0  0  0
    7.6887    2.2563    0.6391 C   0  0  0  0  0  0  0  0  0  0  0  0
    7.3961    0.9113    0.1120 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.1551    0.3908    0.6648 N   0  0  0  0  0  0  0  0  0  0  0  0
    5.6091   -0.5200   -0.3116 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.4989   -1.3062    0.3123 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.8993   -2.3021   -0.3046 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.4393   -2.4590   -0.2534 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.9429   -2.4291    0.9128 O   0  0  0  0  0  0  0  0  0  0  0  0
    1.5772   -2.0690   -1.3087 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.5263   -1.1074   -1.1417 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.5540   -1.3365   -0.2994 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.0522   -0.2841    0.4598 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.4684    0.9775    0.4353 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.3847    1.2629   -0.6231 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.7628    0.2234   -1.4657 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.7262    0.4580   -2.4247 O   0  0  0  0  0  0  0  0  0  0  0  0
    2.0658   -0.4960   -3.4015 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.0944   -0.4884   -4.5525 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.5855    1.7381    1.5237 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.3318    1.3479    2.5864 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.0563    0.1818    2.5760 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0120   -0.1512    3.5856 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.5046   -0.6520    4.5164 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.9702   -0.6238    1.4470 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0500   -1.4785    1.0488 N   0  0  0  0  0  0  0  0  0  0  0  0
   -4.1291   -0.8868    0.3153 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.1855   -0.2580    0.9292 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.6585    0.9755    0.4987 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.3529    1.3711   -0.7941 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.5871    2.6483   -1.1866 F   0  0  0  0  0  0  0  0  0  0  0  0
   -4.5433    0.5758   -1.5653 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.2710    0.9178   -3.2582 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -3.8070   -0.4317   -0.9575 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  3  0  0  0  0
  2  3  1  0  0  0  0
  3  4  1  0  0  0  0
  4  5  1  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  8 10  1  0  0  0  0
 10 11  1  0  0  0  0
 11 12  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 14 20  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 16 11  1  0  0  0  0
 17 18  1  0  0  0  0
 18 19  1  0  0  0  0
 20 21  2  0  0  0  0
 21 22  1  0  0  0  0
 22 23  1  0  0  0  0
 22 25  2  0  0  0  0
 23 24  3  0  0  0  0
 25 26  1  0  0  0  0
 25 13  1  0  0  0  0
 26 27  1  0  0  0  0
 27 28  2  0  0  0  0
 28 29  1  0  0  0  0
 29 30  2  0  0  0  0
 30 31  1  0  0  0  0
 30 32  1  0  0  0  0
 32 33  1  0  0  0  0
 32 34  2  0  0  0  0
 34 27  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000064564721

>  <smiles>
C#CCNC/C=C/C(=O)Nc1cc2c(Nc3ccc(F)c(Cl)c3)c(C#N)cnc2cc1OCC

$$$$

 OpenBabel10312015333D

 25 27  0  0  0  0  0  0  0  0999 V2000
    3.6989    3.8425    1.1264 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.7120    3.0818    0.7140 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.3986    2.0177   -0.2400 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.5317    2.1577   -1.4814 O   0  0  0  0  0  0  0  0  0  0  0  0
    3.7921    0.8318    0.2235 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.9118    0.0300   -0.5737 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.4100   -0.9350   -1.4416 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.7791   -2.1705   -1.5264 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.5412   -2.3948   -0.9568 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.1644   -3.6319   -0.5566 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.3202   -3.8265    0.4848 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.4893   -2.8205    0.8599 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.2530   -1.5993    0.3384 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.9822   -0.4970    0.8664 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.2460   -0.0932    0.3251 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3633    1.1515   -0.2804 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.5730    1.8152   -0.2756 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.8765    3.0604   -1.4826 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -4.6447    1.3480    0.4538 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.9899    2.4107    0.7594 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -4.5300    0.1501    1.1196 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.3711   -0.5978    0.9605 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.3951   -1.9238    1.2368 F   0  0  0  0  0  0  0  0  0  0  0  0
    0.8900   -1.3071   -0.3933 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.5642   -0.1000   -0.2604 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  2  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  3  5  1  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 12 13  2  0  0  0  0
 13 14  1  0  0  0  0
 13 24  1  0  0  0  0
 14 15  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 17 18  1  0  0  0  0
 17 19  2  0  0  0  0
 19 20  1  0  0  0  0
 19 21  1  0  0  0  0
 21 22  2  0  0  0  0
 22 23  1  0  0  0  0
 22 15  1  0  0  0  0
 24 25  2  0  0  0  0
 24  9  1  0  0  0  0
 25  6  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000013671593

>  <smiles>
C=CC(=O)Nc1ccc2ncnc(Nc3cc(Cl)c(Cl)cc3F)c2c1

$$$$

 OpenBabel10312015333D

 25 27  0  0  0  0  0  0  0  0999 V2000
   -3.6522    2.9414    0.4116 O   0  0  0  0  0  0  0  0  0  0  0  0
   -4.4292    2.2420   -0.2910 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.8636    2.6082   -0.5077 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.8754    2.0257    0.8455 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -3.8741    1.0205   -0.7914 N   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0628    0.1990    0.0567 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.6260   -0.8284    0.8046 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0254   -2.0715    0.9190 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.7102   -2.2058    0.4924 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.1325   -3.4274    0.4187 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.2135   -3.4832    0.3457 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.9256   -2.3895    0.0703 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.3613   -1.1771   -0.1425 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.1047    0.0395   -0.0155 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.5031    0.0879   -0.2313 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.9726    0.7631   -1.3502 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.3221    1.0503   -1.4979 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.8126    2.1827   -2.7497 Cl  0  0  0  0  0  0  0  0  0  0  0  0
    5.1028    0.8624   -0.3632 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.7048    1.5741   -0.3256 Cl  0  0  0  0  0  0  0  0  0  0  0  0
    4.7323   -0.0098    0.6468 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.3691   -0.2167    0.8087 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.8492   -0.7724    1.9268 F   0  0  0  0  0  0  0  0  0  0  0  0
   -1.0079   -1.0852    0.0685 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.7145    0.0704   -0.2328 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  2  0  0  0  0
  2  3  1  0  0  0  0
  2  5  1  0  0  0  0
  3  4  1  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 12 13  2  0  0  0  0
 13 14  1  0  0  0  0
 13 24  1  0  0  0  0
 14 15  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 17 18  1  0  0  0  0
 17 19  2  0  0  0  0
 19 20  1  0  0  0  0
 19 21  1  0  0  0  0
 21 22  2  0  0  0  0
 22 23  1  0  0  0  0
 22 15  1  0  0  0  0
 24 25  2  0  0  0  0
 24  9  1  0  0  0  0
 25  6  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000013671601

>  <smiles>
O=C(CCl)Nc1ccc2ncnc(Nc3cc(Cl)c(Cl)cc3F)c2c1

$$$$

 OpenBabel10312015333D

 22 24  0  0  0  0  0  0  0  0999 V2000
    4.2204    3.3968   -0.1145 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.1985    2.0369   -0.4794 O   0  0  0  0  0  0  0  0  0  0  0  0
    3.3119    1.1065    0.0405 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.5149    1.4545    1.1216 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.4140    0.6621    1.3789 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.8738    0.5435    2.6138 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.3925    0.1004    2.7286 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.0885   -0.3254    1.6585 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.3706   -0.6580    0.5585 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.9853   -1.5113   -0.4142 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.4064   -1.6060   -0.5015 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0897   -1.4927   -1.7069 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.2671   -0.7583   -1.7939 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.8887   -0.3023   -0.6381 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.9316    1.2979   -0.6049 Br  0  0  0  0  0  0  0  0  0  0  0  0
   -4.4694   -0.9070    0.5408 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.2230   -1.5177    0.6205 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.9225   -0.2063    0.4132 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.6581   -0.5054   -0.7132 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.9220    0.0667   -0.7923 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.8412   -0.4492   -1.6979 O   0  0  0  0  0  0  0  0  0  0  0  0
    5.2356   -0.4257   -1.4619 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  9 10  1  0  0  0  0
  9 18  2  0  0  0  0
 10 11  1  0  0  0  0
 11 12  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 14 16  1  0  0  0  0
 16 17  2  0  0  0  0
 17 11  1  0  0  0  0
 18 19  1  0  0  0  0
 18  5  1  0  0  0  0
 19 20  2  0  0  0  0
 20 21  1  0  0  0  0
 20  3  1  0  0  0  0
 21 22  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000001386782

>  <smiles>
COc1cc2ncnc(Nc3ccc(Br)cc3)c2cc1OC

$$$$

 OpenBabel10312015333D

 23 25  0  0  0  0  0  0  0  0999 V2000
   -5.5945    1.8044    0.2797 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.2625    2.2269    0.0392 O   0  0  0  0  0  0  0  0  0  0  0  0
   -3.2822    1.3104   -0.3406 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.6136    0.0006   -0.6040 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.6539   -0.9962   -0.4817 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.9926   -2.2697   -0.1645 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.0661   -3.1646    0.2483 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.7952   -2.8949   -0.1100 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.3484   -1.6145   -0.0887 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.9330   -1.4076   -0.6697 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.0478   -0.9097    0.0826 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.7646   -1.7989    0.8744 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.9959   -1.4092    1.3598 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.6023   -0.2263    0.9603 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.4016    0.2080    1.3750 Br  0  0  0  0  0  0  0  0  0  0  0  0
    3.9250    0.5557    0.0344 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.4683    2.3708   -0.2374 Br  0  0  0  0  0  0  0  0  0  0  0  0
    2.8133    0.0457   -0.5752 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.3109   -0.6534   -0.3757 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.9530    0.6828   -0.2879 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.9493    1.6306   -0.1118 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.6566    2.9975   -0.0833 O   0  0  0  0  0  0  0  0  0  0  0  0
   -0.4731    3.5118    0.4951 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  9 10  1  0  0  0  0
  9 19  2  0  0  0  0
 10 11  1  0  0  0  0
 11 12  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 14 16  1  0  0  0  0
 16 17  1  0  0  0  0
 16 18  2  0  0  0  0
 18 11  1  0  0  0  0
 19 20  1  0  0  0  0
 19  5  1  0  0  0  0
 20 21  2  0  0  0  0
 21 22  1  0  0  0  0
 21  3  1  0  0  0  0
 22 23  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000003815032

>  <smiles>
COc1cc2ncnc(Nc3ccc(Br)c(Br)c3)c2cc1OC

$$$$

 OpenBabel10312015333D

 23 25  0  0  0  0  0  0  0  0999 V2000
    6.5192    0.0960    2.1045 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.1833    0.6190    0.9260 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.1191    0.0478    0.0949 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.3878   -0.7515   -0.8506 O   0  0  0  0  0  0  0  0  0  0  0  0
    3.7911    0.5465    0.1225 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.7032   -0.3271   -0.1860 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.7974   -1.7056   -0.0513 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.7510   -2.4051    0.5384 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.4637   -1.8920    0.4346 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.6191   -2.7015    0.4366 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.7598   -2.3882   -0.2236 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.8270   -1.1798   -0.8259 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.9711   -0.2169   -0.4569 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.2426    1.1666   -0.5124 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.6105    1.5853   -0.4550 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0129    2.8457   -0.8804 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.2460    3.3056   -0.4397 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.2594    2.3803   -0.2261 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.9551    1.0443   -0.1500 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.2864   -0.3196   -0.2196 Br  0  0  0  0  0  0  0  0  0  0  0  0
   -3.6429    0.6751   -0.2606 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.3015   -0.6104   -0.0658 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.4157    0.1855   -0.2881 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  2  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  3  5  1  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 12 13  2  0  0  0  0
 13 14  1  0  0  0  0
 13 22  1  0  0  0  0
 14 15  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 17 18  2  0  0  0  0
 18 19  1  0  0  0  0
 19 20  1  0  0  0  0
 19 21  2  0  0  0  0
 21 15  1  0  0  0  0
 22 23  2  0  0  0  0
 22  9  1  0  0  0  0
 23  6  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000001488208

>  <smiles>
C=CC(=O)Nc1ccc2ncnc(Nc3cccc(Br)c3)c2c1

$$$$

 OpenBabel10312015333D

 40 43  0  0  0  0  0  0  0  0999 V2000
    6.4753    1.5606   -2.9466 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.1130    0.9870   -3.2400 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.8107   -0.1257   -2.4326 O   0  0  0  0  0  0  0  0  0  0  0  0
    3.4680   -0.3169   -2.0962 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.4622   -0.2523   -3.0374 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.1580    0.0949   -2.7123 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.3561    0.7593   -3.5795 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.6406    1.5610   -3.1338 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.0573    1.5001   -1.8119 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.9399    2.4927   -1.2419 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3733    3.4408   -0.7192 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.3785    0.6082   -0.9988 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.9151    0.2801    0.2647 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.2230   -0.3029    0.3032 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.2159    0.1801    1.1463 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.5171    0.2645    0.6665 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.9655   -0.7132   -0.2007 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.2063   -0.5525   -0.7778 O   0  0  0  0  0  0  0  0  0  0  0  0
   -7.4173   -0.4588   -0.0716 C   0  0  0  0  0  0  0  0  0  0  0  0
   -7.1132   -0.3854    1.3745 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.9119   -1.5247    2.1431 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.6256   -1.4079    3.4978 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.5236   -0.1195    3.9848 C   0  0  0  0  0  0  0  0  0  0  0  0
   -7.3182    0.8311    3.3810 C   0  0  0  0  0  0  0  0  0  0  0  0
   -7.4729    0.7278    2.0451 N   0  0  0  0  0  0  0  0  0  0  0  0
   -4.0008   -1.5195   -0.7909 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.5775   -2.7060   -1.9416 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -2.6552   -1.1962   -0.6701 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.8344    0.0411   -1.3667 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.7754   -0.3273   -0.4150 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.1209   -0.3864   -0.7532 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.1413   -0.1078    0.2053 N   0  0  0  0  0  0  0  0  0  0  0  0
    4.9401   -1.1359    0.7910 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.3795   -2.2564    0.9414 O   0  0  0  0  0  0  0  0  0  0  0  0
    6.2462   -0.8228    1.3566 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.3320   -0.3434    2.5872 C   0  0  0  0  0  0  0  0  0  0  0  0
    7.3300    0.7083    2.9575 C   0  0  0  0  0  0  0  0  0  0  0  0
    8.6408    0.0874    2.7803 N   0  0  0  0  0  0  0  0  0  0  0  0
    8.5628   -1.3157    3.1669 C   0  0  0  0  0  0  0  0  0  0  0  0
    8.9019    0.0936    1.3447 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  1  0  0  0  0
  4  5  2  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
  9 12  1  0  0  0  0
 10 11  3  0  0  0  0
 12 13  1  0  0  0  0
 12 29  2  0  0  0  0
 13 14  1  0  0  0  0
 14 15  2  0  0  0  0
 15 16  1  0  0  0  0
 16 17  2  0  0  0  0
 17 18  1  0  0  0  0
 17 26  1  0  0  0  0
 18 19  1  0  0  0  0
 19 20  1  0  0  0  0
 20 21  2  0  0  0  0
 21 22  1  0  0  0  0
 22 23  2  0  0  0  0
 23 24  1  0  0  0  0
 24 25  2  0  0  0  0
 25 20  1  0  0  0  0
 26 27  1  0  0  0  0
 26 28  2  0  0  0  0
 28 14  1  0  0  0  0
 29 30  1  0  0  0  0
 29  6  1  0  0  0  0
 30 31  2  0  0  0  0
 31 32  1  0  0  0  0
 31  4  1  0  0  0  0
 32 33  1  0  0  0  0
 33 34  2  0  0  0  0
 33 35  1  0  0  0  0
 35 36  2  0  0  0  0
 36 37  1  0  0  0  0
 37 38  1  0  0  0  0
 38 39  1  0  0  0  0
 38 40  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000003916214

>  <smiles>
CCOc1cc2ncc(C#N)c(Nc3ccc(OCc4ccccn4)c(Cl)c3)c2cc1NC(=O)/C=C/CN(C)C

$$$$`;
    },
    set25Compounds() {
      this.resetToDefault();
      this.textarea = `
 OpenBabel10312015333D

 22 25  0  0  0  0  0  0  0  0999 V2000
   -4.7445    1.7572    0.7582 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.2994    0.7076   -0.1517 N   0  0  0  0  0  0  0  0  0  0  0  0
   -4.9649    0.0619   -1.1129 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.2921   -1.0576   -1.4747 N   0  0  0  0  0  0  0  0  0  0  0  0
   -3.1821   -1.1246   -0.7037 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3093   -2.1397   -0.3319 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.1317   -1.7137    0.2647 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.1733   -2.5853    0.6387 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.9781   -2.1810    1.2171 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.3222   -0.9020    1.0426 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.4362    0.0765    0.7349 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.9219    1.2717    0.1153 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.3256    1.5588    0.1611 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.7939    2.4508    1.1161 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.0027    2.2263    1.7649 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.8559    1.2789    1.2660 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.5026    0.4741    0.1894 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.4644   -1.1620   -0.0930 Br  0  0  0  0  0  0  0  0  0  0  0  0
    3.2485    0.6771   -0.3676 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.8439   -0.3657    0.4384 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.8270    0.5711    0.2832 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0836    0.1196   -0.0922 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  9 10  2  0  0  0  0
 10 11  1  0  0  0  0
 11 12  1  0  0  0  0
 11 20  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 17 18  1  0  0  0  0
 17 19  2  0  0  0  0
 19 13  1  0  0  0  0
 20 21  1  0  0  0  0
 20  7  1  0  0  0  0
 21 22  2  0  0  0  0
 22  2  1  0  0  0  0
 22  5  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000003815030

>  <smiles>
Cn1cnc2cc3ncnc(Nc4cccc(Br)c4)c3cc21

$$$$

 OpenBabel10312015333D

 22 24  0  0  0  0  0  0  0  0999 V2000
   -5.1006   -0.2083   -1.4236 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.9407    0.5310   -0.2154 O   0  0  0  0  0  0  0  0  0  0  0  0
   -3.6504    0.5319    0.3228 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.8345    1.6412    0.1355 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.4589    1.5107    0.0166 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.7000    2.4346   -0.6209 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.4269    2.0953   -1.2918 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.9960    0.8837   -1.0801 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.4169    0.1039   -0.1376 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.1630   -0.9852    0.4167 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.5903   -0.9777    0.2911 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.1185   -1.9498   -0.5464 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.4463   -1.8757   -0.9353 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.1618   -0.6904   -0.8279 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.5160    0.3874   -0.2704 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.2348    2.1540   -0.3890 Br  0  0  0  0  0  0  0  0  0  0  0  0
    3.2994    0.2111    0.3771 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.8443    0.3115    0.3500 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.6481   -0.7546    0.6682 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0341   -0.6580    0.6906 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.8189   -1.8074    0.5544 O   0  0  0  0  0  0  0  0  0  0  0  0
   -3.3394   -2.8891   -0.2302 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  9 10  1  0  0  0  0
  9 18  2  0  0  0  0
 10 11  1  0  0  0  0
 11 12  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 15 16  1  0  0  0  0
 15 17  2  0  0  0  0
 17 11  1  0  0  0  0
 18 19  1  0  0  0  0
 18  5  1  0  0  0  0
 19 20  2  0  0  0  0
 20 21  1  0  0  0  0
 20  3  1  0  0  0  0
 21 22  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000000600292

>  <smiles>
COc1cc2ncnc(Nc3cccc(Br)c3)c2cc1OC

$$$$

 OpenBabel10312015333D

 22 25  0  0  0  0  0  0  0  0999 V2000
   -3.7381    1.6179    2.6126 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.3313    1.6756    1.2297 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.9777    2.8220    0.6165 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.6286    2.4522   -0.6335 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.4005    1.1180   -0.6776 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.4342    0.3832   -1.3548 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.1128   -0.8984   -0.9364 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.9698   -1.4856   -0.0162 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.9526   -0.7494    0.6346 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0498    0.6182    0.4439 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.5910   -2.6995    0.4485 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.5156   -3.3373   -0.0611 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.3606   -2.6866   -0.8590 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.1970   -1.3567   -1.0259 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.2630   -0.5046   -1.4564 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.3599   -0.2167   -0.5827 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.3885   -0.7589    0.6914 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.5688   -0.6259    1.4074 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.5246    0.2732    1.0151 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.2873    1.0968   -0.0752 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.4679    2.5307   -0.4553 Br  0  0  0  0  0  0  0  0  0  0  0  0
    3.2845    0.7319   -0.9657 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  8 11  1  0  0  0  0
  9 10  2  0  0  0  0
 10  2  1  0  0  0  0
 10  5  1  0  0  0  0
 11 12  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 14  7  1  0  0  0  0
 15 16  1  0  0  0  0
 16 17  2  0  0  0  0
 17 18  1  0  0  0  0
 18 19  2  0  0  0  0
 19 20  1  0  0  0  0
 20 21  1  0  0  0  0
 20 22  2  0  0  0  0
 22 16  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000002391775

>  <smiles>
Cn1cnc2cc3c(Nc4cccc(Br)c4)ncnc3cc21

$$$$

 OpenBabel10312015333D

 34 36  0  0  0  0  0  0  0  0999 V2000
    8.3527    3.0433    1.2856 C   0  0  0  0  0  0  0  0  0  0  0  0
    7.6887    2.2563    0.6391 C   0  0  0  0  0  0  0  0  0  0  0  0
    7.3961    0.9113    0.1120 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.1551    0.3908    0.6648 N   0  0  0  0  0  0  0  0  0  0  0  0
    5.6091   -0.5200   -0.3116 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.4989   -1.3062    0.3123 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.8993   -2.3021   -0.3046 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.4393   -2.4590   -0.2534 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.9429   -2.4291    0.9128 O   0  0  0  0  0  0  0  0  0  0  0  0
    1.5772   -2.0690   -1.3087 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.5263   -1.1074   -1.1417 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.5540   -1.3365   -0.2994 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.0522   -0.2841    0.4598 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.4684    0.9775    0.4353 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.3847    1.2629   -0.6231 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.7628    0.2234   -1.4657 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.7262    0.4580   -2.4247 O   0  0  0  0  0  0  0  0  0  0  0  0
    2.0658   -0.4960   -3.4015 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.0944   -0.4884   -4.5525 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.5855    1.7381    1.5237 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.3318    1.3479    2.5864 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.0563    0.1818    2.5760 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0120   -0.1512    3.5856 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.5046   -0.6520    4.5164 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.9702   -0.6238    1.4470 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0500   -1.4785    1.0488 N   0  0  0  0  0  0  0  0  0  0  0  0
   -4.1291   -0.8868    0.3153 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.1855   -0.2580    0.9292 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.6585    0.9755    0.4987 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.3529    1.3711   -0.7941 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.5871    2.6483   -1.1866 F   0  0  0  0  0  0  0  0  0  0  0  0
   -4.5433    0.5758   -1.5653 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.2710    0.9178   -3.2582 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -3.8070   -0.4317   -0.9575 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  3  0  0  0  0
  2  3  1  0  0  0  0
  3  4  1  0  0  0  0
  4  5  1  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  8 10  1  0  0  0  0
 10 11  1  0  0  0  0
 11 12  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 14 20  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 16 11  1  0  0  0  0
 17 18  1  0  0  0  0
 18 19  1  0  0  0  0
 20 21  2  0  0  0  0
 21 22  1  0  0  0  0
 22 23  1  0  0  0  0
 22 25  2  0  0  0  0
 23 24  3  0  0  0  0
 25 26  1  0  0  0  0
 25 13  1  0  0  0  0
 26 27  1  0  0  0  0
 27 28  2  0  0  0  0
 28 29  1  0  0  0  0
 29 30  2  0  0  0  0
 30 31  1  0  0  0  0
 30 32  1  0  0  0  0
 32 33  1  0  0  0  0
 32 34  2  0  0  0  0
 34 27  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000064564721

>  <smiles>
C#CCNC/C=C/C(=O)Nc1cc2c(Nc3ccc(F)c(Cl)c3)c(C#N)cnc2cc1OCC

$$$$

 OpenBabel10312015333D

 25 27  0  0  0  0  0  0  0  0999 V2000
    3.6989    3.8425    1.1264 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.7120    3.0818    0.7140 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.3986    2.0177   -0.2400 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.5317    2.1577   -1.4814 O   0  0  0  0  0  0  0  0  0  0  0  0
    3.7921    0.8318    0.2235 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.9118    0.0300   -0.5737 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.4100   -0.9350   -1.4416 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.7791   -2.1705   -1.5264 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.5412   -2.3948   -0.9568 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.1644   -3.6319   -0.5566 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.3202   -3.8265    0.4848 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.4893   -2.8205    0.8599 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.2530   -1.5993    0.3384 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.9822   -0.4970    0.8664 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.2460   -0.0932    0.3251 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3633    1.1515   -0.2804 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.5730    1.8152   -0.2756 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.8765    3.0604   -1.4826 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -4.6447    1.3480    0.4538 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.9899    2.4107    0.7594 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -4.5300    0.1501    1.1196 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.3711   -0.5978    0.9605 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.3951   -1.9238    1.2368 F   0  0  0  0  0  0  0  0  0  0  0  0
    0.8900   -1.3071   -0.3933 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.5642   -0.1000   -0.2604 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  2  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  3  5  1  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 12 13  2  0  0  0  0
 13 14  1  0  0  0  0
 13 24  1  0  0  0  0
 14 15  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 17 18  1  0  0  0  0
 17 19  2  0  0  0  0
 19 20  1  0  0  0  0
 19 21  1  0  0  0  0
 21 22  2  0  0  0  0
 22 23  1  0  0  0  0
 22 15  1  0  0  0  0
 24 25  2  0  0  0  0
 24  9  1  0  0  0  0
 25  6  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000013671593

>  <smiles>
C=CC(=O)Nc1ccc2ncnc(Nc3cc(Cl)c(Cl)cc3F)c2c1

$$$$

 OpenBabel10312015333D

 25 27  0  0  0  0  0  0  0  0999 V2000
   -3.6522    2.9414    0.4116 O   0  0  0  0  0  0  0  0  0  0  0  0
   -4.4292    2.2420   -0.2910 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.8636    2.6082   -0.5077 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.8754    2.0257    0.8455 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -3.8741    1.0205   -0.7914 N   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0628    0.1990    0.0567 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.6260   -0.8284    0.8046 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0254   -2.0715    0.9190 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.7102   -2.2058    0.4924 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.1325   -3.4274    0.4187 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.2135   -3.4832    0.3457 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.9256   -2.3895    0.0703 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.3613   -1.1771   -0.1425 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.1047    0.0395   -0.0155 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.5031    0.0879   -0.2313 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.9726    0.7631   -1.3502 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.3221    1.0503   -1.4979 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.8126    2.1827   -2.7497 Cl  0  0  0  0  0  0  0  0  0  0  0  0
    5.1028    0.8624   -0.3632 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.7048    1.5741   -0.3256 Cl  0  0  0  0  0  0  0  0  0  0  0  0
    4.7323   -0.0098    0.6468 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.3691   -0.2167    0.8087 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.8492   -0.7724    1.9268 F   0  0  0  0  0  0  0  0  0  0  0  0
   -1.0079   -1.0852    0.0685 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.7145    0.0704   -0.2328 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  2  0  0  0  0
  2  3  1  0  0  0  0
  2  5  1  0  0  0  0
  3  4  1  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 12 13  2  0  0  0  0
 13 14  1  0  0  0  0
 13 24  1  0  0  0  0
 14 15  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 17 18  1  0  0  0  0
 17 19  2  0  0  0  0
 19 20  1  0  0  0  0
 19 21  1  0  0  0  0
 21 22  2  0  0  0  0
 22 23  1  0  0  0  0
 22 15  1  0  0  0  0
 24 25  2  0  0  0  0
 24  9  1  0  0  0  0
 25  6  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000013671601

>  <smiles>
O=C(CCl)Nc1ccc2ncnc(Nc3cc(Cl)c(Cl)cc3F)c2c1

$$$$

 OpenBabel10312015333D

 22 24  0  0  0  0  0  0  0  0999 V2000
    4.2204    3.3968   -0.1145 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.1985    2.0369   -0.4794 O   0  0  0  0  0  0  0  0  0  0  0  0
    3.3119    1.1065    0.0405 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.5149    1.4545    1.1216 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.4140    0.6621    1.3789 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.8738    0.5435    2.6138 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.3925    0.1004    2.7286 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.0885   -0.3254    1.6585 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.3706   -0.6580    0.5585 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.9853   -1.5113   -0.4142 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.4064   -1.6060   -0.5015 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0897   -1.4927   -1.7069 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.2671   -0.7583   -1.7939 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.8887   -0.3023   -0.6381 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.9316    1.2979   -0.6049 Br  0  0  0  0  0  0  0  0  0  0  0  0
   -4.4694   -0.9070    0.5408 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.2230   -1.5177    0.6205 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.9225   -0.2063    0.4132 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.6581   -0.5054   -0.7132 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.9220    0.0667   -0.7923 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.8412   -0.4492   -1.6979 O   0  0  0  0  0  0  0  0  0  0  0  0
    5.2356   -0.4257   -1.4619 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  9 10  1  0  0  0  0
  9 18  2  0  0  0  0
 10 11  1  0  0  0  0
 11 12  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 14 16  1  0  0  0  0
 16 17  2  0  0  0  0
 17 11  1  0  0  0  0
 18 19  1  0  0  0  0
 18  5  1  0  0  0  0
 19 20  2  0  0  0  0
 20 21  1  0  0  0  0
 20  3  1  0  0  0  0
 21 22  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000001386782

>  <smiles>
COc1cc2ncnc(Nc3ccc(Br)cc3)c2cc1OC

$$$$

 OpenBabel10312015333D

 23 25  0  0  0  0  0  0  0  0999 V2000
   -5.5945    1.8044    0.2797 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.2625    2.2269    0.0392 O   0  0  0  0  0  0  0  0  0  0  0  0
   -3.2822    1.3104   -0.3406 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.6136    0.0006   -0.6040 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.6539   -0.9962   -0.4817 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.9926   -2.2697   -0.1645 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.0661   -3.1646    0.2483 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.7952   -2.8949   -0.1100 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.3484   -1.6145   -0.0887 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.9330   -1.4076   -0.6697 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.0478   -0.9097    0.0826 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.7646   -1.7989    0.8744 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.9959   -1.4092    1.3598 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.6023   -0.2263    0.9603 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.4016    0.2080    1.3750 Br  0  0  0  0  0  0  0  0  0  0  0  0
    3.9250    0.5557    0.0344 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.4683    2.3708   -0.2374 Br  0  0  0  0  0  0  0  0  0  0  0  0
    2.8133    0.0457   -0.5752 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.3109   -0.6534   -0.3757 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.9530    0.6828   -0.2879 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.9493    1.6306   -0.1118 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.6566    2.9975   -0.0833 O   0  0  0  0  0  0  0  0  0  0  0  0
   -0.4731    3.5118    0.4951 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  9 10  1  0  0  0  0
  9 19  2  0  0  0  0
 10 11  1  0  0  0  0
 11 12  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 14 16  1  0  0  0  0
 16 17  1  0  0  0  0
 16 18  2  0  0  0  0
 18 11  1  0  0  0  0
 19 20  1  0  0  0  0
 19  5  1  0  0  0  0
 20 21  2  0  0  0  0
 21 22  1  0  0  0  0
 21  3  1  0  0  0  0
 22 23  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000003815032

>  <smiles>
COc1cc2ncnc(Nc3ccc(Br)c(Br)c3)c2cc1OC

$$$$

 OpenBabel10312015333D

 23 25  0  0  0  0  0  0  0  0999 V2000
    6.5192    0.0960    2.1045 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.1833    0.6190    0.9260 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.1191    0.0478    0.0949 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.3878   -0.7515   -0.8506 O   0  0  0  0  0  0  0  0  0  0  0  0
    3.7911    0.5465    0.1225 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.7032   -0.3271   -0.1860 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.7974   -1.7056   -0.0513 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.7510   -2.4051    0.5384 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.4637   -1.8920    0.4346 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.6191   -2.7015    0.4366 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.7598   -2.3882   -0.2236 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.8270   -1.1798   -0.8259 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.9711   -0.2169   -0.4569 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.2426    1.1666   -0.5124 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.6105    1.5853   -0.4550 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0129    2.8457   -0.8804 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.2460    3.3056   -0.4397 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.2594    2.3803   -0.2261 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.9551    1.0443   -0.1500 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.2864   -0.3196   -0.2196 Br  0  0  0  0  0  0  0  0  0  0  0  0
   -3.6429    0.6751   -0.2606 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.3015   -0.6104   -0.0658 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.4157    0.1855   -0.2881 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  2  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  3  5  1  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 12 13  2  0  0  0  0
 13 14  1  0  0  0  0
 13 22  1  0  0  0  0
 14 15  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 17 18  2  0  0  0  0
 18 19  1  0  0  0  0
 19 20  1  0  0  0  0
 19 21  2  0  0  0  0
 21 15  1  0  0  0  0
 22 23  2  0  0  0  0
 22  9  1  0  0  0  0
 23  6  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000001488208

>  <smiles>
C=CC(=O)Nc1ccc2ncnc(Nc3cccc(Br)c3)c2c1

$$$$

 OpenBabel10312015333D

 40 43  0  0  0  0  0  0  0  0999 V2000
    6.4753    1.5606   -2.9466 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.1130    0.9870   -3.2400 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.8107   -0.1257   -2.4326 O   0  0  0  0  0  0  0  0  0  0  0  0
    3.4680   -0.3169   -2.0962 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.4622   -0.2523   -3.0374 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.1580    0.0949   -2.7123 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.3561    0.7593   -3.5795 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.6406    1.5610   -3.1338 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.0573    1.5001   -1.8119 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.9399    2.4927   -1.2419 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3733    3.4408   -0.7192 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.3785    0.6082   -0.9988 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.9151    0.2801    0.2647 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.2230   -0.3029    0.3032 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.2159    0.1801    1.1463 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.5171    0.2645    0.6665 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.9655   -0.7132   -0.2007 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.2063   -0.5525   -0.7778 O   0  0  0  0  0  0  0  0  0  0  0  0
   -7.4173   -0.4588   -0.0716 C   0  0  0  0  0  0  0  0  0  0  0  0
   -7.1132   -0.3854    1.3745 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.9119   -1.5247    2.1431 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.6256   -1.4079    3.4978 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.5236   -0.1195    3.9848 C   0  0  0  0  0  0  0  0  0  0  0  0
   -7.3182    0.8311    3.3810 C   0  0  0  0  0  0  0  0  0  0  0  0
   -7.4729    0.7278    2.0451 N   0  0  0  0  0  0  0  0  0  0  0  0
   -4.0008   -1.5195   -0.7909 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.5775   -2.7060   -1.9416 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -2.6552   -1.1962   -0.6701 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.8344    0.0411   -1.3667 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.7754   -0.3273   -0.4150 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.1209   -0.3864   -0.7532 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.1413   -0.1078    0.2053 N   0  0  0  0  0  0  0  0  0  0  0  0
    4.9401   -1.1359    0.7910 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.3795   -2.2564    0.9414 O   0  0  0  0  0  0  0  0  0  0  0  0
    6.2462   -0.8228    1.3566 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.3320   -0.3434    2.5872 C   0  0  0  0  0  0  0  0  0  0  0  0
    7.3300    0.7083    2.9575 C   0  0  0  0  0  0  0  0  0  0  0  0
    8.6408    0.0874    2.7803 N   0  0  0  0  0  0  0  0  0  0  0  0
    8.5628   -1.3157    3.1669 C   0  0  0  0  0  0  0  0  0  0  0  0
    8.9019    0.0936    1.3447 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  1  0  0  0  0
  4  5  2  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
  9 12  1  0  0  0  0
 10 11  3  0  0  0  0
 12 13  1  0  0  0  0
 12 29  2  0  0  0  0
 13 14  1  0  0  0  0
 14 15  2  0  0  0  0
 15 16  1  0  0  0  0
 16 17  2  0  0  0  0
 17 18  1  0  0  0  0
 17 26  1  0  0  0  0
 18 19  1  0  0  0  0
 19 20  1  0  0  0  0
 20 21  2  0  0  0  0
 21 22  1  0  0  0  0
 22 23  2  0  0  0  0
 23 24  1  0  0  0  0
 24 25  2  0  0  0  0
 25 20  1  0  0  0  0
 26 27  1  0  0  0  0
 26 28  2  0  0  0  0
 28 14  1  0  0  0  0
 29 30  1  0  0  0  0
 29  6  1  0  0  0  0
 30 31  2  0  0  0  0
 31 32  1  0  0  0  0
 31  4  1  0  0  0  0
 32 33  1  0  0  0  0
 33 34  2  0  0  0  0
 33 35  1  0  0  0  0
 35 36  2  0  0  0  0
 36 37  1  0  0  0  0
 37 38  1  0  0  0  0
 38 39  1  0  0  0  0
 38 40  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000003916214

>  <smiles>
CCOc1cc2ncc(C#N)c(Nc3ccc(OCc4ccccn4)c(Cl)c3)c2cc1NC(=O)/C=C/CN(C)C

$$$$

 OpenBabel10312015333D

 21 23  0  0  0  0  0  0  0  0999 V2000
    5.6733    0.5363   -1.0097 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.3775    1.1452   -0.7342 N   0  0  0  0  0  0  0  0  0  0  0  0
    3.9310    2.3045   -1.4999 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.4902    0.4035    0.1046 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.3516   -0.9732    0.0161 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.0682   -1.4685    0.2191 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.6843   -2.6768   -0.2590 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.3858   -2.9941   -0.4604 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.5860   -2.1008   -0.1644 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.2884   -0.8983    0.3726 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.1962    0.1839    0.4203 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.4830    0.1873   -0.1563 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.3241   -0.9069   -0.1816 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.6921   -0.6649   -0.1440 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.2080    0.5468   -0.5855 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.3524    1.6279   -0.7343 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.0126    3.4203   -0.8960 Br  0  0  0  0  0  0  0  0  0  0  0  0
   -3.0138    1.3938   -0.5747 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.0448   -0.6440    0.6700 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.4455    0.5618    1.2305 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.7046    1.0162    1.0183 N   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  2  4  1  0  0  0  0
  4  5  2  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
 10 11  1  0  0  0  0
 10 19  2  0  0  0  0
 11 12  1  0  0  0  0
 12 13  2  0  0  0  0
 13 14  1  0  0  0  0
 14 15  2  0  0  0  0
 15 16  1  0  0  0  0
 16 17  1  0  0  0  0
 16 18  2  0  0  0  0
 18 12  1  0  0  0  0
 19 20  1  0  0  0  0
 19  6  1  0  0  0  0
 20 21  2  0  0  0  0
 21  4  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000021289037

>  <smiles>
CN(C)c1cc2ncnc(Nc3cccc(Br)c3)c2cn1

$$$$

 OpenBabel10312015333D

 23 25  0  0  0  0  0  0  0  0999 V2000
   -6.2622    1.6832    0.6181 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.2680    2.6975    0.0666 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.9329    2.0731   -0.1587 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.8502    2.6454    0.1710 O   0  0  0  0  0  0  0  0  0  0  0  0
   -3.7753    0.8813   -0.9382 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.8188   -0.0956   -0.5183 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.3561   -1.2507    0.0367 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.5394   -2.0424    0.8346 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.1829   -2.0347    0.5537 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.4291   -3.1403    0.7657 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.8777   -3.1458    0.4114 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.4276   -2.0571   -0.1774 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.7035   -0.9218   -0.3082 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.3530    0.3105   -0.6281 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.6732    0.5045   -0.1117 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.0066    0.0749    1.1662 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.3193    0.2854    1.5652 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.3263    0.5406    0.6427 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.9505    1.0683   -0.5839 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.2131    1.9096   -1.7525 Br  0  0  0  0  0  0  0  0  0  0  0  0
    3.6897    0.7555   -1.0258 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.6520   -0.8870   -0.0219 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.4736    0.1456   -0.4409 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  3  5  1  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 12 13  2  0  0  0  0
 13 14  1  0  0  0  0
 13 22  1  0  0  0  0
 14 15  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 17 18  2  0  0  0  0
 18 19  1  0  0  0  0
 19 20  1  0  0  0  0
 19 21  2  0  0  0  0
 21 15  1  0  0  0  0
 22 23  2  0  0  0  0
 22  9  1  0  0  0  0
 23  6  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000001488953

>  <smiles>
CCC(=O)Nc1ccc2ncnc(Nc3cccc(Br)c3)c2c1

$$$$

 OpenBabel10312015333D

 29 31  0  0  0  0  0  0  0  0999 V2000
   -7.9879   -0.4495    1.1164 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.9663    0.0900    0.7463 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.8151    0.7147    0.1446 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.8777    1.2705   -1.1291 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.8143    2.0505   -1.5301 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.5807    1.8286   -0.9787 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.4340    0.7465   -0.1259 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.1624    0.3896    0.3671 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.4957   -0.8262    0.0115 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.1291   -2.0192    0.1199 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.4306   -3.1507    0.3436 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.0901   -3.1407    0.5370 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.6094   -2.0066    0.2958 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.9587   -1.8947    0.6114 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.5807   -0.6903    0.3120 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.9137   -0.4374    0.5940 O   0  0  0  0  0  0  0  0  0  0  0  0
    4.7333   -1.3200    1.3117 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.8814   -2.5801    0.5001 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.4239   -2.2064   -0.7405 O   0  0  0  0  0  0  0  0  0  0  0  0
    6.8153   -2.3605   -0.6472 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.8793    0.3374   -0.2953 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.5829    1.3482   -0.9331 O   0  0  0  0  0  0  0  0  0  0  0  0
    2.6463    2.6197   -0.3347 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.9590    2.8146    0.4029 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.2897    4.1524    0.5549 O   0  0  0  0  0  0  0  0  0  0  0  0
    3.6557    4.9842   -0.3513 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.5241    0.2471   -0.5343 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.1178   -0.9007   -0.1281 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.5515    0.3888    0.6173 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  3  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  1  0  0  0  0
  7 29  2  0  0  0  0
  8  9  1  0  0  0  0
  9 10  2  0  0  0  0
 10 11  1  0  0  0  0
 11 12  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 15 16  1  0  0  0  0
 15 21  2  0  0  0  0
 16 17  1  0  0  0  0
 17 18  1  0  0  0  0
 18 19  1  0  0  0  0
 19 20  1  0  0  0  0
 21 22  1  0  0  0  0
 21 27  1  0  0  0  0
 22 23  1  0  0  0  0
 23 24  1  0  0  0  0
 24 25  1  0  0  0  0
 25 26  1  0  0  0  0
 27 28  2  0  0  0  0
 28  9  1  0  0  0  0
 28 13  1  0  0  0  0
 29  3  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000001546066

>  <smiles>
C#Cc1cccc(Nc2ncnc3cc(OCCOC)c(OCCOC)cc23)c1

$$$$

 OpenBabel10312015333D

 19 21  0  0  0  0  0  0  0  0999 V2000
   -4.3107    2.5648    0.3241 N   0  0  0  0  0  0  0  0  0  0  0  0
   -3.3698    1.5201    0.4477 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.0348    1.8776    0.4966 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.0605    0.9493    0.2489 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.3384   -0.3670   -0.0462 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.6682   -0.7437    0.0484 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.6717    0.1905    0.2060 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0027   -2.0396   -0.1054 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.0205   -2.9300   -0.2995 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.7113   -2.5803   -0.3182 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.3109   -1.2895   -0.2043 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.8840   -1.0861    0.5594 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.0621   -0.4975   -0.0035 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.2362   -1.2288   -0.1463 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.4659   -0.6636    0.1695 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.5751    0.6617    0.5441 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.4602    1.4571    0.3523 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.5751    3.3247    0.7726 Br  0  0  0  0  0  0  0  0  0  0  0  0
    2.2411    0.8803    0.0408 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  2  0  0  0  0
  3  4  1  0  0  0  0
  4  5  2  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  6  8  1  0  0  0  0
  7  2  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 11  5  1  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 17 18  1  0  0  0  0
 17 19  2  0  0  0  0
 19 13  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000003815072

>  <smiles>
Nc1ccc2c(Nc3cccc(Br)c3)ncnc2c1

$$$$

 OpenBabel10312015333D

 34 37  0  0  0  0  0  0  0  0999 V2000
    6.1153   -5.1255    0.0328 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.3789   -4.4205   -0.2424 N   0  0  0  0  0  0  0  0  0  0  0  0
    5.6008   -3.8227   -1.5454 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.9855   -4.8245   -0.1248 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.1222   -3.6045   -0.1414 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.6364   -2.3903   -0.2754 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.9974   -1.2386    0.3681 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.4237   -0.7454    1.4476 O   0  0  0  0  0  0  0  0  0  0  0  0
    2.1758   -0.3790   -0.4237 N   0  0  0  0  0  0  0  0  0  0  0  0
    1.1640    0.3693    0.2624 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.1514    0.0875   -0.0683 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.1313    1.0662   -0.0287 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.9385    2.1341    0.8272 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.3765    2.4475    1.1391 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.4419    1.6374    0.7640 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.7359    2.1524    0.6086 O   0  0  0  0  0  0  0  0  0  0  0  0
    2.7589    3.0152   -0.6993 C   0  0  1  0  0  0  0  0  0  0  0  0
    2.7082    4.4374    0.1792 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.0628    4.4777    0.7539 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.6995    3.2778    0.5697 O   0  0  0  0  0  0  0  0  0  0  0  0
    4.4326    3.0349   -0.7542 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.9028    3.0711    1.0037 N   0  0  0  0  0  0  0  0  0  0  0  0
   -3.1316    2.7664    0.5824 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.2887    1.8420   -0.3958 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3191    0.9509   -0.7103 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.6917   -0.3605   -1.1512 N   0  0  0  0  0  0  0  0  0  0  0  0
   -4.0239   -0.8568   -0.9636 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.0420    0.0155   -1.3296 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.2808   -0.0225   -0.7042 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.4213   -0.8936    0.3694 C   0  0  0  0  0  0  0  0  0  0  0  0
   -7.4037   -0.7520    1.2931 F   0  0  0  0  0  0  0  0  0  0  0  0
   -5.5569   -1.9667    0.5509 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.2137   -3.5154    1.0685 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -4.3188   -1.8650   -0.0656 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  2  4  1  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  7  9  1  0  0  0  0
  9 10  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 12 13  2  0  0  0  0
 13 14  1  0  0  0  0
 13 22  1  0  0  0  0
 14 15  2  0  0  0  0
 15 16  1  0  0  0  0
 15 10  1  0  0  0  0
 17 16  1  1  0  0  0
 17 18  1  0  0  0  0
 18 19  1  0  0  0  0
 19 20  1  0  0  0  0
 20 21  1  0  0  0  0
 21 17  1  0  0  0  0
 22 23  2  0  0  0  0
 23 24  1  0  0  0  0
 24 25  2  0  0  0  0
 25 26  1  0  0  0  0
 25 12  1  0  0  0  0
 26 27  1  0  0  0  0
 27 28  2  0  0  0  0
 28 29  1  0  0  0  0
 29 30  2  0  0  0  0
 30 31  1  0  0  0  0
 30 32  1  0  0  0  0
 32 33  1  0  0  0  0
 32 34  2  0  0  0  0
 34 27  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000003976838

>  <smiles>
CN(C)C/C=C/C(=O)Nc1cc2c(Nc3ccc(F)c(Cl)c3)ncnc2cc1O[C@H]1CCOC1

$$$$

 OpenBabel10312015333D

 31 34  0  0  0  0  0  0  0  0999 V2000
    3.4750    2.3836   -0.3772 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.6285    1.6871   -1.2773 O   0  0  0  0  0  0  0  0  0  0  0  0
    1.3330    1.3250   -0.8957 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.3499    2.3058   -0.9025 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.7050    2.1643   -0.0195 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.6483    3.1112    0.0751 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.6017    2.9883    1.0056 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.8758    1.7695    1.4949 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.0211    0.7236    1.3952 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.6317   -0.5700    1.3903 N   0  0  0  0  0  0  0  0  0  0  0  0
   -3.5952   -0.9168    0.3893 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.0185    0.0336   -0.5227 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.3352    0.0985   -0.9615 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.2682   -0.8035   -0.4784 C   0  0  0  0  0  0  0  0  0  0  0  0
   -7.5446   -0.3877   -0.2414 F   0  0  0  0  0  0  0  0  0  0  0  0
   -5.7484   -1.9497    0.1116 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.8754   -3.2138    0.5149 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -4.4527   -1.9830    0.6119 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.8720    0.9629    0.6529 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.0351   -0.1054    0.3608 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.0493    0.0241   -0.4985 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.1154   -0.8470   -0.4424 O   0  0  0  0  0  0  0  0  0  0  0  0
    2.3743   -1.8747   -1.3595 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.5970   -1.6610   -2.1957 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.8062   -1.2256   -1.4287 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.6062   -1.1289   -0.0088 N   0  0  0  0  0  0  0  0  0  0  0  0
    5.6508   -1.9338    0.6222 C   0  0  0  0  0  0  0  0  0  0  0  0
    7.0262   -1.5402    0.1138 C   0  0  0  0  0  0  0  0  0  0  0  0
    7.0151   -0.3079   -0.5322 O   0  0  0  0  0  0  0  0  0  0  0  0
    6.3242    0.6205    0.2219 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.8777    0.2509    0.3870 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  9 10  1  0  0  0  0
  9 19  2  0  0  0  0
 10 11  1  0  0  0  0
 11 12  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 14 16  1  0  0  0  0
 16 17  1  0  0  0  0
 16 18  2  0  0  0  0
 18 11  1  0  0  0  0
 19 20  1  0  0  0  0
 19  5  1  0  0  0  0
 20 21  2  0  0  0  0
 21 22  1  0  0  0  0
 21  3  1  0  0  0  0
 22 23  1  0  0  0  0
 23 24  1  0  0  0  0
 24 25  1  0  0  0  0
 25 26  1  0  0  0  0
 26 27  1  0  0  0  0
 27 28  1  0  0  0  0
 28 29  1  0  0  0  0
 29 30  1  0  0  0  0
 30 31  1  0  0  0  0
 31 26  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000019632614

>  <smiles>
COc1cc2ncnc(Nc3ccc(F)c(Cl)c3)c2cc1OCCCN1CCOCC1

$$$$

 OpenBabel10312015333D

 34 37  0  0  0  0  0  0  0  0999 V2000
    0.9021   -4.5481   -1.0383 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.2355   -3.7843   -2.0753 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.7127   -2.4258   -2.1085 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.5228   -2.2406   -2.3289 O   0  0  0  0  0  0  0  0  0  0  0  0
    1.4372   -1.2873   -1.6713 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.8643   -0.3529   -0.7457 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.4505    0.0646   -0.8398 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.2448    0.2825    0.2796 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.7582   -0.0455    1.5401 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.6131   -0.1666    1.6661 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.3928   -0.3934    0.5386 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.7030   -0.8493    0.7090 O   0  0  0  0  0  0  0  0  0  0  0  0
    3.6398   -0.6887   -0.3533 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.7755   -1.6658   -0.2362 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.1172   -1.0132   -0.0659 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.9953    0.3772    0.2892 N   0  0  0  0  0  0  0  0  0  0  0  0
    6.5982    0.6079    1.5745 C   0  0  0  0  0  0  0  0  0  0  0  0
    8.0995    0.7033    1.4089 C   0  0  0  0  0  0  0  0  0  0  0  0
    8.3342    1.8657    0.6564 O   0  0  0  0  0  0  0  0  0  0  0  0
    7.9091    1.6190   -0.6395 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.4483    1.2800   -0.7360 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.6219   -0.5375    2.4569 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.9348   -0.7264    2.1895 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.4500   -0.3318    1.0025 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.6211    0.3043    0.1545 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.1523    0.9306   -0.9964 N   0  0  0  0  0  0  0  0  0  0  0  0
   -4.4816    1.4471   -0.8990 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.2378    1.6300   -2.0381 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.6047    1.7617   -1.9606 C   0  0  0  0  0  0  0  0  0  0  0  0
   -7.2491    1.6068   -0.7456 C   0  0  0  0  0  0  0  0  0  0  0  0
   -8.5469    1.2575   -0.6420 F   0  0  0  0  0  0  0  0  0  0  0  0
   -6.5120    1.6207    0.4239 C   0  0  0  0  0  0  0  0  0  0  0  0
   -7.2595    2.0943    1.9318 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -5.1299    1.6042    0.3089 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  2  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  3  5  1  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
  9 22  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 11  6  1  0  0  0  0
 12 13  1  0  0  0  0
 13 14  1  0  0  0  0
 14 15  1  0  0  0  0
 15 16  1  0  0  0  0
 16 17  1  0  0  0  0
 17 18  1  0  0  0  0
 18 19  1  0  0  0  0
 19 20  1  0  0  0  0
 20 21  1  0  0  0  0
 21 16  1  0  0  0  0
 22 23  2  0  0  0  0
 23 24  1  0  0  0  0
 24 25  2  0  0  0  0
 25 26  1  0  0  0  0
 25  8  1  0  0  0  0
 26 27  1  0  0  0  0
 27 28  2  0  0  0  0
 28 29  1  0  0  0  0
 29 30  2  0  0  0  0
 30 31  1  0  0  0  0
 30 32  1  0  0  0  0
 32 33  1  0  0  0  0
 32 34  2  0  0  0  0
 34 27  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000027439698

>  <smiles>
C=CC(=O)Nc1cc2c(Nc3ccc(F)c(Cl)c3)ncnc2cc1OCCCN1CCOCC1

$$$$

 OpenBabel10312015333D

 11 12  0  0  0  0  0  0  0  0999 V2000
    3.0904   -1.0324    0.7239 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.0614   -0.3344    0.0122 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.9756    1.0466    0.0119 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.6977    1.5910    0.0745 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.4400    0.8518   -0.1128 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.6769    1.1994    0.3891 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.5098    0.1998    0.7753 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.5374   -0.8887   -0.0322 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.3929   -1.1802   -0.6920 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.2686   -0.4454   -0.5658 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.0006   -1.0074   -0.5843 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  2  0  0  0  0
  3  4  1  0  0  0  0
  4  5  2  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
 10 11  2  0  0  0  0
 10  5  1  0  0  0  0
 11  2  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000029544518

>  <smiles>
Nc1ccc2cncnc2c1

$$$$

 OpenBabel10312015333D

 29 31  0  0  0  0  0  0  0  0999 V2000
    7.5448    1.0977    0.0685 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.8053    1.9495   -0.8596 N   0  0  0  0  0  0  0  0  0  0  0  0
    7.3422    3.2978   -0.6883 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.4330    2.0020   -0.3620 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.6175    0.8704   -0.8472 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.6360   -0.3322   -0.3188 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.4322   -1.1577   -0.1617 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.4735   -2.3383   -0.5828 O   0  0  0  0  0  0  0  0  0  0  0  0
    2.4630   -0.8387    0.8264 N   0  0  0  0  0  0  0  0  0  0  0  0
    1.2769   -1.5943    1.0326 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.3038   -2.8585    1.6104 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.4113   -3.8160    1.1471 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.7562   -3.3428    0.5594 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.6830   -4.1908    0.0807 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.7232   -3.7018   -0.6222 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.9997   -2.3961   -0.5962 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.1781   -1.4679   -0.0463 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.7292   -0.3285    0.5939 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.9993    0.9048   -0.0426 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.7609    2.0647    0.6858 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.4375    3.2366    0.4965 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.6452    4.4810    1.6920 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -4.1222    3.3790   -0.7028 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.5354    4.9714   -1.3297 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -4.4145    2.2364   -1.4380 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.9816    0.9848   -1.0186 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.8027   -0.0658   -1.3105 F   0  0  0  0  0  0  0  0  0  0  0  0
   -0.9781   -1.9754    0.4399 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.0071   -1.0712    0.8177 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  2  4  1  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  7  9  1  0  0  0  0
  9 10  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 12 13  2  0  0  0  0
 13 14  1  0  0  0  0
 14 15  2  0  0  0  0
 15 16  1  0  0  0  0
 16 17  2  0  0  0  0
 17 18  1  0  0  0  0
 17 28  1  0  0  0  0
 18 19  1  0  0  0  0
 19 20  2  0  0  0  0
 20 21  1  0  0  0  0
 21 22  1  0  0  0  0
 21 23  2  0  0  0  0
 23 24  1  0  0  0  0
 23 25  1  0  0  0  0
 25 26  2  0  0  0  0
 26 27  1  0  0  0  0
 26 19  1  0  0  0  0
 28 29  2  0  0  0  0
 28 13  1  0  0  0  0
 29 10  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000013671607

>  <smiles>
CN(C)C/C=C/C(=O)Nc1ccc2ncnc(Nc3cc(Cl)c(Cl)cc3F)c2c1

$$$$

 OpenBabel10312015333D

 20 22  0  0  0  0  0  0  0  0999 V2000
   -2.7689    3.3129   -0.3594 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.5708    1.9508    0.0265 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.9675    0.8866   -0.7746 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3597   -0.3478   -0.6311 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.8915   -1.4863   -1.1370 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.0847   -2.5735   -1.2084 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.7849   -2.4607   -0.8777 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.3625   -1.4463   -0.0849 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.7047   -1.6607    0.8415 N   0  0  0  0  0  0  0  0  0  0  0  0
    1.9685   -1.0828    0.4901 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.9783   -1.9151    0.0275 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.0125   -1.3322   -0.6924 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.2859    0.0276   -0.6062 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.3384    0.8563   -0.0201 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.3579    2.7536   -0.2808 Br  0  0  0  0  0  0  0  0  0  0  0  0
    2.1994    0.2675    0.4950 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.2231   -0.4088    0.1579 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.0663    0.4865    1.2090 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.8521    1.6205    1.1697 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.9136    2.5519    2.2553 N   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  2  0  0  0  0
  3  4  1  0  0  0  0
  4  5  2  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  1  0  0  0  0
  8 17  2  0  0  0  0
  9 10  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 12 13  2  0  0  0  0
 13 14  1  0  0  0  0
 14 15  1  0  0  0  0
 14 16  2  0  0  0  0
 16 10  1  0  0  0  0
 17 18  1  0  0  0  0
 17  4  1  0  0  0  0
 18 19  2  0  0  0  0
 19 20  1  0  0  0  0
 19  2  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000002391776

>  <smiles>
Nc1cc2ncnc(Nc3cccc(Br)c3)c2cc1N

$$$$

 OpenBabel10312015333D

 23 25  0  0  0  0  0  0  0  0999 V2000
    4.6865   -1.7925   -0.7451 O   0  0  0  0  0  0  0  0  0  0  0  0
    4.9339   -0.7456   -0.0802 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.3020   -0.2709    0.2254 C   0  0  0  0  0  0  0  0  0  0  0  0
    7.4307   -1.3050   -0.6815 Cl  0  0  0  0  0  0  0  0  0  0  0  0
    3.7966   -0.1102    0.4924 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.6047    0.0705   -0.2852 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.5689    0.9853   -1.3317 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.5224    1.8882   -1.4807 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.3768    1.7476   -0.7070 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.5186    2.7264   -0.5353 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.3757    2.6299    0.4924 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.6980    1.3946    0.9503 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.8476    0.3453    0.8374 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.3114   -1.0103    0.8879 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.5984   -1.2353    0.2970 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.9580   -0.6293   -0.9010 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.2881   -0.4051   -1.2384 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.2010   -0.2738   -0.1990 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.9313   -1.0281    0.9312 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.4488   -1.7215    2.2165 I   0  0  0  0  0  0  0  0  0  0  0  0
   -3.6649   -1.5679    1.1240 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.2675    0.5808    0.0410 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.3518   -0.2731    0.2130 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  2  0  0  0  0
  2  3  1  0  0  0  0
  2  5  1  0  0  0  0
  3  4  1  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 12 13  2  0  0  0  0
 13 14  1  0  0  0  0
 13 22  1  0  0  0  0
 14 15  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 17 18  2  0  0  0  0
 18 19  1  0  0  0  0
 19 20  1  0  0  0  0
 19 21  2  0  0  0  0
 21 15  1  0  0  0  0
 22 23  2  0  0  0  0
 22  9  1  0  0  0  0
 23  6  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000013671605

>  <smiles>
O=C(CCl)Nc1ccc2ncnc(Nc3cccc(I)c3)c2c1

$$$$

 OpenBabel10312015333D

 19 21  0  0  0  0  0  0  0  0999 V2000
   -1.6970    3.3369   -0.5029 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.6828    2.0721    0.1487 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.8870    1.0377   -0.3230 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.3431   -0.2596   -0.1391 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.5131   -0.4899    0.5685 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0607    0.5431    1.2885 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.5660    1.7953    1.1353 N   0  0  0  0  0  0  0  0  0  0  0  0
   -3.2229   -1.5813    0.1880 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.5680   -2.6649   -0.2780 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.3386   -2.5038   -0.8028 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.6509   -1.3545   -0.5961 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.6172   -1.2009   -1.1984 N   0  0  0  0  0  0  0  0  0  0  0  0
    1.7939   -0.8127   -0.5060 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.9280   -1.1115    0.8395 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.8121   -0.4051    1.6347 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.5563    0.5824    1.0485 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.6497    0.7431   -0.3254 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.3684    2.3409   -1.1066 Br  0  0  0  0  0  0  0  0  0  0  0  0
    2.8044   -0.0674   -1.0733 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  2  0  0  0  0
  3  4  1  0  0  0  0
  4  5  2  0  0  0  0
  5  6  1  0  0  0  0
  5  8  1  0  0  0  0
  6  7  2  0  0  0  0
  7  2  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 11  4  1  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 17 18  1  0  0  0  0
 17 19  2  0  0  0  0
 19 13  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000021289041

>  <smiles>
Nc1cc2c(Nc3cccc(Br)c3)ncnc2cn1

$$$$

 OpenBabel10312015333D

 20 22  0  0  0  0  0  0  0  0999 V2000
   -4.8592    2.4969    0.6759 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.9837    1.2130   -0.0031 N   0  0  0  0  0  0  0  0  0  0  0  0
   -3.8540    0.5034   -0.4975 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.6135   -0.7993   -0.0798 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3299   -1.2602    0.0772 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.0099   -2.3943    0.7102 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.7176   -2.7465    0.8763 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.2925   -2.0534    0.3306 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.0092   -0.9321   -0.3388 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.0466   -0.0037   -0.5568 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.1886    0.1563    0.2587 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.9287   -0.8974    0.7685 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.3185   -0.8810    0.7392 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.0106    0.2337    0.2804 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.2721    1.4056    0.2620 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.0732    3.1283    0.4113 Br  0  0  0  0  0  0  0  0  0  0  0  0
    2.8927    1.3455    0.1057 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.2827   -0.4313   -0.2771 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.5644    0.7067   -0.9878 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.8177    1.2097   -0.9873 N   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  9 10  1  0  0  0  0
  9 18  2  0  0  0  0
 10 11  1  0  0  0  0
 11 12  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 15 16  1  0  0  0  0
 15 17  2  0  0  0  0
 17 11  1  0  0  0  0
 18 19  1  0  0  0  0
 18  5  1  0  0  0  0
 19 20  2  0  0  0  0
 20  3  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000021289044

>  <smiles>
CNc1cc2ncnc(Nc3cccc(Br)c3)c2cn1

$$$$

 OpenBabel10312015333D

 34 37  0  0  0  0  0  0  0  0999 V2000
   -0.1951   -1.0768   -5.0438 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.4685   -0.1152   -4.4054 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.0991   -0.4251   -3.1159 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.3687   -1.6304   -2.8267 O   0  0  0  0  0  0  0  0  0  0  0  0
    1.1293    0.4882   -2.0297 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.6727    0.1238   -0.7214 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.5337    0.5247   -0.2854 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.0217    0.0276    0.8651 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.3414   -1.0449    1.4274 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.9819   -1.3222    1.1072 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.5413   -0.6411    0.0330 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.9756   -0.3315    0.0255 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.4938    0.5838   -0.7562 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.6078    1.4884   -0.3737 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.8360    1.5134    1.1140 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.1389    0.9473    1.4575 N   0  0  0  0  0  0  0  0  0  0  0  0
    5.8783   -0.0963    2.4445 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.4709   -1.4232    2.0355 C   0  0  0  0  0  0  0  0  0  0  0  0
    7.7970   -1.2404    1.6516 O   0  0  0  0  0  0  0  0  0  0  0  0
    7.8935   -0.4889    0.4961 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.6473    0.3139    0.2514 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.9896   -1.7884    2.3405 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.2226   -1.4341    2.7294 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.8773   -0.3621    2.2220 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3523    0.2919    1.1573 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0692    1.2955    0.4529 N   0  0  0  0  0  0  0  0  0  0  0  0
   -4.4624    1.1777    0.2022 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.1559    2.2756   -0.2838 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.4322    2.1019   -0.8049 C   0  0  0  0  0  0  0  0  0  0  0  0
   -7.0849    0.8787   -0.7429 C   0  0  0  0  0  0  0  0  0  0  0  0
   -8.2197    0.6441   -1.4349 F   0  0  0  0  0  0  0  0  0  0  0  0
   -6.5034   -0.0928    0.0561 C   0  0  0  0  0  0  0  0  0  0  0  0
   -7.3599   -1.5924    0.3672 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -5.1791    0.0233    0.3886 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  2  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  3  5  1  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
  9 22  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 11  6  1  0  0  0  0
 12 13  2  0  0  0  0
 13 14  1  0  0  0  0
 14 15  1  0  0  0  0
 15 16  1  0  0  0  0
 16 17  1  0  0  0  0
 17 18  1  0  0  0  0
 18 19  1  0  0  0  0
 19 20  1  0  0  0  0
 20 21  1  0  0  0  0
 21 16  1  0  0  0  0
 22 23  2  0  0  0  0
 23 24  1  0  0  0  0
 24 25  2  0  0  0  0
 25 26  1  0  0  0  0
 25  8  1  0  0  0  0
 26 27  1  0  0  0  0
 27 28  2  0  0  0  0
 28 29  1  0  0  0  0
 29 30  2  0  0  0  0
 30 31  1  0  0  0  0
 30 32  1  0  0  0  0
 32 33  1  0  0  0  0
 32 34  2  0  0  0  0
 34 27  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000013806963

>  <smiles>
C=CC(=O)Nc1nc2c(Nc3ccc(F)c(Cl)c3)ncnc2cc1/C=C/CCN1CCOCC1

$$$$

 OpenBabel10312015333D

 34 37  0  0  0  0  0  0  0  0999 V2000
    3.4624   -1.9533    2.4988 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.1035   -2.7658    1.5061 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.7699   -2.6232    0.9100 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.7596   -2.8074    1.6521 O   0  0  0  0  0  0  0  0  0  0  0  0
    1.5433   -1.8092   -0.2467 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.4395   -0.8988   -0.3182 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.8357   -1.2944   -0.0840 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.6726   -0.4399    0.5376 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.2610    0.7927    1.0287 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.0620    1.3142    0.5547 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.7488    0.4476   -0.1664 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.8456    0.9693   -0.9577 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.7165    0.1896   -1.5494 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.7078    0.8517   -2.4555 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.0657    0.2858   -2.0626 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.1377    0.3335   -0.6206 N   0  0  0  0  0  0  0  0  0  0  0  0
    5.4915    1.6891   -0.2239 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.8193    1.5896    0.5169 C   0  0  0  0  0  0  0  0  0  0  0  0
    7.7226    1.0335   -0.4023 O   0  0  0  0  0  0  0  0  0  0  0  0
    7.4762   -0.3461   -0.4143 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.0285   -0.6564   -0.0748 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.7796    1.1887    2.2173 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.9801    0.6965    2.6041 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.6084   -0.1788    1.7821 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.9210   -0.9332    0.8921 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.6581   -1.7496   -0.1227 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.8055   -0.8968   -0.5664 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.8812   -0.6597    0.2811 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.5753    0.5442    0.2616 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.0741    1.6201   -0.4573 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.9432    2.6464   -0.6879 F   0  0  0  0  0  0  0  0  0  0  0  0
   -5.2055    1.2972   -1.4929 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.9037    2.5039   -2.7370 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -4.6715    0.0191   -1.6025 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  2  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  3  5  1  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
  9 22  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 11  6  1  0  0  0  0
 12 13  2  0  0  0  0
 13 14  1  0  0  0  0
 14 15  1  0  0  0  0
 15 16  1  0  0  0  0
 16 17  1  0  0  0  0
 17 18  1  0  0  0  0
 18 19  1  0  0  0  0
 19 20  1  0  0  0  0
 20 21  1  0  0  0  0
 21 16  1  0  0  0  0
 22 23  2  0  0  0  0
 23 24  1  0  0  0  0
 24 25  2  0  0  0  0
 25 26  1  0  0  0  0
 25  8  1  0  0  0  0
 26 27  1  0  0  0  0
 27 28  2  0  0  0  0
 28 29  1  0  0  0  0
 29 30  2  0  0  0  0
 30 31  1  0  0  0  0
 30 32  1  0  0  0  0
 32 33  1  0  0  0  0
 32 34  2  0  0  0  0
 34 27  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000045505867

>  <smiles>
C=CC(=O)Nc1nc2c(Cc3ccc(F)c(Cl)c3)ncnc2cc1/C=C/CCN1CCOCC1

$$$$`;
    },
    set50Compounds() {
      this.resetToDefault();
      this.textarea = `
 OpenBabel10312015333D

 22 25  0  0  0  0  0  0  0  0999 V2000
   -4.7445    1.7572    0.7582 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.2994    0.7076   -0.1517 N   0  0  0  0  0  0  0  0  0  0  0  0
   -4.9649    0.0619   -1.1129 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.2921   -1.0576   -1.4747 N   0  0  0  0  0  0  0  0  0  0  0  0
   -3.1821   -1.1246   -0.7037 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3093   -2.1397   -0.3319 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.1317   -1.7137    0.2647 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.1733   -2.5853    0.6387 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.9781   -2.1810    1.2171 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.3222   -0.9020    1.0426 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.4362    0.0765    0.7349 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.9219    1.2717    0.1153 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.3256    1.5588    0.1611 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.7939    2.4508    1.1161 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.0027    2.2263    1.7649 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.8559    1.2789    1.2660 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.5026    0.4741    0.1894 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.4644   -1.1620   -0.0930 Br  0  0  0  0  0  0  0  0  0  0  0  0
    3.2485    0.6771   -0.3676 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.8439   -0.3657    0.4384 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.8270    0.5711    0.2832 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0836    0.1196   -0.0922 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  9 10  2  0  0  0  0
 10 11  1  0  0  0  0
 11 12  1  0  0  0  0
 11 20  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 17 18  1  0  0  0  0
 17 19  2  0  0  0  0
 19 13  1  0  0  0  0
 20 21  1  0  0  0  0
 20  7  1  0  0  0  0
 21 22  2  0  0  0  0
 22  2  1  0  0  0  0
 22  5  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000003815030

>  <smiles>
Cn1cnc2cc3ncnc(Nc4cccc(Br)c4)c3cc21

$$$$

 OpenBabel10312015333D

 22 24  0  0  0  0  0  0  0  0999 V2000
   -5.1006   -0.2083   -1.4236 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.9407    0.5310   -0.2154 O   0  0  0  0  0  0  0  0  0  0  0  0
   -3.6504    0.5319    0.3228 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.8345    1.6412    0.1355 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.4589    1.5107    0.0166 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.7000    2.4346   -0.6209 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.4269    2.0953   -1.2918 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.9960    0.8837   -1.0801 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.4169    0.1039   -0.1376 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.1630   -0.9852    0.4167 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.5903   -0.9777    0.2911 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.1185   -1.9498   -0.5464 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.4463   -1.8757   -0.9353 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.1618   -0.6904   -0.8279 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.5160    0.3874   -0.2704 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.2348    2.1540   -0.3890 Br  0  0  0  0  0  0  0  0  0  0  0  0
    3.2994    0.2111    0.3771 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.8443    0.3115    0.3500 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.6481   -0.7546    0.6682 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0341   -0.6580    0.6906 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.8189   -1.8074    0.5544 O   0  0  0  0  0  0  0  0  0  0  0  0
   -3.3394   -2.8891   -0.2302 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  9 10  1  0  0  0  0
  9 18  2  0  0  0  0
 10 11  1  0  0  0  0
 11 12  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 15 16  1  0  0  0  0
 15 17  2  0  0  0  0
 17 11  1  0  0  0  0
 18 19  1  0  0  0  0
 18  5  1  0  0  0  0
 19 20  2  0  0  0  0
 20 21  1  0  0  0  0
 20  3  1  0  0  0  0
 21 22  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000000600292

>  <smiles>
COc1cc2ncnc(Nc3cccc(Br)c3)c2cc1OC

$$$$

 OpenBabel10312015333D

 22 25  0  0  0  0  0  0  0  0999 V2000
   -3.7381    1.6179    2.6126 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.3313    1.6756    1.2297 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.9777    2.8220    0.6165 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.6286    2.4522   -0.6335 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.4005    1.1180   -0.6776 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.4342    0.3832   -1.3548 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.1128   -0.8984   -0.9364 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.9698   -1.4856   -0.0162 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.9526   -0.7494    0.6346 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0498    0.6182    0.4439 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.5910   -2.6995    0.4485 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.5156   -3.3373   -0.0611 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.3606   -2.6866   -0.8590 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.1970   -1.3567   -1.0259 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.2630   -0.5046   -1.4564 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.3599   -0.2167   -0.5827 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.3885   -0.7589    0.6914 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.5688   -0.6259    1.4074 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.5246    0.2732    1.0151 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.2873    1.0968   -0.0752 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.4679    2.5307   -0.4553 Br  0  0  0  0  0  0  0  0  0  0  0  0
    3.2845    0.7319   -0.9657 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  8 11  1  0  0  0  0
  9 10  2  0  0  0  0
 10  2  1  0  0  0  0
 10  5  1  0  0  0  0
 11 12  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 14  7  1  0  0  0  0
 15 16  1  0  0  0  0
 16 17  2  0  0  0  0
 17 18  1  0  0  0  0
 18 19  2  0  0  0  0
 19 20  1  0  0  0  0
 20 21  1  0  0  0  0
 20 22  2  0  0  0  0
 22 16  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000002391775

>  <smiles>
Cn1cnc2cc3c(Nc4cccc(Br)c4)ncnc3cc21

$$$$

 OpenBabel10312015333D

 34 36  0  0  0  0  0  0  0  0999 V2000
    8.3527    3.0433    1.2856 C   0  0  0  0  0  0  0  0  0  0  0  0
    7.6887    2.2563    0.6391 C   0  0  0  0  0  0  0  0  0  0  0  0
    7.3961    0.9113    0.1120 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.1551    0.3908    0.6648 N   0  0  0  0  0  0  0  0  0  0  0  0
    5.6091   -0.5200   -0.3116 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.4989   -1.3062    0.3123 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.8993   -2.3021   -0.3046 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.4393   -2.4590   -0.2534 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.9429   -2.4291    0.9128 O   0  0  0  0  0  0  0  0  0  0  0  0
    1.5772   -2.0690   -1.3087 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.5263   -1.1074   -1.1417 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.5540   -1.3365   -0.2994 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.0522   -0.2841    0.4598 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.4684    0.9775    0.4353 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.3847    1.2629   -0.6231 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.7628    0.2234   -1.4657 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.7262    0.4580   -2.4247 O   0  0  0  0  0  0  0  0  0  0  0  0
    2.0658   -0.4960   -3.4015 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.0944   -0.4884   -4.5525 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.5855    1.7381    1.5237 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.3318    1.3479    2.5864 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.0563    0.1818    2.5760 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0120   -0.1512    3.5856 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.5046   -0.6520    4.5164 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.9702   -0.6238    1.4470 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0500   -1.4785    1.0488 N   0  0  0  0  0  0  0  0  0  0  0  0
   -4.1291   -0.8868    0.3153 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.1855   -0.2580    0.9292 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.6585    0.9755    0.4987 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.3529    1.3711   -0.7941 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.5871    2.6483   -1.1866 F   0  0  0  0  0  0  0  0  0  0  0  0
   -4.5433    0.5758   -1.5653 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.2710    0.9178   -3.2582 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -3.8070   -0.4317   -0.9575 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  3  0  0  0  0
  2  3  1  0  0  0  0
  3  4  1  0  0  0  0
  4  5  1  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  8 10  1  0  0  0  0
 10 11  1  0  0  0  0
 11 12  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 14 20  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 16 11  1  0  0  0  0
 17 18  1  0  0  0  0
 18 19  1  0  0  0  0
 20 21  2  0  0  0  0
 21 22  1  0  0  0  0
 22 23  1  0  0  0  0
 22 25  2  0  0  0  0
 23 24  3  0  0  0  0
 25 26  1  0  0  0  0
 25 13  1  0  0  0  0
 26 27  1  0  0  0  0
 27 28  2  0  0  0  0
 28 29  1  0  0  0  0
 29 30  2  0  0  0  0
 30 31  1  0  0  0  0
 30 32  1  0  0  0  0
 32 33  1  0  0  0  0
 32 34  2  0  0  0  0
 34 27  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000064564721

>  <smiles>
C#CCNC/C=C/C(=O)Nc1cc2c(Nc3ccc(F)c(Cl)c3)c(C#N)cnc2cc1OCC

$$$$

 OpenBabel10312015333D

 25 27  0  0  0  0  0  0  0  0999 V2000
    3.6989    3.8425    1.1264 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.7120    3.0818    0.7140 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.3986    2.0177   -0.2400 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.5317    2.1577   -1.4814 O   0  0  0  0  0  0  0  0  0  0  0  0
    3.7921    0.8318    0.2235 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.9118    0.0300   -0.5737 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.4100   -0.9350   -1.4416 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.7791   -2.1705   -1.5264 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.5412   -2.3948   -0.9568 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.1644   -3.6319   -0.5566 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.3202   -3.8265    0.4848 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.4893   -2.8205    0.8599 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.2530   -1.5993    0.3384 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.9822   -0.4970    0.8664 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.2460   -0.0932    0.3251 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3633    1.1515   -0.2804 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.5730    1.8152   -0.2756 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.8765    3.0604   -1.4826 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -4.6447    1.3480    0.4538 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.9899    2.4107    0.7594 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -4.5300    0.1501    1.1196 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.3711   -0.5978    0.9605 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.3951   -1.9238    1.2368 F   0  0  0  0  0  0  0  0  0  0  0  0
    0.8900   -1.3071   -0.3933 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.5642   -0.1000   -0.2604 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  2  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  3  5  1  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 12 13  2  0  0  0  0
 13 14  1  0  0  0  0
 13 24  1  0  0  0  0
 14 15  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 17 18  1  0  0  0  0
 17 19  2  0  0  0  0
 19 20  1  0  0  0  0
 19 21  1  0  0  0  0
 21 22  2  0  0  0  0
 22 23  1  0  0  0  0
 22 15  1  0  0  0  0
 24 25  2  0  0  0  0
 24  9  1  0  0  0  0
 25  6  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000013671593

>  <smiles>
C=CC(=O)Nc1ccc2ncnc(Nc3cc(Cl)c(Cl)cc3F)c2c1

$$$$

 OpenBabel10312015333D

 25 27  0  0  0  0  0  0  0  0999 V2000
   -3.6522    2.9414    0.4116 O   0  0  0  0  0  0  0  0  0  0  0  0
   -4.4292    2.2420   -0.2910 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.8636    2.6082   -0.5077 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.8754    2.0257    0.8455 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -3.8741    1.0205   -0.7914 N   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0628    0.1990    0.0567 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.6260   -0.8284    0.8046 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0254   -2.0715    0.9190 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.7102   -2.2058    0.4924 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.1325   -3.4274    0.4187 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.2135   -3.4832    0.3457 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.9256   -2.3895    0.0703 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.3613   -1.1771   -0.1425 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.1047    0.0395   -0.0155 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.5031    0.0879   -0.2313 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.9726    0.7631   -1.3502 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.3221    1.0503   -1.4979 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.8126    2.1827   -2.7497 Cl  0  0  0  0  0  0  0  0  0  0  0  0
    5.1028    0.8624   -0.3632 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.7048    1.5741   -0.3256 Cl  0  0  0  0  0  0  0  0  0  0  0  0
    4.7323   -0.0098    0.6468 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.3691   -0.2167    0.8087 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.8492   -0.7724    1.9268 F   0  0  0  0  0  0  0  0  0  0  0  0
   -1.0079   -1.0852    0.0685 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.7145    0.0704   -0.2328 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  2  0  0  0  0
  2  3  1  0  0  0  0
  2  5  1  0  0  0  0
  3  4  1  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 12 13  2  0  0  0  0
 13 14  1  0  0  0  0
 13 24  1  0  0  0  0
 14 15  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 17 18  1  0  0  0  0
 17 19  2  0  0  0  0
 19 20  1  0  0  0  0
 19 21  1  0  0  0  0
 21 22  2  0  0  0  0
 22 23  1  0  0  0  0
 22 15  1  0  0  0  0
 24 25  2  0  0  0  0
 24  9  1  0  0  0  0
 25  6  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000013671601

>  <smiles>
O=C(CCl)Nc1ccc2ncnc(Nc3cc(Cl)c(Cl)cc3F)c2c1

$$$$

 OpenBabel10312015333D

 22 24  0  0  0  0  0  0  0  0999 V2000
    4.2204    3.3968   -0.1145 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.1985    2.0369   -0.4794 O   0  0  0  0  0  0  0  0  0  0  0  0
    3.3119    1.1065    0.0405 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.5149    1.4545    1.1216 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.4140    0.6621    1.3789 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.8738    0.5435    2.6138 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.3925    0.1004    2.7286 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.0885   -0.3254    1.6585 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.3706   -0.6580    0.5585 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.9853   -1.5113   -0.4142 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.4064   -1.6060   -0.5015 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0897   -1.4927   -1.7069 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.2671   -0.7583   -1.7939 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.8887   -0.3023   -0.6381 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.9316    1.2979   -0.6049 Br  0  0  0  0  0  0  0  0  0  0  0  0
   -4.4694   -0.9070    0.5408 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.2230   -1.5177    0.6205 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.9225   -0.2063    0.4132 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.6581   -0.5054   -0.7132 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.9220    0.0667   -0.7923 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.8412   -0.4492   -1.6979 O   0  0  0  0  0  0  0  0  0  0  0  0
    5.2356   -0.4257   -1.4619 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  9 10  1  0  0  0  0
  9 18  2  0  0  0  0
 10 11  1  0  0  0  0
 11 12  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 14 16  1  0  0  0  0
 16 17  2  0  0  0  0
 17 11  1  0  0  0  0
 18 19  1  0  0  0  0
 18  5  1  0  0  0  0
 19 20  2  0  0  0  0
 20 21  1  0  0  0  0
 20  3  1  0  0  0  0
 21 22  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000001386782

>  <smiles>
COc1cc2ncnc(Nc3ccc(Br)cc3)c2cc1OC

$$$$

 OpenBabel10312015333D

 23 25  0  0  0  0  0  0  0  0999 V2000
   -5.5945    1.8044    0.2797 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.2625    2.2269    0.0392 O   0  0  0  0  0  0  0  0  0  0  0  0
   -3.2822    1.3104   -0.3406 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.6136    0.0006   -0.6040 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.6539   -0.9962   -0.4817 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.9926   -2.2697   -0.1645 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.0661   -3.1646    0.2483 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.7952   -2.8949   -0.1100 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.3484   -1.6145   -0.0887 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.9330   -1.4076   -0.6697 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.0478   -0.9097    0.0826 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.7646   -1.7989    0.8744 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.9959   -1.4092    1.3598 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.6023   -0.2263    0.9603 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.4016    0.2080    1.3750 Br  0  0  0  0  0  0  0  0  0  0  0  0
    3.9250    0.5557    0.0344 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.4683    2.3708   -0.2374 Br  0  0  0  0  0  0  0  0  0  0  0  0
    2.8133    0.0457   -0.5752 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.3109   -0.6534   -0.3757 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.9530    0.6828   -0.2879 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.9493    1.6306   -0.1118 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.6566    2.9975   -0.0833 O   0  0  0  0  0  0  0  0  0  0  0  0
   -0.4731    3.5118    0.4951 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  9 10  1  0  0  0  0
  9 19  2  0  0  0  0
 10 11  1  0  0  0  0
 11 12  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 14 16  1  0  0  0  0
 16 17  1  0  0  0  0
 16 18  2  0  0  0  0
 18 11  1  0  0  0  0
 19 20  1  0  0  0  0
 19  5  1  0  0  0  0
 20 21  2  0  0  0  0
 21 22  1  0  0  0  0
 21  3  1  0  0  0  0
 22 23  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000003815032

>  <smiles>
COc1cc2ncnc(Nc3ccc(Br)c(Br)c3)c2cc1OC

$$$$

 OpenBabel10312015333D

 23 25  0  0  0  0  0  0  0  0999 V2000
    6.5192    0.0960    2.1045 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.1833    0.6190    0.9260 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.1191    0.0478    0.0949 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.3878   -0.7515   -0.8506 O   0  0  0  0  0  0  0  0  0  0  0  0
    3.7911    0.5465    0.1225 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.7032   -0.3271   -0.1860 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.7974   -1.7056   -0.0513 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.7510   -2.4051    0.5384 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.4637   -1.8920    0.4346 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.6191   -2.7015    0.4366 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.7598   -2.3882   -0.2236 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.8270   -1.1798   -0.8259 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.9711   -0.2169   -0.4569 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.2426    1.1666   -0.5124 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.6105    1.5853   -0.4550 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0129    2.8457   -0.8804 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.2460    3.3056   -0.4397 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.2594    2.3803   -0.2261 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.9551    1.0443   -0.1500 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.2864   -0.3196   -0.2196 Br  0  0  0  0  0  0  0  0  0  0  0  0
   -3.6429    0.6751   -0.2606 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.3015   -0.6104   -0.0658 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.4157    0.1855   -0.2881 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  2  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  3  5  1  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 12 13  2  0  0  0  0
 13 14  1  0  0  0  0
 13 22  1  0  0  0  0
 14 15  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 17 18  2  0  0  0  0
 18 19  1  0  0  0  0
 19 20  1  0  0  0  0
 19 21  2  0  0  0  0
 21 15  1  0  0  0  0
 22 23  2  0  0  0  0
 22  9  1  0  0  0  0
 23  6  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000001488208

>  <smiles>
C=CC(=O)Nc1ccc2ncnc(Nc3cccc(Br)c3)c2c1

$$$$

 OpenBabel10312015333D

 40 43  0  0  0  0  0  0  0  0999 V2000
    6.4753    1.5606   -2.9466 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.1130    0.9870   -3.2400 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.8107   -0.1257   -2.4326 O   0  0  0  0  0  0  0  0  0  0  0  0
    3.4680   -0.3169   -2.0962 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.4622   -0.2523   -3.0374 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.1580    0.0949   -2.7123 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.3561    0.7593   -3.5795 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.6406    1.5610   -3.1338 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.0573    1.5001   -1.8119 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.9399    2.4927   -1.2419 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3733    3.4408   -0.7192 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.3785    0.6082   -0.9988 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.9151    0.2801    0.2647 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.2230   -0.3029    0.3032 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.2159    0.1801    1.1463 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.5171    0.2645    0.6665 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.9655   -0.7132   -0.2007 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.2063   -0.5525   -0.7778 O   0  0  0  0  0  0  0  0  0  0  0  0
   -7.4173   -0.4588   -0.0716 C   0  0  0  0  0  0  0  0  0  0  0  0
   -7.1132   -0.3854    1.3745 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.9119   -1.5247    2.1431 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.6256   -1.4079    3.4978 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.5236   -0.1195    3.9848 C   0  0  0  0  0  0  0  0  0  0  0  0
   -7.3182    0.8311    3.3810 C   0  0  0  0  0  0  0  0  0  0  0  0
   -7.4729    0.7278    2.0451 N   0  0  0  0  0  0  0  0  0  0  0  0
   -4.0008   -1.5195   -0.7909 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.5775   -2.7060   -1.9416 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -2.6552   -1.1962   -0.6701 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.8344    0.0411   -1.3667 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.7754   -0.3273   -0.4150 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.1209   -0.3864   -0.7532 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.1413   -0.1078    0.2053 N   0  0  0  0  0  0  0  0  0  0  0  0
    4.9401   -1.1359    0.7910 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.3795   -2.2564    0.9414 O   0  0  0  0  0  0  0  0  0  0  0  0
    6.2462   -0.8228    1.3566 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.3320   -0.3434    2.5872 C   0  0  0  0  0  0  0  0  0  0  0  0
    7.3300    0.7083    2.9575 C   0  0  0  0  0  0  0  0  0  0  0  0
    8.6408    0.0874    2.7803 N   0  0  0  0  0  0  0  0  0  0  0  0
    8.5628   -1.3157    3.1669 C   0  0  0  0  0  0  0  0  0  0  0  0
    8.9019    0.0936    1.3447 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  1  0  0  0  0
  4  5  2  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
  9 12  1  0  0  0  0
 10 11  3  0  0  0  0
 12 13  1  0  0  0  0
 12 29  2  0  0  0  0
 13 14  1  0  0  0  0
 14 15  2  0  0  0  0
 15 16  1  0  0  0  0
 16 17  2  0  0  0  0
 17 18  1  0  0  0  0
 17 26  1  0  0  0  0
 18 19  1  0  0  0  0
 19 20  1  0  0  0  0
 20 21  2  0  0  0  0
 21 22  1  0  0  0  0
 22 23  2  0  0  0  0
 23 24  1  0  0  0  0
 24 25  2  0  0  0  0
 25 20  1  0  0  0  0
 26 27  1  0  0  0  0
 26 28  2  0  0  0  0
 28 14  1  0  0  0  0
 29 30  1  0  0  0  0
 29  6  1  0  0  0  0
 30 31  2  0  0  0  0
 31 32  1  0  0  0  0
 31  4  1  0  0  0  0
 32 33  1  0  0  0  0
 33 34  2  0  0  0  0
 33 35  1  0  0  0  0
 35 36  2  0  0  0  0
 36 37  1  0  0  0  0
 37 38  1  0  0  0  0
 38 39  1  0  0  0  0
 38 40  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000003916214

>  <smiles>
CCOc1cc2ncc(C#N)c(Nc3ccc(OCc4ccccn4)c(Cl)c3)c2cc1NC(=O)/C=C/CN(C)C

$$$$

 OpenBabel10312015333D

 21 23  0  0  0  0  0  0  0  0999 V2000
    5.6733    0.5363   -1.0097 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.3775    1.1452   -0.7342 N   0  0  0  0  0  0  0  0  0  0  0  0
    3.9310    2.3045   -1.4999 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.4902    0.4035    0.1046 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.3516   -0.9732    0.0161 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.0682   -1.4685    0.2191 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.6843   -2.6768   -0.2590 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.3858   -2.9941   -0.4604 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.5860   -2.1008   -0.1644 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.2884   -0.8983    0.3726 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.1962    0.1839    0.4203 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.4830    0.1873   -0.1563 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.3241   -0.9069   -0.1816 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.6921   -0.6649   -0.1440 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.2080    0.5468   -0.5855 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.3524    1.6279   -0.7343 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.0126    3.4203   -0.8960 Br  0  0  0  0  0  0  0  0  0  0  0  0
   -3.0138    1.3938   -0.5747 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.0448   -0.6440    0.6700 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.4455    0.5618    1.2305 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.7046    1.0162    1.0183 N   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  2  4  1  0  0  0  0
  4  5  2  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
 10 11  1  0  0  0  0
 10 19  2  0  0  0  0
 11 12  1  0  0  0  0
 12 13  2  0  0  0  0
 13 14  1  0  0  0  0
 14 15  2  0  0  0  0
 15 16  1  0  0  0  0
 16 17  1  0  0  0  0
 16 18  2  0  0  0  0
 18 12  1  0  0  0  0
 19 20  1  0  0  0  0
 19  6  1  0  0  0  0
 20 21  2  0  0  0  0
 21  4  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000021289037

>  <smiles>
CN(C)c1cc2ncnc(Nc3cccc(Br)c3)c2cn1

$$$$

 OpenBabel10312015333D

 23 25  0  0  0  0  0  0  0  0999 V2000
   -6.2622    1.6832    0.6181 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.2680    2.6975    0.0666 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.9329    2.0731   -0.1587 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.8502    2.6454    0.1710 O   0  0  0  0  0  0  0  0  0  0  0  0
   -3.7753    0.8813   -0.9382 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.8188   -0.0956   -0.5183 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.3561   -1.2507    0.0367 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.5394   -2.0424    0.8346 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.1829   -2.0347    0.5537 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.4291   -3.1403    0.7657 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.8777   -3.1458    0.4114 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.4276   -2.0571   -0.1774 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.7035   -0.9218   -0.3082 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.3530    0.3105   -0.6281 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.6732    0.5045   -0.1117 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.0066    0.0749    1.1662 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.3193    0.2854    1.5652 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.3263    0.5406    0.6427 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.9505    1.0683   -0.5839 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.2131    1.9096   -1.7525 Br  0  0  0  0  0  0  0  0  0  0  0  0
    3.6897    0.7555   -1.0258 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.6520   -0.8870   -0.0219 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.4736    0.1456   -0.4409 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  3  5  1  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 12 13  2  0  0  0  0
 13 14  1  0  0  0  0
 13 22  1  0  0  0  0
 14 15  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 17 18  2  0  0  0  0
 18 19  1  0  0  0  0
 19 20  1  0  0  0  0
 19 21  2  0  0  0  0
 21 15  1  0  0  0  0
 22 23  2  0  0  0  0
 22  9  1  0  0  0  0
 23  6  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000001488953

>  <smiles>
CCC(=O)Nc1ccc2ncnc(Nc3cccc(Br)c3)c2c1

$$$$

 OpenBabel10312015333D

 29 31  0  0  0  0  0  0  0  0999 V2000
   -7.9879   -0.4495    1.1164 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.9663    0.0900    0.7463 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.8151    0.7147    0.1446 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.8777    1.2705   -1.1291 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.8143    2.0505   -1.5301 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.5807    1.8286   -0.9787 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.4340    0.7465   -0.1259 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.1624    0.3896    0.3671 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.4957   -0.8262    0.0115 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.1291   -2.0192    0.1199 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.4306   -3.1507    0.3436 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.0901   -3.1407    0.5370 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.6094   -2.0066    0.2958 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.9587   -1.8947    0.6114 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.5807   -0.6903    0.3120 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.9137   -0.4374    0.5940 O   0  0  0  0  0  0  0  0  0  0  0  0
    4.7333   -1.3200    1.3117 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.8814   -2.5801    0.5001 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.4239   -2.2064   -0.7405 O   0  0  0  0  0  0  0  0  0  0  0  0
    6.8153   -2.3605   -0.6472 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.8793    0.3374   -0.2953 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.5829    1.3482   -0.9331 O   0  0  0  0  0  0  0  0  0  0  0  0
    2.6463    2.6197   -0.3347 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.9590    2.8146    0.4029 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.2897    4.1524    0.5549 O   0  0  0  0  0  0  0  0  0  0  0  0
    3.6557    4.9842   -0.3513 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.5241    0.2471   -0.5343 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.1178   -0.9007   -0.1281 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.5515    0.3888    0.6173 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  3  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  1  0  0  0  0
  7 29  2  0  0  0  0
  8  9  1  0  0  0  0
  9 10  2  0  0  0  0
 10 11  1  0  0  0  0
 11 12  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 15 16  1  0  0  0  0
 15 21  2  0  0  0  0
 16 17  1  0  0  0  0
 17 18  1  0  0  0  0
 18 19  1  0  0  0  0
 19 20  1  0  0  0  0
 21 22  1  0  0  0  0
 21 27  1  0  0  0  0
 22 23  1  0  0  0  0
 23 24  1  0  0  0  0
 24 25  1  0  0  0  0
 25 26  1  0  0  0  0
 27 28  2  0  0  0  0
 28  9  1  0  0  0  0
 28 13  1  0  0  0  0
 29  3  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000001546066

>  <smiles>
C#Cc1cccc(Nc2ncnc3cc(OCCOC)c(OCCOC)cc23)c1

$$$$

 OpenBabel10312015333D

 19 21  0  0  0  0  0  0  0  0999 V2000
   -4.3107    2.5648    0.3241 N   0  0  0  0  0  0  0  0  0  0  0  0
   -3.3698    1.5201    0.4477 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.0348    1.8776    0.4966 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.0605    0.9493    0.2489 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.3384   -0.3670   -0.0462 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.6682   -0.7437    0.0484 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.6717    0.1905    0.2060 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0027   -2.0396   -0.1054 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.0205   -2.9300   -0.2995 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.7113   -2.5803   -0.3182 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.3109   -1.2895   -0.2043 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.8840   -1.0861    0.5594 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.0621   -0.4975   -0.0035 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.2362   -1.2288   -0.1463 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.4659   -0.6636    0.1695 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.5751    0.6617    0.5441 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.4602    1.4571    0.3523 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.5751    3.3247    0.7726 Br  0  0  0  0  0  0  0  0  0  0  0  0
    2.2411    0.8803    0.0408 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  2  0  0  0  0
  3  4  1  0  0  0  0
  4  5  2  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  6  8  1  0  0  0  0
  7  2  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 11  5  1  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 17 18  1  0  0  0  0
 17 19  2  0  0  0  0
 19 13  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000003815072

>  <smiles>
Nc1ccc2c(Nc3cccc(Br)c3)ncnc2c1

$$$$

 OpenBabel10312015333D

 34 37  0  0  0  0  0  0  0  0999 V2000
    6.1153   -5.1255    0.0328 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.3789   -4.4205   -0.2424 N   0  0  0  0  0  0  0  0  0  0  0  0
    5.6008   -3.8227   -1.5454 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.9855   -4.8245   -0.1248 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.1222   -3.6045   -0.1414 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.6364   -2.3903   -0.2754 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.9974   -1.2386    0.3681 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.4237   -0.7454    1.4476 O   0  0  0  0  0  0  0  0  0  0  0  0
    2.1758   -0.3790   -0.4237 N   0  0  0  0  0  0  0  0  0  0  0  0
    1.1640    0.3693    0.2624 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.1514    0.0875   -0.0683 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.1313    1.0662   -0.0287 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.9385    2.1341    0.8272 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.3765    2.4475    1.1391 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.4419    1.6374    0.7640 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.7359    2.1524    0.6086 O   0  0  0  0  0  0  0  0  0  0  0  0
    2.7589    3.0152   -0.6993 C   0  0  1  0  0  0  0  0  0  0  0  0
    2.7082    4.4374    0.1792 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.0628    4.4777    0.7539 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.6995    3.2778    0.5697 O   0  0  0  0  0  0  0  0  0  0  0  0
    4.4326    3.0349   -0.7542 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.9028    3.0711    1.0037 N   0  0  0  0  0  0  0  0  0  0  0  0
   -3.1316    2.7664    0.5824 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.2887    1.8420   -0.3958 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3191    0.9509   -0.7103 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.6917   -0.3605   -1.1512 N   0  0  0  0  0  0  0  0  0  0  0  0
   -4.0239   -0.8568   -0.9636 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.0420    0.0155   -1.3296 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.2808   -0.0225   -0.7042 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.4213   -0.8936    0.3694 C   0  0  0  0  0  0  0  0  0  0  0  0
   -7.4037   -0.7520    1.2931 F   0  0  0  0  0  0  0  0  0  0  0  0
   -5.5569   -1.9667    0.5509 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.2137   -3.5154    1.0685 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -4.3188   -1.8650   -0.0656 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  2  4  1  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  7  9  1  0  0  0  0
  9 10  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 12 13  2  0  0  0  0
 13 14  1  0  0  0  0
 13 22  1  0  0  0  0
 14 15  2  0  0  0  0
 15 16  1  0  0  0  0
 15 10  1  0  0  0  0
 17 16  1  1  0  0  0
 17 18  1  0  0  0  0
 18 19  1  0  0  0  0
 19 20  1  0  0  0  0
 20 21  1  0  0  0  0
 21 17  1  0  0  0  0
 22 23  2  0  0  0  0
 23 24  1  0  0  0  0
 24 25  2  0  0  0  0
 25 26  1  0  0  0  0
 25 12  1  0  0  0  0
 26 27  1  0  0  0  0
 27 28  2  0  0  0  0
 28 29  1  0  0  0  0
 29 30  2  0  0  0  0
 30 31  1  0  0  0  0
 30 32  1  0  0  0  0
 32 33  1  0  0  0  0
 32 34  2  0  0  0  0
 34 27  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000003976838

>  <smiles>
CN(C)C/C=C/C(=O)Nc1cc2c(Nc3ccc(F)c(Cl)c3)ncnc2cc1O[C@H]1CCOC1

$$$$

 OpenBabel10312015333D

 31 34  0  0  0  0  0  0  0  0999 V2000
    3.4750    2.3836   -0.3772 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.6285    1.6871   -1.2773 O   0  0  0  0  0  0  0  0  0  0  0  0
    1.3330    1.3250   -0.8957 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.3499    2.3058   -0.9025 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.7050    2.1643   -0.0195 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.6483    3.1112    0.0751 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.6017    2.9883    1.0056 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.8758    1.7695    1.4949 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.0211    0.7236    1.3952 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.6317   -0.5700    1.3903 N   0  0  0  0  0  0  0  0  0  0  0  0
   -3.5952   -0.9168    0.3893 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.0185    0.0336   -0.5227 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.3352    0.0985   -0.9615 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.2682   -0.8035   -0.4784 C   0  0  0  0  0  0  0  0  0  0  0  0
   -7.5446   -0.3877   -0.2414 F   0  0  0  0  0  0  0  0  0  0  0  0
   -5.7484   -1.9497    0.1116 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.8754   -3.2138    0.5149 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -4.4527   -1.9830    0.6119 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.8720    0.9629    0.6529 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.0351   -0.1054    0.3608 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.0493    0.0241   -0.4985 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.1154   -0.8470   -0.4424 O   0  0  0  0  0  0  0  0  0  0  0  0
    2.3743   -1.8747   -1.3595 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.5970   -1.6610   -2.1957 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.8062   -1.2256   -1.4287 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.6062   -1.1289   -0.0088 N   0  0  0  0  0  0  0  0  0  0  0  0
    5.6508   -1.9338    0.6222 C   0  0  0  0  0  0  0  0  0  0  0  0
    7.0262   -1.5402    0.1138 C   0  0  0  0  0  0  0  0  0  0  0  0
    7.0151   -0.3079   -0.5322 O   0  0  0  0  0  0  0  0  0  0  0  0
    6.3242    0.6205    0.2219 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.8777    0.2509    0.3870 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  9 10  1  0  0  0  0
  9 19  2  0  0  0  0
 10 11  1  0  0  0  0
 11 12  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 14 16  1  0  0  0  0
 16 17  1  0  0  0  0
 16 18  2  0  0  0  0
 18 11  1  0  0  0  0
 19 20  1  0  0  0  0
 19  5  1  0  0  0  0
 20 21  2  0  0  0  0
 21 22  1  0  0  0  0
 21  3  1  0  0  0  0
 22 23  1  0  0  0  0
 23 24  1  0  0  0  0
 24 25  1  0  0  0  0
 25 26  1  0  0  0  0
 26 27  1  0  0  0  0
 27 28  1  0  0  0  0
 28 29  1  0  0  0  0
 29 30  1  0  0  0  0
 30 31  1  0  0  0  0
 31 26  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000019632614

>  <smiles>
COc1cc2ncnc(Nc3ccc(F)c(Cl)c3)c2cc1OCCCN1CCOCC1

$$$$

 OpenBabel10312015333D

 34 37  0  0  0  0  0  0  0  0999 V2000
    0.9021   -4.5481   -1.0383 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.2355   -3.7843   -2.0753 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.7127   -2.4258   -2.1085 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.5228   -2.2406   -2.3289 O   0  0  0  0  0  0  0  0  0  0  0  0
    1.4372   -1.2873   -1.6713 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.8643   -0.3529   -0.7457 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.4505    0.0646   -0.8398 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.2448    0.2825    0.2796 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.7582   -0.0455    1.5401 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.6131   -0.1666    1.6661 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.3928   -0.3934    0.5386 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.7030   -0.8493    0.7090 O   0  0  0  0  0  0  0  0  0  0  0  0
    3.6398   -0.6887   -0.3533 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.7755   -1.6658   -0.2362 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.1172   -1.0132   -0.0659 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.9953    0.3772    0.2892 N   0  0  0  0  0  0  0  0  0  0  0  0
    6.5982    0.6079    1.5745 C   0  0  0  0  0  0  0  0  0  0  0  0
    8.0995    0.7033    1.4089 C   0  0  0  0  0  0  0  0  0  0  0  0
    8.3342    1.8657    0.6564 O   0  0  0  0  0  0  0  0  0  0  0  0
    7.9091    1.6190   -0.6395 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.4483    1.2800   -0.7360 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.6219   -0.5375    2.4569 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.9348   -0.7264    2.1895 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.4500   -0.3318    1.0025 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.6211    0.3043    0.1545 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.1523    0.9306   -0.9964 N   0  0  0  0  0  0  0  0  0  0  0  0
   -4.4816    1.4471   -0.8990 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.2378    1.6300   -2.0381 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.6047    1.7617   -1.9606 C   0  0  0  0  0  0  0  0  0  0  0  0
   -7.2491    1.6068   -0.7456 C   0  0  0  0  0  0  0  0  0  0  0  0
   -8.5469    1.2575   -0.6420 F   0  0  0  0  0  0  0  0  0  0  0  0
   -6.5120    1.6207    0.4239 C   0  0  0  0  0  0  0  0  0  0  0  0
   -7.2595    2.0943    1.9318 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -5.1299    1.6042    0.3089 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  2  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  3  5  1  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
  9 22  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 11  6  1  0  0  0  0
 12 13  1  0  0  0  0
 13 14  1  0  0  0  0
 14 15  1  0  0  0  0
 15 16  1  0  0  0  0
 16 17  1  0  0  0  0
 17 18  1  0  0  0  0
 18 19  1  0  0  0  0
 19 20  1  0  0  0  0
 20 21  1  0  0  0  0
 21 16  1  0  0  0  0
 22 23  2  0  0  0  0
 23 24  1  0  0  0  0
 24 25  2  0  0  0  0
 25 26  1  0  0  0  0
 25  8  1  0  0  0  0
 26 27  1  0  0  0  0
 27 28  2  0  0  0  0
 28 29  1  0  0  0  0
 29 30  2  0  0  0  0
 30 31  1  0  0  0  0
 30 32  1  0  0  0  0
 32 33  1  0  0  0  0
 32 34  2  0  0  0  0
 34 27  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000027439698

>  <smiles>
C=CC(=O)Nc1cc2c(Nc3ccc(F)c(Cl)c3)ncnc2cc1OCCCN1CCOCC1

$$$$

 OpenBabel10312015333D

 11 12  0  0  0  0  0  0  0  0999 V2000
    3.0904   -1.0324    0.7239 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.0614   -0.3344    0.0122 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.9756    1.0466    0.0119 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.6977    1.5910    0.0745 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.4400    0.8518   -0.1128 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.6769    1.1994    0.3891 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.5098    0.1998    0.7753 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.5374   -0.8887   -0.0322 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.3929   -1.1802   -0.6920 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.2686   -0.4454   -0.5658 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.0006   -1.0074   -0.5843 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  2  0  0  0  0
  3  4  1  0  0  0  0
  4  5  2  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
 10 11  2  0  0  0  0
 10  5  1  0  0  0  0
 11  2  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000029544518

>  <smiles>
Nc1ccc2cncnc2c1

$$$$

 OpenBabel10312015333D

 29 31  0  0  0  0  0  0  0  0999 V2000
    7.5448    1.0977    0.0685 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.8053    1.9495   -0.8596 N   0  0  0  0  0  0  0  0  0  0  0  0
    7.3422    3.2978   -0.6883 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.4330    2.0020   -0.3620 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.6175    0.8704   -0.8472 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.6360   -0.3322   -0.3188 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.4322   -1.1577   -0.1617 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.4735   -2.3383   -0.5828 O   0  0  0  0  0  0  0  0  0  0  0  0
    2.4630   -0.8387    0.8264 N   0  0  0  0  0  0  0  0  0  0  0  0
    1.2769   -1.5943    1.0326 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.3038   -2.8585    1.6104 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.4113   -3.8160    1.1471 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.7562   -3.3428    0.5594 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.6830   -4.1908    0.0807 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.7232   -3.7018   -0.6222 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.9997   -2.3961   -0.5962 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.1781   -1.4679   -0.0463 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.7292   -0.3285    0.5939 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.9993    0.9048   -0.0426 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.7609    2.0647    0.6858 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.4375    3.2366    0.4965 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.6452    4.4810    1.6920 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -4.1222    3.3790   -0.7028 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.5354    4.9714   -1.3297 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -4.4145    2.2364   -1.4380 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.9816    0.9848   -1.0186 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.8027   -0.0658   -1.3105 F   0  0  0  0  0  0  0  0  0  0  0  0
   -0.9781   -1.9754    0.4399 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.0071   -1.0712    0.8177 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  2  4  1  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  7  9  1  0  0  0  0
  9 10  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 12 13  2  0  0  0  0
 13 14  1  0  0  0  0
 14 15  2  0  0  0  0
 15 16  1  0  0  0  0
 16 17  2  0  0  0  0
 17 18  1  0  0  0  0
 17 28  1  0  0  0  0
 18 19  1  0  0  0  0
 19 20  2  0  0  0  0
 20 21  1  0  0  0  0
 21 22  1  0  0  0  0
 21 23  2  0  0  0  0
 23 24  1  0  0  0  0
 23 25  1  0  0  0  0
 25 26  2  0  0  0  0
 26 27  1  0  0  0  0
 26 19  1  0  0  0  0
 28 29  2  0  0  0  0
 28 13  1  0  0  0  0
 29 10  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000013671607

>  <smiles>
CN(C)C/C=C/C(=O)Nc1ccc2ncnc(Nc3cc(Cl)c(Cl)cc3F)c2c1

$$$$

 OpenBabel10312015333D

 20 22  0  0  0  0  0  0  0  0999 V2000
   -2.7689    3.3129   -0.3594 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.5708    1.9508    0.0265 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.9675    0.8866   -0.7746 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3597   -0.3478   -0.6311 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.8915   -1.4863   -1.1370 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.0847   -2.5735   -1.2084 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.7849   -2.4607   -0.8777 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.3625   -1.4463   -0.0849 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.7047   -1.6607    0.8415 N   0  0  0  0  0  0  0  0  0  0  0  0
    1.9685   -1.0828    0.4901 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.9783   -1.9151    0.0275 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.0125   -1.3322   -0.6924 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.2859    0.0276   -0.6062 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.3384    0.8563   -0.0201 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.3579    2.7536   -0.2808 Br  0  0  0  0  0  0  0  0  0  0  0  0
    2.1994    0.2675    0.4950 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.2231   -0.4088    0.1579 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.0663    0.4865    1.2090 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.8521    1.6205    1.1697 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.9136    2.5519    2.2553 N   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  2  0  0  0  0
  3  4  1  0  0  0  0
  4  5  2  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  1  0  0  0  0
  8 17  2  0  0  0  0
  9 10  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 12 13  2  0  0  0  0
 13 14  1  0  0  0  0
 14 15  1  0  0  0  0
 14 16  2  0  0  0  0
 16 10  1  0  0  0  0
 17 18  1  0  0  0  0
 17  4  1  0  0  0  0
 18 19  2  0  0  0  0
 19 20  1  0  0  0  0
 19  2  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000002391776

>  <smiles>
Nc1cc2ncnc(Nc3cccc(Br)c3)c2cc1N

$$$$

 OpenBabel10312015333D

 23 25  0  0  0  0  0  0  0  0999 V2000
    4.6865   -1.7925   -0.7451 O   0  0  0  0  0  0  0  0  0  0  0  0
    4.9339   -0.7456   -0.0802 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.3020   -0.2709    0.2254 C   0  0  0  0  0  0  0  0  0  0  0  0
    7.4307   -1.3050   -0.6815 Cl  0  0  0  0  0  0  0  0  0  0  0  0
    3.7966   -0.1102    0.4924 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.6047    0.0705   -0.2852 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.5689    0.9853   -1.3317 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.5224    1.8882   -1.4807 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.3768    1.7476   -0.7070 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.5186    2.7264   -0.5353 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.3757    2.6299    0.4924 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.6980    1.3946    0.9503 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.8476    0.3453    0.8374 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.3114   -1.0103    0.8879 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.5984   -1.2353    0.2970 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.9580   -0.6293   -0.9010 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.2881   -0.4051   -1.2384 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.2010   -0.2738   -0.1990 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.9313   -1.0281    0.9312 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.4488   -1.7215    2.2165 I   0  0  0  0  0  0  0  0  0  0  0  0
   -3.6649   -1.5679    1.1240 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.2675    0.5808    0.0410 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.3518   -0.2731    0.2130 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  2  0  0  0  0
  2  3  1  0  0  0  0
  2  5  1  0  0  0  0
  3  4  1  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 12 13  2  0  0  0  0
 13 14  1  0  0  0  0
 13 22  1  0  0  0  0
 14 15  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 17 18  2  0  0  0  0
 18 19  1  0  0  0  0
 19 20  1  0  0  0  0
 19 21  2  0  0  0  0
 21 15  1  0  0  0  0
 22 23  2  0  0  0  0
 22  9  1  0  0  0  0
 23  6  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000013671605

>  <smiles>
O=C(CCl)Nc1ccc2ncnc(Nc3cccc(I)c3)c2c1

$$$$

 OpenBabel10312015333D

 19 21  0  0  0  0  0  0  0  0999 V2000
   -1.6970    3.3369   -0.5029 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.6828    2.0721    0.1487 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.8870    1.0377   -0.3230 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.3431   -0.2596   -0.1391 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.5131   -0.4899    0.5685 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0607    0.5431    1.2885 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.5660    1.7953    1.1353 N   0  0  0  0  0  0  0  0  0  0  0  0
   -3.2229   -1.5813    0.1880 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.5680   -2.6649   -0.2780 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.3386   -2.5038   -0.8028 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.6509   -1.3545   -0.5961 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.6172   -1.2009   -1.1984 N   0  0  0  0  0  0  0  0  0  0  0  0
    1.7939   -0.8127   -0.5060 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.9280   -1.1115    0.8395 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.8121   -0.4051    1.6347 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.5563    0.5824    1.0485 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.6497    0.7431   -0.3254 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.3684    2.3409   -1.1066 Br  0  0  0  0  0  0  0  0  0  0  0  0
    2.8044   -0.0674   -1.0733 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  2  0  0  0  0
  3  4  1  0  0  0  0
  4  5  2  0  0  0  0
  5  6  1  0  0  0  0
  5  8  1  0  0  0  0
  6  7  2  0  0  0  0
  7  2  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 11  4  1  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 17 18  1  0  0  0  0
 17 19  2  0  0  0  0
 19 13  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000021289041

>  <smiles>
Nc1cc2c(Nc3cccc(Br)c3)ncnc2cn1

$$$$

 OpenBabel10312015333D

 20 22  0  0  0  0  0  0  0  0999 V2000
   -4.8592    2.4969    0.6759 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.9837    1.2130   -0.0031 N   0  0  0  0  0  0  0  0  0  0  0  0
   -3.8540    0.5034   -0.4975 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.6135   -0.7993   -0.0798 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3299   -1.2602    0.0772 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.0099   -2.3943    0.7102 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.7176   -2.7465    0.8763 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.2925   -2.0534    0.3306 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.0092   -0.9321   -0.3388 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.0466   -0.0037   -0.5568 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.1886    0.1563    0.2587 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.9287   -0.8974    0.7685 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.3185   -0.8810    0.7392 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.0106    0.2337    0.2804 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.2721    1.4056    0.2620 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.0732    3.1283    0.4113 Br  0  0  0  0  0  0  0  0  0  0  0  0
    2.8927    1.3455    0.1057 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.2827   -0.4313   -0.2771 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.5644    0.7067   -0.9878 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.8177    1.2097   -0.9873 N   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  9 10  1  0  0  0  0
  9 18  2  0  0  0  0
 10 11  1  0  0  0  0
 11 12  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 15 16  1  0  0  0  0
 15 17  2  0  0  0  0
 17 11  1  0  0  0  0
 18 19  1  0  0  0  0
 18  5  1  0  0  0  0
 19 20  2  0  0  0  0
 20  3  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000021289044

>  <smiles>
CNc1cc2ncnc(Nc3cccc(Br)c3)c2cn1

$$$$

 OpenBabel10312015333D

 34 37  0  0  0  0  0  0  0  0999 V2000
   -0.1951   -1.0768   -5.0438 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.4685   -0.1152   -4.4054 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.0991   -0.4251   -3.1159 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.3687   -1.6304   -2.8267 O   0  0  0  0  0  0  0  0  0  0  0  0
    1.1293    0.4882   -2.0297 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.6727    0.1238   -0.7214 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.5337    0.5247   -0.2854 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.0217    0.0276    0.8651 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.3414   -1.0449    1.4274 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.9819   -1.3222    1.1072 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.5413   -0.6411    0.0330 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.9756   -0.3315    0.0255 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.4938    0.5838   -0.7562 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.6078    1.4884   -0.3737 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.8360    1.5134    1.1140 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.1389    0.9473    1.4575 N   0  0  0  0  0  0  0  0  0  0  0  0
    5.8783   -0.0963    2.4445 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.4709   -1.4232    2.0355 C   0  0  0  0  0  0  0  0  0  0  0  0
    7.7970   -1.2404    1.6516 O   0  0  0  0  0  0  0  0  0  0  0  0
    7.8935   -0.4889    0.4961 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.6473    0.3139    0.2514 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.9896   -1.7884    2.3405 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.2226   -1.4341    2.7294 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.8773   -0.3621    2.2220 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3523    0.2919    1.1573 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0692    1.2955    0.4529 N   0  0  0  0  0  0  0  0  0  0  0  0
   -4.4624    1.1777    0.2022 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.1559    2.2756   -0.2838 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.4322    2.1019   -0.8049 C   0  0  0  0  0  0  0  0  0  0  0  0
   -7.0849    0.8787   -0.7429 C   0  0  0  0  0  0  0  0  0  0  0  0
   -8.2197    0.6441   -1.4349 F   0  0  0  0  0  0  0  0  0  0  0  0
   -6.5034   -0.0928    0.0561 C   0  0  0  0  0  0  0  0  0  0  0  0
   -7.3599   -1.5924    0.3672 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -5.1791    0.0233    0.3886 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  2  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  3  5  1  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
  9 22  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 11  6  1  0  0  0  0
 12 13  2  0  0  0  0
 13 14  1  0  0  0  0
 14 15  1  0  0  0  0
 15 16  1  0  0  0  0
 16 17  1  0  0  0  0
 17 18  1  0  0  0  0
 18 19  1  0  0  0  0
 19 20  1  0  0  0  0
 20 21  1  0  0  0  0
 21 16  1  0  0  0  0
 22 23  2  0  0  0  0
 23 24  1  0  0  0  0
 24 25  2  0  0  0  0
 25 26  1  0  0  0  0
 25  8  1  0  0  0  0
 26 27  1  0  0  0  0
 27 28  2  0  0  0  0
 28 29  1  0  0  0  0
 29 30  2  0  0  0  0
 30 31  1  0  0  0  0
 30 32  1  0  0  0  0
 32 33  1  0  0  0  0
 32 34  2  0  0  0  0
 34 27  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000013806963

>  <smiles>
C=CC(=O)Nc1nc2c(Nc3ccc(F)c(Cl)c3)ncnc2cc1/C=C/CCN1CCOCC1

$$$$

 OpenBabel10312015333D

 34 37  0  0  0  0  0  0  0  0999 V2000
    3.4624   -1.9533    2.4988 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.1035   -2.7658    1.5061 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.7699   -2.6232    0.9100 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.7596   -2.8074    1.6521 O   0  0  0  0  0  0  0  0  0  0  0  0
    1.5433   -1.8092   -0.2467 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.4395   -0.8988   -0.3182 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.8357   -1.2944   -0.0840 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.6726   -0.4399    0.5376 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.2610    0.7927    1.0287 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.0620    1.3142    0.5547 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.7488    0.4476   -0.1664 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.8456    0.9693   -0.9577 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.7165    0.1896   -1.5494 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.7078    0.8517   -2.4555 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.0657    0.2858   -2.0626 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.1377    0.3335   -0.6206 N   0  0  0  0  0  0  0  0  0  0  0  0
    5.4915    1.6891   -0.2239 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.8193    1.5896    0.5169 C   0  0  0  0  0  0  0  0  0  0  0  0
    7.7226    1.0335   -0.4023 O   0  0  0  0  0  0  0  0  0  0  0  0
    7.4762   -0.3461   -0.4143 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.0285   -0.6564   -0.0748 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.7796    1.1887    2.2173 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.9801    0.6965    2.6041 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.6084   -0.1788    1.7821 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.9210   -0.9332    0.8921 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.6581   -1.7496   -0.1227 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.8055   -0.8968   -0.5664 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.8812   -0.6597    0.2811 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.5753    0.5442    0.2616 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.0741    1.6201   -0.4573 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.9432    2.6464   -0.6879 F   0  0  0  0  0  0  0  0  0  0  0  0
   -5.2055    1.2972   -1.4929 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.9037    2.5039   -2.7370 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -4.6715    0.0191   -1.6025 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  2  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  3  5  1  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
  9 22  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 11  6  1  0  0  0  0
 12 13  2  0  0  0  0
 13 14  1  0  0  0  0
 14 15  1  0  0  0  0
 15 16  1  0  0  0  0
 16 17  1  0  0  0  0
 17 18  1  0  0  0  0
 18 19  1  0  0  0  0
 19 20  1  0  0  0  0
 20 21  1  0  0  0  0
 21 16  1  0  0  0  0
 22 23  2  0  0  0  0
 23 24  1  0  0  0  0
 24 25  2  0  0  0  0
 25 26  1  0  0  0  0
 25  8  1  0  0  0  0
 26 27  1  0  0  0  0
 27 28  2  0  0  0  0
 28 29  1  0  0  0  0
 29 30  2  0  0  0  0
 30 31  1  0  0  0  0
 30 32  1  0  0  0  0
 32 33  1  0  0  0  0
 32 34  2  0  0  0  0
 34 27  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000045505867

>  <smiles>
C=CC(=O)Nc1nc2c(Cc3ccc(F)c(Cl)c3)ncnc2cc1/C=C/CCN1CCOCC1

$$$$

 OpenBabel10312015333D

 35 38  0  0  0  0  0  0  0  0999 V2000
   -3.7864    4.5670   -0.2741 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.9367    4.4492   -0.3281 N   0  0  0  0  0  0  0  0  0  0  0  0
   -5.8444    5.5479   -0.4530 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.6039    3.2006   -0.1004 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.6733    2.0551   -0.2429 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.4170    1.2906    0.8196 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.6455    1.8617    2.0337 F   0  0  0  0  0  0  0  0  0  0  0  0
   -3.4339    0.2038    0.7140 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.1967   -0.4705    1.7603 O   0  0  0  0  0  0  0  0  0  0  0  0
   -2.5130    0.1097   -0.3655 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.2756   -0.5788   -0.2880 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.0641    0.1068   -0.3037 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.1300   -0.5979   -0.2190 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.1361   -1.9803   -0.3585 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.0783   -2.5761   -0.5562 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.2898   -1.9610   -0.2720 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.4250   -2.7413   -0.2638 O   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3540   -3.8991    0.7944 C   0  0  1  0  0  0  0  0  0  0  0  0
   -3.8259   -4.5297    0.2973 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.5256   -4.5638   -1.1708 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3860   -5.2912   -1.1258 O   0  0  0  0  0  0  0  0  0  0  0  0
   -1.4880   -4.8739   -0.2506 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.2475   -2.6381    0.0421 N   0  0  0  0  0  0  0  0  0  0  0  0
    3.1825   -2.0106    0.7969 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.2414   -0.6566    0.7655 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.2037    0.0960    0.3229 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.4892    1.3603   -0.2916 N   0  0  0  0  0  0  0  0  0  0  0  0
    3.8304    1.6886   -0.6777 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.5850    0.6542   -1.2196 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.9662    0.6266   -1.1465 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.5751    1.3603   -0.1357 C   0  0  0  0  0  0  0  0  0  0  0  0
    7.8503    1.1203    0.2212 F   0  0  0  0  0  0  0  0  0  0  0  0
    5.9200    2.5329    0.2233 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.8632    3.9143    0.7723 Cl  0  0  0  0  0  0  0  0  0  0  0  0
    4.5427    2.6232    0.0595 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  2  4  1  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  6  8  1  0  0  0  0
  8  9  2  0  0  0  0
  8 10  1  0  0  0  0
 10 11  1  0  0  0  0
 11 12  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 14 23  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 16 11  1  0  0  0  0
 18 17  1  6  0  0  0
 18 19  1  0  0  0  0
 19 20  1  0  0  0  0
 20 21  1  0  0  0  0
 21 22  1  0  0  0  0
 22 18  1  0  0  0  0
 23 24  2  0  0  0  0
 24 25  1  0  0  0  0
 25 26  2  0  0  0  0
 26 27  1  0  0  0  0
 26 13  1  0  0  0  0
 27 28  1  0  0  0  0
 28 29  2  0  0  0  0
 29 30  1  0  0  0  0
 30 31  2  0  0  0  0
 31 32  1  0  0  0  0
 31 33  1  0  0  0  0
 33 34  1  0  0  0  0
 33 35  2  0  0  0  0
 35 28  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000145214115

>  <smiles>
CN(C)C/C=C(\\F)C(=O)Nc1cc2c(Nc3ccc(F)c(Cl)c3)ncnc2cc1O[C@H]1CCOC1

$$$$

 OpenBabel10312015333D

 20 22  0  0  0  0  0  0  0  0999 V2000
   -4.9772    1.5656   -1.0775 O   0  0  0  0  0  0  0  0  0  0  0  0
   -3.8426    0.8905   -0.6616 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.7238   -0.4733   -0.9008 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.4933   -1.0594   -0.6273 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3078   -2.3927   -0.7207 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.1438   -2.9288   -0.2975 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.0339   -2.1698   -0.1398 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.1519   -0.8269    0.0015 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.9325   -0.0128   -0.3928 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.2103   -0.0114    0.2491 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.9416   -1.1806    0.1286 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.3046   -1.2374    0.0835 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.0080   -0.0610   -0.0789 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.3313    1.1377   -0.0468 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.2967    2.7069   -0.5517 Br  0  0  0  0  0  0  0  0  0  0  0  0
    2.9651    1.1564    0.2058 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.4338   -0.3090   -0.1350 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.6478    1.0182    0.1822 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.9099    1.5903    0.0894 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.3243    2.5973    0.9651 O   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  2  0  0  0  0
  3  4  1  0  0  0  0
  4  5  2  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  1  0  0  0  0
  8 17  2  0  0  0  0
  9 10  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 12 13  2  0  0  0  0
 13 14  1  0  0  0  0
 14 15  1  0  0  0  0
 14 16  2  0  0  0  0
 16 10  1  0  0  0  0
 17 18  1  0  0  0  0
 17  4  1  0  0  0  0
 18 19  2  0  0  0  0
 19 20  1  0  0  0  0
 19  2  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000003815038

>  <smiles>
Oc1cc2ncnc(Nc3cccc(Br)c3)c2cc1O

$$$$

 OpenBabel10312015333D

 26 28  0  0  0  0  0  0  0  0999 V2000
    5.4428    2.7424   -2.0802 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.3310    1.2348   -1.8851 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.8774    0.8221   -1.9451 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.5936   -0.2930   -1.1408 O   0  0  0  0  0  0  0  0  0  0  0  0
    2.4018   -0.3297   -0.4298 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.5865   -1.4529   -0.4946 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.3111   -1.3443    0.0367 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.3982   -2.4446    0.3827 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.3397   -2.3884    1.3560 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.9910   -1.2049    1.4652 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.3460   -0.0377    1.2201 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.0929    1.1678    1.0171 N   0  0  0  0  0  0  0  0  0  0  0  0
   -3.3637    0.9974    0.3767 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.4797    1.7338    0.7432 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.7084    1.0844    0.7399 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.9089    0.0258   -0.1382 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.8426   -0.4643   -0.8816 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.0908   -2.1788   -1.6992 Br  0  0  0  0  0  0  0  0  0  0  0  0
   -3.5761    0.0223   -0.5860 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.1097   -0.1434    0.5946 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.7227    0.9663    0.6564 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.0632    0.7760    0.3411 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.0781    1.5118    0.9419 O   0  0  0  0  0  0  0  0  0  0  0  0
    3.6621    0.9783    2.1249 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.3673   -0.3247    1.8718 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.8099   -1.4564    2.7235 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  1  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  9 10  2  0  0  0  0
 10 11  1  0  0  0  0
 11 12  1  0  0  0  0
 11 20  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 17 18  1  0  0  0  0
 17 19  2  0  0  0  0
 19 13  1  0  0  0  0
 20 21  1  0  0  0  0
 20  7  1  0  0  0  0
 21 22  2  0  0  0  0
 22 23  1  0  0  0  0
 22  5  1  0  0  0  0
 23 24  1  0  0  0  0
 24 25  1  0  0  0  0
 25 26  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000003815039

>  <smiles>
CCCOc1cc2ncnc(Nc3cccc(Br)c3)c2cc1OCCC

$$$$

 OpenBabel10312015333D

 24 26  0  0  0  0  0  0  0  0999 V2000
   -4.7275    3.1696   -0.6080 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.2876    1.9989   -0.3933 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.5485    0.7902   -0.0777 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.1966   -0.2710    0.0271 O   0  0  0  0  0  0  0  0  0  0  0  0
   -3.1356    0.7360   -0.2864 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.6026    1.6168   -1.3214 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3469   -0.3102    0.2925 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.9828   -0.1593    0.3838 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.0943   -1.2250    0.2954 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.6694   -2.4894    0.2670 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.0415   -2.6554    0.3934 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.8342   -1.5599    0.4678 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.0929   -3.5118   -0.1929 N   0  0  0  0  0  0  0  0  0  0  0  0
    1.4316   -3.3553   -0.2853 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.9726   -2.1350   -0.4442 N   0  0  0  0  0  0  0  0  0  0  0  0
    1.2169   -1.0528   -0.1345 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.5583    0.1845   -0.7674 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.5080    1.0904   -0.2279 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.2951    1.7107    0.9937 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.3682    2.0132    1.8033 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.6826    1.8754    1.3879 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.8930    1.3347    0.1488 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.6243    1.2828   -0.6491 Br  0  0  0  0  0  0  0  0  0  0  0  0
    3.8242    0.9218   -0.6357 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  2  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  3  5  1  0  0  0  0
  5  6  1  0  0  0  0
  5  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  9 10  2  0  0  0  0
 10 11  1  0  0  0  0
 10 13  1  0  0  0  0
 11 12  2  0  0  0  0
 12  7  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 16  9  1  0  0  0  0
 17 18  1  0  0  0  0
 18 19  2  0  0  0  0
 19 20  1  0  0  0  0
 20 21  2  0  0  0  0
 21 22  1  0  0  0  0
 22 23  1  0  0  0  0
 22 24  2  0  0  0  0
 24 18  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000013861814

>  <smiles>
C=CC(=O)N(C)c1cc2c(Nc3cccc(Br)c3)ncnc2cn1

$$$$

 OpenBabel10312015333D

 24 26  0  0  0  0  0  0  0  0999 V2000
   -5.9819    1.6183    0.2718 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.1671    1.9451    0.0011 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.9311    1.3686   -0.5505 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.2513    2.1569   -1.2669 O   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0695    0.7918    0.7186 C   0  0  1  0  0  0  0  0  0  0  0  0
   -3.9498   -0.6275    0.7368 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.9060    0.1748   -0.2481 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.8346   -0.2050    0.5517 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.0018   -1.1570    0.0179 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.3287   -1.7498   -1.1932 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.3233   -1.1803   -1.9787 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.2930   -0.5349   -1.2826 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.4101   -2.7921   -1.5739 N   0  0  0  0  0  0  0  0  0  0  0  0
    1.3245   -3.3085   -0.7216 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.6997   -2.6915    0.4070 N   0  0  0  0  0  0  0  0  0  0  0  0
    1.0662   -1.5772    0.7803 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.5777   -0.6517    1.7232 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.6435    0.1855    1.2870 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.9247   -0.2754    1.5640 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.0298    0.2751    0.9354 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.8007    1.3217    0.0826 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.5470    1.8891   -0.1093 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.5394    3.7289   -0.6512 Br  0  0  0  0  0  0  0  0  0  0  0  0
    2.4711    1.2951    0.4987 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  2  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  5  3  1  0  0  0  0
  5  6  1  6  0  0  0
  5  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  9 10  2  0  0  0  0
 10 11  1  0  0  0  0
 10 13  1  0  0  0  0
 11 12  2  0  0  0  0
 12  7  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 16  9  1  0  0  0  0
 17 18  1  0  0  0  0
 18 19  2  0  0  0  0
 19 20  1  0  0  0  0
 20 21  2  0  0  0  0
 21 22  1  0  0  0  0
 22 23  1  0  0  0  0
 22 24  2  0  0  0  0
 24 18  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000040951553

>  <smiles>
C=CC(=O)[C@@H](C)c1cc2c(Nc3cccc(Br)c3)ncnc2cn1

$$$$

 OpenBabel10312015333D

 24 26  0  0  0  0  0  0  0  0999 V2000
    4.5118    2.1755   -1.1707 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.2529    2.1880   -0.9112 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.3613    1.8242    0.1293 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.3594    2.4947    0.4304 O   0  0  0  0  0  0  0  0  0  0  0  0
    3.4827    0.4064    0.8787 C   0  0  2  0  0  0  0  0  0  0  0  0
    4.9413    0.0057    0.2341 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.6484   -0.3598   -0.2727 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.3016   -0.2875    0.0891 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.4009   -1.2139   -0.3991 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.8789   -2.2028   -1.2391 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.2440   -2.3647   -1.3223 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.0414   -1.6361   -0.5109 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.0641   -3.2181   -1.5988 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.2500   -3.1938   -1.3628 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.7535   -2.0989   -0.7428 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.9540   -1.1391   -0.2221 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.4347   -0.3290    0.8327 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.7168    0.2654    0.6704 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.8256   -0.5454    0.6412 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.0878    0.0015    0.5692 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.2261    1.3733    0.6806 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.1036    2.1658    0.6192 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.2953    4.0471    0.4834 Br  0  0  0  0  0  0  0  0  0  0  0  0
   -2.8414    1.6414    0.7906 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  2  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  5  3  1  0  0  0  0
  5  6  1  6  0  0  0
  5  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  9 10  2  0  0  0  0
 10 11  1  0  0  0  0
 10 13  1  0  0  0  0
 11 12  2  0  0  0  0
 12  7  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 16  9  1  0  0  0  0
 17 18  1  0  0  0  0
 18 19  2  0  0  0  0
 19 20  1  0  0  0  0
 20 21  2  0  0  0  0
 21 22  1  0  0  0  0
 22 23  1  0  0  0  0
 22 24  2  0  0  0  0
 24 18  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000040951555

>  <smiles>
C=CC(=O)[C@H](C)c1cc2c(Nc3cccc(Br)c3)ncnc2cn1

$$$$

 OpenBabel10312015333D

 24 26  0  0  0  0  0  0  0  0999 V2000
    6.2175    0.2249    2.4918 N   0  0  0  0  0  0  0  0  0  0  0  0
    5.5532    1.0647    2.0639 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.7916    2.1017    1.3459 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.0604    1.4739    0.2272 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.6740    0.6738   -0.5051 O   0  0  0  0  0  0  0  0  0  0  0  0
    2.7132    1.7738   -0.1118 N   0  0  0  0  0  0  0  0  0  0  0  0
    1.8959    0.9590   -0.9214 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.4369    0.2843   -2.0089 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.9132   -0.9378   -2.3906 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.8070   -1.4825   -1.7711 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.6291   -2.8190   -1.6559 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.1678   -3.3558   -0.7006 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.0195   -2.5390   -0.0360 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.0131   -1.2139   -0.3195 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.7709   -0.3728    0.5498 N   0  0  0  0  0  0  0  0  0  0  0  0
   -3.1198    0.0031    0.2778 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.2994    1.2630   -0.2773 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.4938    1.9371   -0.2402 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.4636    1.4391    0.6123 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.3413    0.1956    1.2147 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.4720   -0.1156    2.7273 Br  0  0  0  0  0  0  0  0  0  0  0  0
   -4.1953   -0.5144    0.9788 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.0624   -0.6261   -0.9691 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.6023    0.5829   -0.5821 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  3  0  0  0  0
  2  3  1  0  0  0  0
  3  4  1  0  0  0  0
  4  5  2  0  0  0  0
  4  6  1  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  9 10  2  0  0  0  0
 10 11  1  0  0  0  0
 11 12  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 14 23  1  0  0  0  0
 15 16  1  0  0  0  0
 16 17  2  0  0  0  0
 17 18  1  0  0  0  0
 18 19  2  0  0  0  0
 19 20  1  0  0  0  0
 20 21  1  0  0  0  0
 20 22  2  0  0  0  0
 22 16  1  0  0  0  0
 23 24  2  0  0  0  0
 23 10  1  0  0  0  0
 24  7  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000045349211

>  <smiles>
N#CCC(=O)Nc1ccc2ncnc(Nc3cccc(Br)c3)c2c1

$$$$

 OpenBabel10312015333D

 24 26  0  0  0  0  0  0  0  0999 V2000
    5.3777    2.5781   -0.9707 O   0  0  0  0  0  0  0  0  0  0  0  0
    5.0020    2.6792   -0.0785 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.4998    1.2509    0.6572 C   0  0  1  0  0  0  0  0  0  0  0  0
    4.3250    1.3022    1.6669 O   0  0  0  0  0  0  0  0  0  0  0  0
    4.6509    0.3300   -0.4635 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.2860    0.6949   -0.3409 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.3168   -0.3483   -0.1851 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.9518   -0.1210   -0.3184 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.0744   -1.0587    0.1951 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.6348   -2.1568    0.8323 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.9610   -2.5137    0.6708 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.7169   -1.6342   -0.0254 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.2029   -2.9937    1.4474 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.5193   -2.9350    1.2348 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.9649   -2.2450    0.1569 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.2259   -1.2035   -0.2704 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.8139   -0.1604   -1.0045 N   0  0  0  0  0  0  0  0  0  0  0  0
   -3.1636    0.2179   -0.7100 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.0204   -0.5759    0.0369 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.9609   -0.0343    0.9060 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.0621    1.3430    0.9605 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.4744    2.0951   -0.0367 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.8113    3.9630   -0.0921 Br  0  0  0  0  0  0  0  0  0  0  0  0
   -3.5774    1.5260   -0.9284 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  3  2  1  0  0  0  0
  3  4  1  1  0  0  0
  3  5  1  0  0  0  0
  5  6  1  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  9 10  2  0  0  0  0
 10 11  1  0  0  0  0
 10 13  1  0  0  0  0
 11 12  2  0  0  0  0
 12  7  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 16  9  1  0  0  0  0
 17 18  1  0  0  0  0
 18 19  2  0  0  0  0
 19 20  1  0  0  0  0
 20 21  2  0  0  0  0
 21 22  1  0  0  0  0
 22 23  1  0  0  0  0
 22 24  2  0  0  0  0
 24 18  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000021289048

>  <smiles>
OC[C@@H](O)CNc1cc2c(Nc3cccc(Br)c3)ncnc2cn1

$$$$

 OpenBabel10312015333D

 24 26  0  0  0  0  0  0  0  0999 V2000
    5.7637    2.4021    0.0481 O   0  0  0  0  0  0  0  0  0  0  0  0
    5.7784    2.5149    0.7963 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.6815    1.3397    1.2892 C   0  0  2  0  0  0  0  0  0  0  0  0
    5.4349    0.2623    0.4727 O   0  0  0  0  0  0  0  0  0  0  0  0
    3.6582    1.7096    0.0085 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.2709    0.4629   -0.5387 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.2547   -0.4134   -0.1255 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.9701   -0.2629   -0.6369 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.0983   -1.3399   -0.6104 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.4811   -2.4953    0.0560 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.8047   -2.6987    0.3523 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.6434   -1.6799    0.1614 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.4672   -3.2574    0.6359 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.7507   -3.1770    0.2792 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.1078   -2.1253   -0.4964 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.2387   -1.1850   -0.8990 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.6679    0.1405   -1.2353 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.8090    0.6473   -0.5611 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0951    0.3210    0.7595 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.1920    0.8411    1.4323 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.0151    1.6682    0.6982 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.7876    1.9219   -0.6506 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.8386    3.2582   -1.5277 Br  0  0  0  0  0  0  0  0  0  0  0  0
   -3.8702    1.1449   -1.3063 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  3  2  1  0  0  0  0
  3  4  1  6  0  0  0
  3  5  1  0  0  0  0
  5  6  1  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  9 10  2  0  0  0  0
 10 11  1  0  0  0  0
 10 13  1  0  0  0  0
 11 12  2  0  0  0  0
 12  7  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 16  9  1  0  0  0  0
 17 18  1  0  0  0  0
 18 19  2  0  0  0  0
 19 20  1  0  0  0  0
 20 21  2  0  0  0  0
 21 22  1  0  0  0  0
 22 23  1  0  0  0  0
 22 24  2  0  0  0  0
 24 18  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000021289051

>  <smiles>
OC[C@H](O)CNc1cc2c(Nc3cccc(Br)c3)ncnc2cn1

$$$$

 OpenBabel10312015333D

 27 29  0  0  0  0  0  0  0  0999 V2000
   -4.2742    4.3553   -1.0095 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.5525    3.2511   -0.3373 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.4774    2.4688    0.2576 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3451    2.9874    0.4961 O   0  0  0  0  0  0  0  0  0  0  0  0
   -3.5949    1.1032    0.6174 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.5716    0.1738    0.2672 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.2534    0.3132    0.6768 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.2974   -0.6210    0.2955 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.6822   -1.5855   -0.6275 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.0326   -1.7986   -0.8737 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0121   -1.0461   -0.2353 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.2273   -1.6144    0.1592 O   0  0  0  0  0  0  0  0  0  0  0  0
   -4.2902   -2.6741    1.1109 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.8017   -3.9468    0.4490 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.2308   -2.5499   -0.8940 N   0  0  0  0  0  0  0  0  0  0  0  0
    1.2620   -2.7902   -0.0487 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.5858   -1.8482    0.8532 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.8685   -0.7108    1.0196 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.4937    0.5293    1.3730 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.7075    0.9215    0.7205 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.6841    1.5555    1.4753 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.0145    1.5911    1.0840 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.3895    0.9121   -0.0686 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.6487    1.0960   -0.5578 F   0  0  0  0  0  0  0  0  0  0  0  0
    4.4613    0.1864   -0.7768 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.9095   -0.4341   -2.3371 Cl  0  0  0  0  0  0  0  0  0  0  0  0
    3.1569    0.1750   -0.3628 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  2  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  3  5  1  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
  9 15  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 11  6  1  0  0  0  0
 12 13  1  0  0  0  0
 13 14  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 17 18  2  0  0  0  0
 18 19  1  0  0  0  0
 18  8  1  0  0  0  0
 19 20  1  0  0  0  0
 20 21  2  0  0  0  0
 21 22  1  0  0  0  0
 22 23  2  0  0  0  0
 23 24  1  0  0  0  0
 23 25  1  0  0  0  0
 25 26  1  0  0  0  0
 25 27  2  0  0  0  0
 27 20  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000084671548

>  <smiles>
C=CC(=O)Nc1cc2c(Nc3ccc(F)c(Cl)c3)ncnc2cc1OCC

$$$$

 OpenBabel10312015333D

 39 42  0  0  0  0  0  0  0  0999 V2000
    0.6072    1.4028    5.4687 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.0529    1.0062    5.4945 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.5929    0.7028    4.2402 O   0  0  0  0  0  0  0  0  0  0  0  0
    1.8859    0.3020    3.1303 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.6040   -0.2127    3.2798 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.1284   -0.5216    2.1611 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.2125   -1.3284    2.2098 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.1447   -1.1426    1.2440 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.6881   -0.7703    0.0468 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.3961   -0.4195   -0.1670 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.0599   -0.0951   -1.4867 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.9062   -0.1002   -2.5475 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.4419    1.1214   -2.9376 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.7945    1.2758   -3.2178 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.6406    0.1774   -3.1762 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.9479    0.3475   -2.7204 O   0  0  0  0  0  0  0  0  0  0  0  0
   -5.3289    1.2887   -1.7518 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.4768    0.8331   -0.9213 C   0  0  0  0  0  0  0  0  0  0  0  0
   -7.6299    0.4100   -1.5571 C   0  0  0  0  0  0  0  0  0  0  0  0
   -8.4271   -0.5402   -0.9381 C   0  0  0  0  0  0  0  0  0  0  0  0
   -8.0852   -0.9931    0.3292 C   0  0  0  0  0  0  0  0  0  0  0  0
   -7.0714   -0.3352    0.9994 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.2898    0.5686    0.3763 N   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0336   -1.0740   -3.2145 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.1367   -2.4272   -2.9664 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -1.7168   -1.2036   -2.7879 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.4328   -0.2444    0.9231 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.7665    0.1092    0.7779 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.5543    0.2671    1.9122 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.9323   -0.1249    1.8750 N   0  0  0  0  0  0  0  0  0  0  0  0
    4.8178    0.3290    0.8461 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.6218    1.4910    0.4225 O   0  0  0  0  0  0  0  0  0  0  0  0
    6.0172   -0.4458    0.6004 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.6348   -1.0569    1.6526 F   0  0  0  0  0  0  0  0  0  0  0  0
    6.2016   -1.0129   -0.5894 C   0  0  0  0  0  0  0  0  0  0  0  0
    7.5913   -1.3865   -0.9589 C   0  0  0  0  0  0  0  0  0  0  0  0
    8.2292   -0.2098   -1.4935 N   0  0  0  0  0  0  0  0  0  0  0  0
    9.5170   -0.5773   -2.0638 C   0  0  0  0  0  0  0  0  0  0  0  0
    7.3776    0.4050   -2.4939 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  1  0  0  0  0
  4  5  2  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
 10 11  1  0  0  0  0
 10 27  2  0  0  0  0
 11 12  1  0  0  0  0
 12 13  2  0  0  0  0
 13 14  1  0  0  0  0
 14 15  2  0  0  0  0
 15 16  1  0  0  0  0
 15 24  1  0  0  0  0
 16 17  1  0  0  0  0
 17 18  1  0  0  0  0
 18 19  2  0  0  0  0
 19 20  1  0  0  0  0
 20 21  2  0  0  0  0
 21 22  1  0  0  0  0
 22 23  2  0  0  0  0
 23 18  1  0  0  0  0
 24 25  1  0  0  0  0
 24 26  2  0  0  0  0
 26 12  1  0  0  0  0
 27 28  1  0  0  0  0
 27  6  1  0  0  0  0
 28 29  2  0  0  0  0
 29 30  1  0  0  0  0
 29  4  1  0  0  0  0
 30 31  1  0  0  0  0
 31 32  2  0  0  0  0
 31 33  1  0  0  0  0
 33 34  1  0  0  0  0
 33 35  2  0  0  0  0
 35 36  1  0  0  0  0
 36 37  1  0  0  0  0
 37 38  1  0  0  0  0
 37 39  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000145220973

>  <smiles>
CCOc1cc2ncnc(Nc3ccc(OCc4ccccn4)c(Cl)c3)c2cc1NC(=O)/C(F)=C/CN(C)C

$$$$

 OpenBabel10312015333D

 22 24  0  0  0  0  0  0  0  0999 V2000
    4.2986    3.4353    0.3090 O   0  0  0  0  0  0  0  0  0  0  0  0
    3.5798    2.2518    0.2952 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.5215    1.0799    0.5366 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.7793    0.0241    1.1900 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.7903   -0.6425    0.4063 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.4345   -0.5616    0.6886 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.6085   -1.4396    0.0292 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.1204   -2.2186   -0.9967 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.3958   -1.9894   -1.4971 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.2219   -1.2880   -0.6926 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.3058   -3.0849   -1.6111 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.9976   -3.1453   -1.3236 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.5368   -2.0910   -0.6824 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.7528   -1.4500    0.2137 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.3781   -0.5162    1.0656 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.1829    0.5161    0.4853 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.6135    1.4616   -0.3547 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.1980    2.7223   -0.3794 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.5065    2.8699    0.0639 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.2404    1.7779    0.5086 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.1276    1.6519    0.2893 Br  0  0  0  0  0  0  0  0  0  0  0  0
   -3.5221    0.6365    0.8323 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  1  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  8 11  1  0  0  0  0
  9 10  2  0  0  0  0
 10  5  1  0  0  0  0
 11 12  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 14  7  1  0  0  0  0
 15 16  1  0  0  0  0
 16 17  2  0  0  0  0
 17 18  1  0  0  0  0
 18 19  2  0  0  0  0
 19 20  1  0  0  0  0
 20 21  1  0  0  0  0
 20 22  2  0  0  0  0
 22 16  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000021289055

>  <smiles>
OCCNc1cc2c(Nc3cccc(Br)c3)ncnc2cn1

$$$$

 OpenBabel10312015333D

 20 22  0  0  0  0  0  0  0  0999 V2000
   -3.9704   -2.5085    0.4550 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.2290   -1.1846    0.9744 N   0  0  0  0  0  0  0  0  0  0  0  0
   -3.2474   -0.1413    0.9371 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.9614   -0.3901    0.4740 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.3003    0.5967   -0.2468 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.9360    1.7928   -0.5611 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0681    2.0973    0.1735 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.6265    1.1562    0.9683 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.6797    2.3405   -1.7730 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.7111    1.8182   -2.5644 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.1501    0.8996   -2.0632 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.0563    0.4185   -0.8117 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.6782   -0.7291   -0.4486 N   0  0  0  0  0  0  0  0  0  0  0  0
    1.9010   -0.7148    0.2698 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.1735   -1.8006    1.0922 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.4526   -2.3203    1.2356 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.5150   -1.6988    0.5910 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.2987   -0.3914    0.1732 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.6063    0.7698    0.0675 Cl  0  0  0  0  0  0  0  0  0  0  0  0
    3.0109   -0.0101   -0.1794 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  6  9  1  0  0  0  0
  7  8  2  0  0  0  0
  8  3  1  0  0  0  0
  9 10  2  0  0  0  0
 10 11  1  0  0  0  0
 11 12  2  0  0  0  0
 12 13  1  0  0  0  0
 12  5  1  0  0  0  0
 13 14  1  0  0  0  0
 14 15  2  0  0  0  0
 15 16  1  0  0  0  0
 16 17  2  0  0  0  0
 17 18  1  0  0  0  0
 18 19  1  0  0  0  0
 18 20  2  0  0  0  0
 20 14  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000021289058

>  <smiles>
CNc1cc2c(Nc3cccc(Cl)c3)ncnc2cn1

$$$$

 OpenBabel10312015333D

 24 26  0  0  0  0  0  0  0  0999 V2000
   -5.0077    3.6898   -0.7653 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.2795    2.2840   -0.4149 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.9698    1.1476   -0.1115 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.5091   -0.2061    0.1055 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.7898   -1.0371   -0.8072 O   0  0  0  0  0  0  0  0  0  0  0  0
   -3.4038   -0.5257    0.9259 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3363   -1.3828    0.5189 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3646   -2.7452    0.6402 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.2105   -3.4276    0.2767 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.0263   -2.8220    0.2043 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.1288   -3.4055    0.7352 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.2622   -2.6870    0.8460 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.3059   -1.3496    0.6484 N   0  0  0  0  0  0  0  0  0  0  0  0
    1.2388   -0.7715    0.0434 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.1809    0.6379   -0.1472 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.3374    1.4444   -0.2879 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.1537    2.8107   -0.3428 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.2374    3.6767   -0.3405 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.4888    3.1203   -0.2602 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.6524    1.7784   -0.0426 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.4103    1.0474    0.0776 Br  0  0  0  0  0  0  0  0  0  0  0  0
    3.5980    0.8966   -0.2171 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.0206   -1.4399    0.0602 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.1702   -0.7334    0.1312 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  3  0  0  0  0
  3  4  1  0  0  0  0
  4  5  2  0  0  0  0
  4  6  1  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  9 10  2  0  0  0  0
 10 11  1  0  0  0  0
 11 12  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 14 23  1  0  0  0  0
 15 16  1  0  0  0  0
 16 17  2  0  0  0  0
 17 18  1  0  0  0  0
 18 19  2  0  0  0  0
 19 20  1  0  0  0  0
 20 21  1  0  0  0  0
 20 22  2  0  0  0  0
 22 16  1  0  0  0  0
 23 24  2  0  0  0  0
 23 10  1  0  0  0  0
 24  7  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000001488207

>  <smiles>
CC#CC(=O)Nc1ccc2ncnc(Nc3cccc(Br)c3)c2c1

$$$$

 OpenBabel10312015333D

 31 33  0  0  0  0  0  0  0  0999 V2000
   -1.0329    1.4067   -2.6489 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.1662    1.1377   -1.9275 O   0  0  0  0  0  0  0  0  0  0  0  0
    0.3095   -0.0046   -1.1387 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.0697   -1.2698   -1.5715 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.6707   -2.1149   -0.6418 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.4145   -3.1784   -1.0358 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.1149   -3.9181   -0.1441 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.5961   -3.2568    0.9364 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.0173   -2.1147    1.3824 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.7600   -1.1990    2.1979 N   0  0  0  0  0  0  0  0  0  0  0  0
   -3.6744   -0.3313    1.5176 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.7099   -0.9671    0.8547 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.5554   -0.2658    0.0107 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.0349    0.8822   -0.5610 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.6119    1.3902   -1.6609 F   0  0  0  0  0  0  0  0  0  0  0  0
   -4.0931    1.5864    0.1618 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.6406    3.1647   -0.4615 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -3.3411    0.9512    1.1362 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.8868   -1.7205    0.6754 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.1760   -0.6257    1.1571 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.5376    0.1225    0.2266 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.4679    1.1338    0.6088 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.7953    1.1983    0.0777 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.9126    0.8372   -1.1318 O   0  0  0  0  0  0  0  0  0  0  0  0
    3.9740    1.3297    0.9438 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.2822    2.4899    1.5515 F   0  0  0  0  0  0  0  0  0  0  0  0
    4.8395    0.3287    0.8919 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.2414    0.5391    1.3259 C   0  0  0  0  0  0  0  0  0  0  0  0
    7.1742    0.4127    0.2197 N   0  0  0  0  0  0  0  0  0  0  0  0
    6.5478    0.5774   -1.0650 C   0  0  0  0  0  0  0  0  0  0  0  0
    8.1521    1.4783    0.3749 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  9 10  1  0  0  0  0
  9 19  2  0  0  0  0
 10 11  1  0  0  0  0
 11 12  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 14 16  1  0  0  0  0
 16 17  1  0  0  0  0
 16 18  2  0  0  0  0
 18 11  1  0  0  0  0
 19 20  1  0  0  0  0
 19  5  1  0  0  0  0
 20 21  2  0  0  0  0
 21 22  1  0  0  0  0
 21  3  1  0  0  0  0
 22 23  1  0  0  0  0
 23 24  2  0  0  0  0
 23 25  1  0  0  0  0
 25 26  1  0  0  0  0
 25 27  2  0  0  0  0
 27 28  1  0  0  0  0
 28 29  1  0  0  0  0
 29 30  1  0  0  0  0
 29 31  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000145221410

>  <smiles>
COc1cc2ncnc(Nc3ccc(F)c(Cl)c3)c2cc1NC(=O)/C(F)=C/CN(C)C

$$$$

 OpenBabel10312015333D

 24 26  0  0  0  0  0  0  0  0999 V2000
    5.7773    1.0840   -1.6493 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.2404   -0.1522   -1.2421 O   0  0  0  0  0  0  0  0  0  0  0  0
    4.1128   -0.2949   -0.4570 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.6339    0.7232    0.3590 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.2702    0.8530    0.5551 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.7314    1.9763    1.0869 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.5443    2.4508    0.6388 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.3400    1.5793    0.1313 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.0269    0.3105   -0.1735 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.9390   -0.7373   -0.2536 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3183   -0.3666   -0.2668 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0283   -0.0968    0.8953 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.4002    0.1097    0.8189 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.2749    0.9807    2.0751 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -4.9987   -0.1549   -0.4076 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.7484   -0.0641   -0.4465 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -4.2519   -0.0661   -1.5765 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.8690   -0.0712   -1.4991 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.1373    0.5137   -2.4914 F   0  0  0  0  0  0  0  0  0  0  0  0
    1.3658   -0.0250   -0.0229 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.8504   -1.1704   -0.5899 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.2213   -1.3072   -0.7717 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.7741   -2.5563   -1.0732 O   0  0  0  0  0  0  0  0  0  0  0  0
    3.7573   -3.5184   -0.0468 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  9 10  1  0  0  0  0
  9 20  2  0  0  0  0
 10 11  1  0  0  0  0
 11 12  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  1  0  0  0  0
 13 15  2  0  0  0  0
 15 16  1  0  0  0  0
 15 17  1  0  0  0  0
 17 18  2  0  0  0  0
 18 19  1  0  0  0  0
 18 11  1  0  0  0  0
 20 21  1  0  0  0  0
 20  5  1  0  0  0  0
 21 22  2  0  0  0  0
 22 23  1  0  0  0  0
 22  3  1  0  0  0  0
 23 24  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000000589460

>  <smiles>
COc1cc2ncnc(Nc3cc(Cl)c(Cl)cc3F)c2cc1OC

$$$$

 OpenBabel10312015333D

 27 29  0  0  0  0  0  0  0  0999 V2000
    4.7497    2.3761   -0.0048 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.1798    2.0814    0.0216 N   0  0  0  0  0  0  0  0  0  0  0  0
    6.7453    2.0206   -1.2998 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.3213    0.8202    0.7430 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.1511   -0.0439    0.5024 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.3344   -0.4811    1.4426 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.8969   -0.6102    1.1853 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.0267   -0.2448    2.0323 O   0  0  0  0  0  0  0  0  0  0  0  0
    2.4454   -0.7629   -0.1449 N   0  0  0  0  0  0  0  0  0  0  0  0
    1.1093   -1.0053   -0.5232 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.8533   -1.3973   -1.8315 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.2514   -2.1780   -2.1487 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.2485   -2.2741   -1.1871 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.1125   -3.3117   -1.1423 N   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0390   -3.3664   -0.1546 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.1338   -2.3921    0.7830 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.1761   -1.4385    0.8994 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.4783   -0.1497    1.4513 N   0  0  0  0  0  0  0  0  0  0  0  0
   -3.4410    0.6400    0.7464 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.6640    0.4058   -0.5998 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.8673    1.4281   -1.4989 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.2262    2.6632   -1.0286 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.1218    2.9109    0.3336 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.0584    4.7477    0.8776 Br  0  0  0  0  0  0  0  0  0  0  0  0
   -3.8369    1.8800    1.2123 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.1808   -1.4516   -0.0703 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.0227   -0.8665    0.3056 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  2  4  1  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  7  9  1  0  0  0  0
  9 10  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 12 13  2  0  0  0  0
 13 14  1  0  0  0  0
 14 15  2  0  0  0  0
 15 16  1  0  0  0  0
 16 17  2  0  0  0  0
 17 18  1  0  0  0  0
 17 26  1  0  0  0  0
 18 19  1  0  0  0  0
 19 20  2  0  0  0  0
 20 21  1  0  0  0  0
 21 22  2  0  0  0  0
 22 23  1  0  0  0  0
 23 24  1  0  0  0  0
 23 25  2  0  0  0  0
 25 19  1  0  0  0  0
 26 27  2  0  0  0  0
 26 13  1  0  0  0  0
 27 10  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000001494103

>  <smiles>
CN(C)C/C=C/C(=O)Nc1ccc2ncnc(Nc3cccc(Br)c3)c2c1

$$$$

 OpenBabel10312015333D

 23 25  0  0  0  0  0  0  0  0999 V2000
    4.6612   -0.0288    1.1339 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.3065    0.3709    0.7881 N   0  0  0  0  0  0  0  0  0  0  0  0
    3.0256    1.7864    0.5924 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.2550    2.6230    0.8195 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.3135    3.0877    2.1187 O   0  0  0  0  0  0  0  0  0  0  0  0
    2.4442   -0.6250    0.2250 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.0609   -0.4815    0.2185 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.4215   -1.0713   -0.8636 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.1468   -1.8944   -1.7186 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.4024   -2.3793   -1.3643 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.9224   -1.8008   -0.2527 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.5315   -2.2640   -2.8508 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.7087   -1.7981   -3.1343 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.4854   -1.2791   -2.1528 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.9624   -0.9655   -0.9418 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.7280   -1.0664    0.2637 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.4302    0.0078    0.8451 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.8308   -0.0584    2.1505 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.7766    0.8173    2.6639 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.2018    1.8197    1.8108 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.0476    1.7337    0.4393 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.2870    2.5492   -0.7743 Br  0  0  0  0  0  0  0  0  0  0  0  0
   -3.0332    0.9170   -0.0162 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  2  6  1  0  0  0  0
  3  4  1  0  0  0  0
  4  5  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
  9 12  1  0  0  0  0
 10 11  2  0  0  0  0
 11  6  1  0  0  0  0
 12 13  2  0  0  0  0
 13 14  1  0  0  0  0
 14 15  2  0  0  0  0
 15 16  1  0  0  0  0
 15  8  1  0  0  0  0
 16 17  1  0  0  0  0
 17 18  2  0  0  0  0
 18 19  1  0  0  0  0
 19 20  2  0  0  0  0
 20 21  1  0  0  0  0
 21 22  1  0  0  0  0
 21 23  2  0  0  0  0
 23 17  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000021289062

>  <smiles>
CN(CCO)c1cc2c(Nc3cccc(Br)c3)ncnc2cn1

$$$$

 OpenBabel10312015333D

 33 35  0  0  0  0  0  0  0  0999 V2000
    2.3156   -4.2466    1.1532 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.3555   -3.6898    0.2097 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.9779   -2.4264   -0.2766 O   0  0  0  0  0  0  0  0  0  0  0  0
    1.6331   -2.0908   -0.3184 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.7369   -3.0679   -0.7345 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.5985   -2.8146   -0.4473 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.5033   -3.7853   -0.6897 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.7867   -3.5323   -0.3411 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.2623   -2.2302   -0.2470 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.6560   -1.9675   -0.0355 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.7861   -1.8577   -0.2363 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3691   -1.1667   -0.2000 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.7772    0.0773   -0.7378 N   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0059    1.2443    0.0589 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3868    2.4400   -0.2859 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0632    3.6507   -0.2034 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.3979    3.6938    0.1796 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.1669    4.7568   -0.1206 F   0  0  0  0  0  0  0  0  0  0  0  0
   -4.8987    2.5652    0.8179 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.5346    2.6021    1.4677 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -4.1536    1.3927    0.8287 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.0242   -1.5130   -0.2192 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.1044   -0.5150    0.0114 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.1923   -0.9242    0.2956 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.2059    0.0006    0.6911 N   0  0  0  0  0  0  0  0  0  0  0  0
    3.1023    0.4608   -0.3139 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.6569    0.4940   -1.4895 O   0  0  0  0  0  0  0  0  0  0  0  0
    4.3195    1.2058    0.0200 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.2816    1.3137   -0.8738 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.3310    2.3580   -0.8484 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.9144    2.5076    0.4792 N   0  0  0  0  0  0  0  0  0  0  0  0
    7.7572    1.3404    0.6945 C   0  0  0  0  0  0  0  0  0  0  0  0
    7.6954    3.7243    0.4974 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  1  0  0  0  0
  4  5  2  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
  9 12  1  0  0  0  0
 10 11  3  0  0  0  0
 12 13  1  0  0  0  0
 12 22  2  0  0  0  0
 13 14  1  0  0  0  0
 14 15  2  0  0  0  0
 15 16  1  0  0  0  0
 16 17  2  0  0  0  0
 17 18  1  0  0  0  0
 17 19  1  0  0  0  0
 19 20  1  0  0  0  0
 19 21  2  0  0  0  0
 21 14  1  0  0  0  0
 22 23  1  0  0  0  0
 22  6  1  0  0  0  0
 23 24  2  0  0  0  0
 24 25  1  0  0  0  0
 24  4  1  0  0  0  0
 25 26  1  0  0  0  0
 26 27  2  0  0  0  0
 26 28  1  0  0  0  0
 28 29  2  0  0  0  0
 29 30  1  0  0  0  0
 30 31  1  0  0  0  0
 31 32  1  0  0  0  0
 31 33  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000000602803

>  <smiles>
CCOc1cc2ncc(C#N)c(Nc3ccc(F)c(Cl)c3)c2cc1NC(=O)/C=C/CN(C)C

$$$$

 OpenBabel10312015333D

 30 33  0  0  0  0  0  0  0  0999 V2000
    8.1471   -0.9764    2.0031 C   0  0  0  0  0  0  0  0  0  0  0  0
    7.1358   -0.0414    1.5887 N   0  0  0  0  0  0  0  0  0  0  0  0
    7.3616    0.5266    0.2902 C   0  0  0  0  0  0  0  0  0  0  0  0
    6.6960   -0.2275   -0.8279 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.2739   -0.2891   -0.4942 N   0  0  0  0  0  0  0  0  0  0  0  0
    4.9479    1.0283    0.0492 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.8018    1.6206   -0.7254 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.8509    0.5215   -1.0292 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.1329   -0.4290   -1.8198 O   0  0  0  0  0  0  0  0  0  0  0  0
    1.7412    0.2792   -0.1575 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.5557   -0.3316   -0.6667 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.5009   -0.9440   -1.8991 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.6933   -1.1676   -2.5554 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.8782   -0.7399   -2.0020 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0032   -0.7243   -2.7420 N   0  0  0  0  0  0  0  0  0  0  0  0
   -4.0184    0.1071   -2.4098 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.0832    0.6411   -1.1678 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.9702    0.6872   -0.3968 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.0062    1.1580    0.9551 N   0  0  0  0  0  0  0  0  0  0  0  0
   -4.2681    1.0155    1.6182 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.9931    2.0854    2.0856 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.3711    2.0833    1.9058 C   0  0  0  0  0  0  0  0  0  0  0  0
   -7.0027    0.8540    2.0460 C   0  0  0  0  0  0  0  0  0  0  0  0
   -6.2680   -0.3119    1.8866 C   0  0  0  0  0  0  0  0  0  0  0  0
   -7.1421   -1.9745    1.5159 Br  0  0  0  0  0  0  0  0  0  0  0  0
   -4.9369   -0.1895    1.5088 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.8352    0.0332   -0.8498 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.6509    0.1426   -0.1672 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.1826   -1.2057    0.6410 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.7924   -0.4929    1.8161 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  1  0  0  0  0
  4  5  1  0  0  0  0
  5  6  1  0  0  0  0
  5 29  1  0  0  0  0
  6  7  1  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  8 10  1  0  0  0  0
 10 11  1  0  0  0  0
 11 12  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 17 18  2  0  0  0  0
 18 19  1  0  0  0  0
 18 27  1  0  0  0  0
 19 20  1  0  0  0  0
 20 21  2  0  0  0  0
 21 22  1  0  0  0  0
 22 23  2  0  0  0  0
 23 24  1  0  0  0  0
 24 25  1  0  0  0  0
 24 26  2  0  0  0  0
 26 20  1  0  0  0  0
 27 28  2  0  0  0  0
 27 14  1  0  0  0  0
 28 11  1  0  0  0  0
 29 30  1  0  0  0  0
 30  2  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000084671546

>  <smiles>
CN1CCN(CCC(=O)Nc2ccc3ncnc(Nc4cccc(Br)c4)c3c2)CC1

$$$$

 OpenBabel10312015333D

 25 27  0  0  0  0  0  0  0  0999 V2000
   -4.0041    3.2127   -0.5755 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.5310    1.9209   -0.2812 O   0  0  0  0  0  0  0  0  0  0  0  0
   -3.6795    0.8524    0.0138 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.2726    0.5728    1.3127 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.1985   -0.2917    1.4770 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.0158   -1.0134    2.6056 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.0853   -1.9969    2.6686 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.1397   -2.0258    1.6980 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.3998   -1.5073    0.4752 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.6210   -1.3970   -0.5221 N   0  0  0  0  0  0  0  0  0  0  0  0
    1.5268   -0.2971   -0.3731 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.1326    0.8957    0.2093 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.0211    1.9406    0.3718 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.3822    1.6914    0.3688 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.8147    0.4321   -0.0130 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.2757    0.1352   -0.1323 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.9900    0.8511    0.8211 F   0  0  0  0  0  0  0  0  0  0  0  0
    5.6754    0.4446   -1.4173 F   0  0  0  0  0  0  0  0  0  0  0  0
    5.4320   -1.2204    0.1374 F   0  0  0  0  0  0  0  0  0  0  0  0
    2.8941   -0.5190   -0.4297 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.5373   -0.7478    0.3439 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.0783   -0.6162   -0.9292 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.2876    0.0546   -1.0539 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.2082   -0.2617   -2.0516 O   0  0  0  0  0  0  0  0  0  0  0  0
   -5.3281   -1.1096   -1.8071 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  9 10  1  0  0  0  0
  9 21  2  0  0  0  0
 10 11  1  0  0  0  0
 11 12  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 15 16  1  0  0  0  0
 15 20  2  0  0  0  0
 16 17  1  0  0  0  0
 16 18  1  0  0  0  0
 16 19  1  0  0  0  0
 20 11  1  0  0  0  0
 21 22  1  0  0  0  0
 21  5  1  0  0  0  0
 22 23  2  0  0  0  0
 23 24  1  0  0  0  0
 23  3  1  0  0  0  0
 24 25  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000003815044

>  <smiles>
COc1cc2ncnc(Nc3cccc(C(F)(F)F)c3)c2cc1OC

$$$$

 OpenBabel10312015333D

 22 24  0  0  0  0  0  0  0  0999 V2000
    6.2666    3.4934    0.1019 O   0  0  0  0  0  0  0  0  0  0  0  0
    5.9873    2.1407   -0.0154 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.5449    1.9177   -0.3723 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.8801    0.9881    0.5065 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.8388    0.1241    0.0369 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.3712   -0.8532    0.9068 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.1387   -1.4152    0.6338 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.7986   -2.6549    1.0451 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.2012   -3.3604    0.4641 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.1389   -2.6255   -0.1817 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.7914   -1.4714   -0.8005 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.7911   -0.5807   -1.3086 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.8012   -0.1198   -0.4040 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.6076   -1.0704    0.1954 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.8263   -0.6865    0.6908 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.0059    0.6447    0.9642 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.0144    1.5781    0.7078 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.5075    3.4093    0.9849 Br  0  0  0  0  0  0  0  0  0  0  0  0
   -2.9130    1.2177   -0.0436 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.4754   -0.9794   -0.5098 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.9908    0.0036   -1.3325 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.3060    0.2999   -1.1965 N   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  1  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  7  8  2  0  0  0  0
  8  9  1  0  0  0  0
  9 10  2  0  0  0  0
 10 11  1  0  0  0  0
 11 12  1  0  0  0  0
 11 20  2  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 17 18  1  0  0  0  0
 17 19  2  0  0  0  0
 19 13  1  0  0  0  0
 20 21  1  0  0  0  0
 20  7  1  0  0  0  0
 21 22  2  0  0  0  0
 22  5  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000021289066

>  <smiles>
OCCNc1cc2ncnc(Nc3cccc(Br)c3)c2cn1

$$$$

 OpenBabel10312015333D

 22 24  0  0  0  0  0  0  0  0999 V2000
   -2.6603    4.4138   -0.3620 O   0  0  0  0  0  0  0  0  0  0  0  0
   -3.2902    3.1784   -0.3929 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.2749    2.0718   -0.1417 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.8219    0.7910   -0.5053 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3801   -0.4495    0.0157 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.2663   -1.2195    0.7597 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.7927   -0.4186    1.5973 Br  0  0  0  0  0  0  0  0  0  0  0  0
   -3.1431   -2.6025    0.7042 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.0150   -3.1757    0.1313 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.9876   -2.3309   -0.2525 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.1207   -0.9680   -0.2279 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.0929   -0.0492   -0.5288 N   0  0  0  0  0  0  0  0  0  0  0  0
    1.2557   -0.4377   -0.8149 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.6709   -0.4602   -2.1050 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.8763    0.0141   -2.4861 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.8400    0.3049   -1.5954 N   0  0  0  0  0  0  0  0  0  0  0  0
    3.4927    0.3476   -0.2861 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.5179    0.4049    0.6506 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.1883    0.2378    1.9746 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.8854    0.1824    2.3331 N   0  0  0  0  0  0  0  0  0  0  0  0
    1.8913    0.2353    1.4229 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.2271   -0.0701    0.1091 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  1  0  0  0  0
  3  4  1  0  0  0  0
  4  5  1  0  0  0  0
  5  6  2  0  0  0  0
  6  7  1  0  0  0  0
  6  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 11  5  1  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 17 18  2  0  0  0  0
 18 19  1  0  0  0  0
 19 20  2  0  0  0  0
 20 21  1  0  0  0  0
 21 22  2  0  0  0  0
 22 13  1  0  0  0  0
 22 17  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000029133505

>  <smiles>
OCCNc1c(Br)cccc1Nc1ncnc2ccncc12

$$$$

 OpenBabel10312015333D

 23 25  0  0  0  0  0  0  0  0999 V2000
    6.6343    0.9042    0.5171 C   0  0  0  0  0  0  0  0  0  0  0  0
    5.5330    1.6288    0.6012 C   0  0  0  0  0  0  0  0  0  0  0  0
    4.2484    0.9678    0.3779 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.1827    1.5675    0.7042 O   0  0  0  0  0  0  0  0  0  0  0  0
    4.1637   -0.3139   -0.2534 N   0  0  0  0  0  0  0  0  0  0  0  0
    2.9024   -0.9413   -0.5043 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.1411   -0.6523   -1.6299 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.7588   -0.6418   -1.4861 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.2087   -1.2393   -0.3578 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.9869   -2.0095    0.4969 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.3639   -1.8796    0.3688 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.4137   -3.1021    1.0532 N   0  0  0  0  0  0  0  0  0  0  0  0
   -0.9393   -3.1925    1.0780 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.6610   -2.1361    0.6707 N   0  0  0  0  0  0  0  0  0  0  0  0
   -1.1348   -1.1077   -0.0328 C   0  0  0  0  0  0  0  0  0  0  0  0
   -1.9054   -0.1859   -0.7714 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.9662    0.5863   -0.2500 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.0840   -0.0499    0.2642 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.1567    0.6401    0.7888 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.0236    2.0148    0.8816 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.8437    2.6401    0.5007 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.8087    4.5334    0.7165 Br  0  0  0  0  0  0  0  0  0  0  0  0
   -3.0141    1.9689   -0.3796 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  2  0  0  0  0
  2  3  1  0  0  0  0
  3  4  2  0  0  0  0
  3  5  1  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  7  8  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
 10 11  2  0  0  0  0
 10 12  1  0  0  0  0
 11  6  1  0  0  0  0
 12 13  2  0  0  0  0
 13 14  1  0  0  0  0
 14 15  2  0  0  0  0
 15 16  1  0  0  0  0
 15  9  1  0  0  0  0
 16 17  1  0  0  0  0
 17 18  2  0  0  0  0
 18 19  1  0  0  0  0
 19 20  2  0  0  0  0
 20 21  1  0  0  0  0
 21 22  1  0  0  0  0
 21 23  2  0  0  0  0
 23 17  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000001488274

>  <smiles>
C=CC(=O)Nc1ccc2c(Nc3cccc(Br)c3)ncnc2c1

$$$$

 OpenBabel10312015333D

 19 21  0  0  0  0  0  0  0  0999 V2000
    5.3702   -1.6426   -0.8725 N   0  0  0  0  0  0  0  0  0  0  0  0
    4.1524   -1.3820   -0.1635 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.0276   -2.1475   -0.4399 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.7505   -1.6045   -0.3651 C   0  0  0  0  0  0  0  0  0  0  0  0
    1.5606   -0.2731   -0.0188 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.6641    0.4580    0.3889 C   0  0  0  0  0  0  0  0  0  0  0  0
    3.9285   -0.1131    0.3477 C   0  0  0  0  0  0  0  0  0  0  0  0
    2.5021    1.8033    0.3845 N   0  0  0  0  0  0  0  0  0  0  0  0
    1.4564    2.3985   -0.2356 C   0  0  0  0  0  0  0  0  0  0  0  0
    0.3724    1.6694   -0.5991 N   0  0  0  0  0  0  0  0  0  0  0  0
    0.3566    0.3362   -0.3556 C   0  0  0  0  0  0  0  0  0  0  0  0
   -0.8098   -0.4210   -0.1518 N   0  0  0  0  0  0  0  0  0  0  0  0
   -2.1324    0.0396   -0.2502 C   0  0  0  0  0  0  0  0  0  0  0  0
   -2.3931    1.1926   -0.9536 C   0  0  0  0  0  0  0  0  0  0  0  0
   -3.6762    1.5919   -1.2393 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.7130    0.8309   -0.7464 C   0  0  0  0  0  0  0  0  0  0  0  0
   -4.4713   -0.4400   -0.2641 C   0  0  0  0  0  0  0  0  0  0  0  0
   -5.7846   -1.4160    0.3370 Cl  0  0  0  0  0  0  0  0  0  0  0  0
   -3.1607   -0.8804   -0.1944 C   0  0  0  0  0  0  0  0  0  0  0  0
  1  2  1  0  0  0  0
  2  3  2  0  0  0  0
  3  4  1  0  0  0  0
  4  5  2  0  0  0  0
  5  6  1  0  0  0  0
  6  7  2  0  0  0  0
  6  8  1  0  0  0  0
  7  2  1  0  0  0  0
  8  9  2  0  0  0  0
  9 10  1  0  0  0  0
 10 11  2  0  0  0  0
 11 12  1  0  0  0  0
 11  5  1  0  0  0  0
 12 13  1  0  0  0  0
 13 14  2  0  0  0  0
 14 15  1  0  0  0  0
 15 16  2  0  0  0  0
 16 17  1  0  0  0  0
 17 18  1  0  0  0  0
 17 19  2  0  0  0  0
 19 13  1  0  0  0  0
M  END
>  <zinc_id>
ZINC000003815046

>  <smiles>
Nc1ccc2c(Nc3cccc(Cl)c3)ncnc2c1

$$$$`;
    },
    resetToDefault() {
      this.textarea = null;
      this.file = null;
    }
  },
  created() {
    this.setActive(this.$route.name.toLowerCase());
  }
};
</script>

<style scoped>
header::before {
  background-image: url("../assets/images/molecular-white-background.webp");
}

.compounds .btn {
  margin: 0px 10px;
}

.compounds .btn:first-child {
  margin-left: 0;
}

textarea {
  font-family: "IBMPlexSans Light";
  border: none;
  outline: none;
  background: none;
  background-color: #ffffff;
  -webkit-box-shadow: 4px 4px 10px 0px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 4px 4px 10px 0px rgba(0, 0, 0, 0.3);
  box-shadow: 4px 4px 10px 0px rgba(0, 0, 0, 0.3);
  padding: 20px;
  width: 100%;
  font-size: 1em;
  resize: vertical;
  border-radius: 5px;
}

hr {
  width: 100%;
  margin: 40px 0px;
  border: 1px solid #f1f1f1;
}

.btn-compounds-group {
  text-align: left;
}

.btn-compounds-group .btn:last-child {
  margin: 0px 20px;
}

.molecule-img .img {
  margin: 0 auto;
  width: 40%;
}

.colored {
  color: #ff8a00;
}

.v-input {
  width: 100%;
  margin-left: -30px;
}

@media screen and (max-width: 991px) {
  textarea {
    border: 1px solid #777777;
  }
  .compounds .btn {
    font-size: 0.8em;
    margin: 5px;
    margin-left: 0;
  }
  .compounds .btn:first-child {
    margin: 5px;
    margin-left: 0;
  }
  .btn-compounds-group {
    text-align: center;
  }
  .input-container {
    display: flex;
    flex-direction: column-reverse;
  }
  .v-input {
    width: 90%;
    margin-left: 0px;
  }
}
</style>

<style>
.v-input__slot {
  color: #582e91;
}
.v-application .primary--text {
  color: #582e91 !important;
  caret-color: #582e91 !important;
}
</style>
